import React from "react";
import ReactDOM from "react-dom/client";
    const { useState, useEffect, useRef } = React;

    /* ─── Palette ─── */
    const C = {
      navy:"#0D2B45", navyL:"#122F4A", navyD:"#091E30",
      amber:"#B87830", gold:"#C9A870", cream:"#F5F0E8",
      muted:"#7A9CB5", mutedL:"#9BBAD1",
      success:"#4CAF82", error:"#E05A5A",
    };

    const FONTS_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&family=DM+Sans:wght@400;500;600;700&display=swap');
*{box-sizing:border-box;margin:0;padding:0;font-family:'Inter',sans-serif}
h1,h2,h3,h4{font-family:'DM Sans',sans-serif}
::-webkit-scrollbar{width:5px}::-webkit-scrollbar-track{background:#091E30}::-webkit-scrollbar-thumb{background:#B8783060;border-radius:3px}
textarea:focus,input:focus,select:focus{border-color:#B87830!important;outline:none}
button:hover{filter:brightness(1.08)}
@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}
@keyframes borderSpin{from{--border-angle:0deg}to{--border-angle:360deg}}
@property --border-angle{syntax:"<angle>";initial-value:0deg;inherits:false}
.loader-border{border:2px solid #B8783050;border-radius:16px;position:absolute;inset:-2px;pointer-events:none;z-index:1}
.loader-glow{animation:borderSpin 2.5s linear infinite;background:conic-gradient(from var(--border-angle),transparent 0deg,transparent 160deg,#D4A44A 180deg,transparent 200deg,transparent 360deg) border-box;border:2px solid transparent;mask:linear-gradient(#000 0 0) padding-box,linear-gradient(#000 0 0);mask-composite:exclude;-webkit-mask:linear-gradient(#000 0 0) padding-box,linear-gradient(#000 0 0);-webkit-mask-composite:xor;border-radius:16px;position:absolute;inset:-2px;pointer-events:none;z-index:2}

/* ═══════ RESPONSIVE MOBILE ═══════ */
@media(max-width:640px){
  .po-home-grid{grid-template-columns:1fr!important}
  .po-lib-layout{flex-direction:column!important}
  .po-lib-sidebar{width:100%!important;position:static!important;border-right:none!important}
  .po-sidebar-toggle{display:block!important}
  .po-sidebar-content{display:none!important}
  .po-sidebar-content.open{display:block!important}
  .po-lib-grid{grid-template-columns:1fr!important}
  .po-header{padding:10px 14px!important}
  .po-header-title{font-size:18px!important}
  .po-header-sub{display:none!important}
  .po-main{padding:20px 12px 60px!important}
  .po-modal-body{max-width:95vw!important;max-height:92vh!important}
  .po-modal-inner{padding:14px 16px!important}
  .po-loader-box{padding:24px 20px!important;max-width:300px!important}
  .po-tabs{overflow-x:auto;-webkit-overflow-scrolling:touch}
  .po-tabs button{min-width:0!important;padding:8px 4px!important;font-size:11px!important}
  .po-step-label{display:none!important}
  .po-step-circle{width:28px!important;height:28px!important;font-size:12px!important}
  .po-debug{max-height:150px!important}
  .po-hero-title{font-size:22px!important}
}
@media(max-width:380px){
  .po-header-title{font-size:16px!important}
  .po-main{padding:16px 8px 50px!important}
}
    `;

    /* ─── Styles partagés ─── */
    const bdgS = t => {
      const MAP = {
        Thinking:{bg:"#9B59B618",color:"#C39BD3",border:"#9B59B640"},
        Agent:   {bg:"#20B2AA18",color:"#4ECDC4",border:"#20B2AA40"},
        Image:   {bg:"#4285F418",color:"#7BAAF7",border:"#4285F440"},
        Pro:     {bg:"#E8A83018",color:"#F0C060",border:"#E8A83040"},
      };
      const bc = MAP[t] || {bg:`${C.amber}20`,color:C.gold,border:`${C.amber}40`};
      return {background:bc.bg,color:bc.color,border:`1px solid ${bc.border}`,borderRadius:"4px",padding:"2px 7px",fontSize:"11px",fontWeight:"600"};
    };
    const inpS  = (ex={}) => ({width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 15px",color:C.cream,fontSize:"15px",lineHeight:"1.7",...ex});
    const btnS  = (p,d,ex={}) => ({background:p?`linear-gradient(135deg,${C.amber},${C.gold})`:"transparent",color:p?C.navyD:C.amber,border:p?"none":`2px solid ${C.amber}80`,borderRadius:"9px",padding:p?"13px 28px":"10px 20px",fontWeight:"700",fontSize:"15px",cursor:d?"not-allowed":"pointer",opacity:d?.5:1,transition:"all 0.2s",...ex});
    const labelS = {display:"block",fontSize:"12px",fontWeight:"700",color:C.amber,textTransform:"uppercase",letterSpacing:"1.2px",marginBottom:"10px"};

    /* ─── TASK_LABELS ─── */
    const TASK_LABELS = {redaction:"Rédaction",analyse:"Analyse",code:"Code",recherche:"Recherche",image:"Image",raisonnement:"Raisonnement",transformation:"Transformation"};

    /* ─── Markdown renderer ─── */
    const inlineMd = text => {
      const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*|`[^`]+`)/g);
      return parts.map((p,i) => {
        if(p.startsWith("**")&&p.endsWith("**")) return <strong key={i} style={{color:C.gold,fontWeight:"700"}}>{p.slice(2,-2)}</strong>;
        if(p.startsWith("*") &&p.endsWith("*"))  return <em key={i} style={{color:C.mutedL,fontStyle:"italic"}}>{p.slice(1,-1)}</em>;
        if(p.startsWith("`") &&p.endsWith("`"))  return <code key={i} style={{background:`${C.amber}18`,color:C.gold,borderRadius:"3px",padding:"1px 5px",fontSize:"13px",fontFamily:"monospace"}}>{p.slice(1,-1)}</code>;
        return p;
      });
    };
    const renderMd = text => {
      if(!text) return null;
      return text.split("\n").map((line,i) => {
        if(!line.trim()) return <div key={i} style={{height:"10px"}}/>;
        if(line.startsWith("## ")) return <h2 key={i} style={{fontSize:"16px",fontWeight:"700",color:C.gold,fontFamily:"'DM Sans',sans-serif",margin:"16px 0 6px"}}>{line.slice(3)}</h2>;
        if(line.startsWith("### ")) return <h3 key={i} style={{fontSize:"14px",fontWeight:"700",color:C.amber,margin:"12px 0 4px"}}>{line.slice(4)}</h3>;
        if(line.startsWith("# ")) return <h1 key={i} style={{fontSize:"18px",fontWeight:"700",color:C.gold,fontFamily:"'DM Sans',sans-serif",margin:"0 0 10px"}}>{line.slice(2)}</h1>;
        if(line.startsWith("> ")) return <blockquote key={i} style={{borderLeft:`3px solid ${C.amber}`,paddingLeft:"12px",margin:"8px 0",color:C.mutedL,fontSize:"14px",fontStyle:"italic"}}>{inlineMd(line.slice(2))}</blockquote>;
        if(/^[-*] /.test(line)) return <div key={i} style={{display:"flex",gap:"8px",margin:"3px 0",paddingLeft:"4px"}}><span style={{color:C.amber,marginTop:"2px",flexShrink:0}}>·</span><span style={{fontSize:"14px",lineHeight:"1.7",color:C.cream}}>{inlineMd(line.slice(2))}</span></div>;
        const m = line.match(/^(\d+)\. (.*)/);
        if(m) return <div key={i} style={{display:"flex",gap:"8px",margin:"3px 0",paddingLeft:"4px"}}><span style={{color:C.amber,flexShrink:0,minWidth:"18px",fontSize:"13px",marginTop:"2px"}}>{m[1]}.</span><span style={{fontSize:"14px",lineHeight:"1.7",color:C.cream}}>{inlineMd(m[2])}</span></div>;
        return <p key={i} style={{fontSize:"14px",lineHeight:"1.75",color:C.cream,margin:"4px 0"}}>{inlineMd(line)}</p>;
      });
    };

    /* ─── Loader ─── */
    const LOADER_MSGS = {
      analyze:   ["Lecture de ta demande…","Détection du type de tâche…","Consultation de la matrice de scoring…","Sélection des meilleurs modèles…"],
      questions: ["Chargement des connaissances du modèle…","Analyse des spécificités de la plateforme…","Formulation des questions…"],
      generate:  ["Injection du socle universel…","Application du module de tâche…","Chargement de la fiche plateforme…","Application du snippet de mode…","Génération du prompt…","Structuration en Markdown…","Vérification de la complétude…"],
      autoall:   ["Analyse du contexte…","Génération des réponses…"],
    };
    const LoaderOverlay = ({ phase, onCancel, status }) => {
      const [idx, setIdx]   = useState(0);
      const [fade, setFade] = useState(true);
      const [elapsed, setElapsed] = useState(0);
      const msgs = LOADER_MSGS[phase] || ["Traitement en cours…"];
      useEffect(() => {
        const t = setInterval(() => {
          setFade(false);
          setTimeout(() => { setIdx(i => (i+1) % msgs.length); setFade(true); }, 300);
        }, 2500);
        return () => clearInterval(t);
      }, [msgs.length]);
      useEffect(() => {
        setElapsed(0);
        const t = setInterval(() => setElapsed(s => s+1), 1000);
        return () => clearInterval(t);
      }, [phase]);
      const titles = {analyze:"Analyse de ta demande",questions:"Préparation des questions",generate:"Génération du prompt",autoall:"Auto-réponses"};
      return (
        <div style={{position:"fixed",inset:0,background:"#0D2B45CC",backdropFilter:"blur(4px)",zIndex:50,display:"flex",alignItems:"center",justifyContent:"center"}}>
          <div className="po-loader-box" style={{background:C.navyL,borderRadius:"16px",padding:"36px 48px",maxWidth:"360px",width:"90%",textAlign:"center",position:"relative"}}>
            <div className="loader-border"/>
            <div className="loader-glow"/>
            <div style={{position:"relative",width:"56px",height:"56px",margin:"0 auto 24px",zIndex:3}}>
              <svg viewBox="0 0 56 56" width="56" height="56">
                <circle cx="28" cy="28" r="24" fill="none" stroke={`${C.amber}25`} strokeWidth="2"/>
                <text x="28" y="33" textAnchor="middle" fontSize="18" fill={C.amber}>✦</text>
              </svg>
            </div>
            <div style={{fontSize:"15px",fontWeight:"700",fontFamily:"'DM Sans',sans-serif",color:C.gold,marginBottom:"12px"}}>{titles[phase]||"Traitement"}</div>
            <div style={{fontSize:"13px",color:C.muted,lineHeight:"1.6",minHeight:"42px",transition:"opacity 0.3s",opacity:fade?1:0}}>{msgs[idx]}</div>
            {status && <div style={{fontSize:"12px",color:C.muted,marginTop:"12px"}}>{status}</div>}
            <div style={{fontSize:"11px",color:`${C.muted}80`,marginTop:"6px"}}>{elapsed}s</div>
            <div style={{display:"flex",justifyContent:"center",gap:"6px",marginTop:"14px"}}>
              {msgs.map((_,i) => <div key={i} style={{width:"6px",height:"6px",borderRadius:"50%",background:i===idx?C.amber:`${C.amber}30`,transition:"background 0.3s"}}/>)}
            </div>
            {onCancel && <button onClick={onCancel} style={{marginTop:"18px",background:"transparent",border:`1px solid ${C.amber}40`,borderRadius:"8px",padding:"7px 18px",color:C.muted,fontSize:"13px",cursor:"pointer"}}>Annuler</button>}
          </div>
        </div>
      );
    };

    /* ─── Modal wrapper ─── */
    const Modal = ({ title, icon, onClose, children }) => (
      <div style={{position:"fixed",inset:0,background:"#000B",zIndex:100,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:"6vh",padding:"6vh 16px 16px"}}>
        <div className="po-modal-body" style={{background:C.navyL,border:`1px solid ${C.amber}40`,borderRadius:"14px",width:"100%",maxWidth:"540px",maxHeight:"88vh",overflow:"hidden",display:"flex",flexDirection:"column"}}>
          <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"15px 20px",borderBottom:`1px solid ${C.amber}20`}}>
            <div style={{display:"flex",alignItems:"center",gap:"9px"}}>
              <span style={{fontSize:"17px"}}>{icon}</span>
              <span style={{fontSize:"16px",fontWeight:"700",fontFamily:"'DM Sans',sans-serif",color:C.gold}}>{title}</span>
            </div>
            <button onClick={onClose} style={{background:"transparent",border:"none",color:C.muted,fontSize:"18px",cursor:"pointer",padding:"2px 8px"}}>✕</button>
          </div>
          <div className="po-modal-inner" style={{overflowY:"auto",padding:"18px 20px",flex:1}}>{children}</div>
        </div>
      </div>
    );

    /* ─── Modale de confirmation ─── */
    const ConfirmModal = ({ message, onConfirm, onCancel }) => (
      <div style={{position:"fixed",inset:0,background:"#000D",zIndex:200,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:"20vh",padding:"20vh 16px 16px"}}>
        <div style={{background:C.navyL,border:`1px solid ${C.error}50`,borderRadius:"14px",width:"100%",maxWidth:"400px",padding:"24px 22px"}}>
          <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"16px"}}>
            <span style={{fontSize:"20px"}}>⚠️</span>
            <span style={{fontSize:"15px",fontWeight:"700",fontFamily:"'DM Sans',sans-serif",color:C.cream}}>Confirmation</span>
          </div>
          <p style={{fontSize:"14px",color:C.muted,lineHeight:"1.7",marginBottom:"20px"}}>{message}</p>
          <div style={{display:"flex",gap:"9px",justifyContent:"flex-end"}}>
            <button onClick={onCancel} style={{background:"transparent",border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"9px 18px",color:C.muted,fontSize:"13px",fontWeight:"600",cursor:"pointer"}}>Annuler</button>
            <button onClick={onConfirm} style={{background:`${C.error}20`,border:`1px solid ${C.error}50`,borderRadius:"8px",padding:"9px 18px",color:C.error,fontSize:"13px",fontWeight:"700",cursor:"pointer"}}>Supprimer</button>
          </div>
        </div>
      </div>
    );

    /* ─── Panneau Paramètres unifié (4 onglets) ─── */
    /* ─── Comptes mémorisés (bascule multi-comptes) ─── */
    const ACCOUNTS_KEY = "po:accounts";
    const loadAccounts = () => {
      try { return JSON.parse(localStorage.getItem(ACCOUNTS_KEY)) || []; } catch { return []; }
    };
    const saveAccounts = (list) => localStorage.setItem(ACCOUNTS_KEY, JSON.stringify(list));
    const rememberAccount = (token, user) => {
      const list = loadAccounts().filter(a => a.id !== user.id);
      saveAccounts([...list, { id: user.id, email: user.email, username: user.username, token }]);
    };
    const forgetAccount = (userId) => saveAccounts(loadAccounts().filter(a => a.id !== userId));
    const switchAccount = (account) => {
      localStorage.setItem("po:token", account.token);
      window.location.href = "/";
    };
    const addAccount = () => {
      localStorage.removeItem("po:token");
      window.location.href = "/";
    };

    const SettingsModal = ({ onClose, /* API */ apiProvider, apiKey, apiModel, setApiProvider, setApiKey, setApiModel, allProviders, /* Contexte */ ctxDraft, setCtxDraft, setCtx, /* Modèles */ enabled, setEnabled, platforms, /* Debug */ showDebug, setShowDebug, /* Backup */ onExport, onImport, lastBackup, initialTab, /* Compte */ currentUser, onLogout }) => {
      const TABS = [
        {id:"api", label:"Connexion API", icon:"🔌"},
        {id:"ctx", label:"Mon contexte", icon:"👤"},
        {id:"models", label:"Mes modèles", icon:"⚙️"},
        {id:"backup", label:"Sauvegarde", icon:"💾"},
        {id:"debug", label:"Debug", icon:"🛠"},
        {id:"account", label:"Compte", icon:"🔒"},
      ];
      const [tab, setTab] = useState(initialTab || "api");

      /* ── état local API ── */
      const [locProv,  setLocProv]  = useState(apiProvider);
      const [locKey,   setLocKey]   = useState(apiKey);
      const [locModel, setLocModel] = useState(apiModel || "");
      const handleProvChange = (newProv) => {
        const saved = (allProviders || {})[newProv] || {};
        setLocProv(newProv);
        setLocModel(saved.model || "");
        setLocKey(saved.key || "");
      };

      /* ── état local Modèles ── */
      const [locEnabled, setLocEnabled] = useState({...enabled});

      /* ── état local Contexte ── */
      const [locCtx, setLocCtx] = useState(ctxDraft);

      /* ── état local Debug ── */
      const [locDebug, setLocDebug] = useState(showDebug);

      const toggleAll = (pid, v) => { const pl = platforms.find(p=>p.id===pid); const u = {...locEnabled}; pl.models.forEach(m => { u[m.id]=v; }); setLocEnabled(u); };
      const cnt = pid => platforms.find(p=>p.id===pid).models.filter(m=>locEnabled[m.id]!==false).length;

      const prov = API_PROVIDERS.find(p => p.id === locProv) || API_PROVIDERS[0];
      const effectiveModel = (locModel && prov.models.find(m => m.id === locModel)) ? locModel : (prov.models[0]?.id || "");
      const canSaveApi = locKey.trim().length >= 10;

      const saveAll = () => {
        setApiProvider(locProv); setApiKey(locKey.trim()); setApiModel(effectiveModel);
        setCtxDraft(locCtx); setCtx(locCtx);
        setEnabled(locEnabled);
        setShowDebug(locDebug);
        onClose();
      };

      const tabStyle = (id) => ({
        flex:1, padding:"10px 6px", fontSize:"12px", fontWeight:tab===id?"700":"500",
        color:tab===id?C.gold:C.muted, background:tab===id?`${C.amber}15`:"transparent",
        border:"none", borderBottom:tab===id?`2px solid ${C.amber}`:`2px solid transparent`,
        cursor:"pointer", transition:"all 0.2s", textAlign:"center", lineHeight:"1.3",
      });

      return (
        <Modal title="Paramètres" icon="⚙️" onClose={onClose}>
          {/* Onglets */}
          <div className="po-tabs" style={{display:"flex",gap:0,marginBottom:"20px",borderBottom:`1px solid ${C.amber}20`}}>
            {TABS.map(t => (
              <button key={t.id} onClick={() => setTab(t.id)} style={tabStyle(t.id)}>
                <span style={{display:"block",fontSize:"15px",marginBottom:"3px"}}>{t.icon}</span>{t.label}
              </button>
            ))}
          </div>

          {/* ── Onglet API ── */}
          {tab === "api" && (
            <div>
              <p style={{fontSize:"13px",color:C.muted,marginBottom:"16px",lineHeight:"1.7"}}>
                Choisis le fournisseur d'API et le modèle utilisé pour générer les prompts. Ta clé est stockée localement et n'est jamais partagée.
              </p>
              <div style={{marginBottom:"18px"}}>
                <div style={labelS}>Fournisseur</div>
                {API_PROVIDERS.map(p => (
                  <label key={p.id} onClick={() => handleProvChange(p.id)} style={{display:"flex",alignItems:"center",gap:"10px",padding:"10px 12px",borderRadius:"8px",cursor:"pointer",marginBottom:"4px",background:locProv===p.id?`${C.amber}15`:"transparent",border:`1px solid ${locProv===p.id?C.amber+"40":C.amber+"15"}`}}>
                    <div style={{width:"16px",height:"16px",borderRadius:"50%",border:`2px solid ${locProv===p.id?C.amber:C.muted}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {locProv===p.id && <div style={{width:"8px",height:"8px",borderRadius:"50%",background:C.amber}}/>}
                    </div>
                    <div>
                      <div style={{fontSize:"14px",fontWeight:"600",color:locProv===p.id?C.cream:C.muted}}>{p.name}</div>
                      <div style={{fontSize:"11px",color:C.muted,marginTop:"2px"}}>Clé API → {p.hint}</div>
                    </div>
                  </label>
                ))}
              </div>
              <div style={{marginBottom:"18px"}}>
                <div style={labelS}>Modèle pour l'optimiseur <span style={{fontWeight:"400",fontSize:"10px",color:C.muted,marginLeft:"6px"}}>Prix : entrée / sortie par million de tokens</span></div>
                {prov.models.map(m => (
                  <label key={m.id} onClick={() => setLocModel(m.id)} style={{display:"flex",alignItems:"center",gap:"10px",padding:"9px 12px",borderRadius:"8px",cursor:"pointer",marginBottom:"4px",background:effectiveModel===m.id?`${C.amber}15`:"transparent",border:`1px solid ${effectiveModel===m.id?C.amber+"40":C.amber+"15"}`}}>
                    <div style={{width:"16px",height:"16px",borderRadius:"50%",border:`2px solid ${effectiveModel===m.id?C.amber:C.muted}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      {effectiveModel===m.id && <div style={{width:"8px",height:"8px",borderRadius:"50%",background:C.amber}}/>}
                    </div>
                    <div>
                      <div style={{fontSize:"13px",color:effectiveModel===m.id?C.cream:C.muted,fontWeight:effectiveModel===m.id?"600":"400"}}>{m.name}</div>
                      <div style={{fontSize:"11px",color:C.muted,marginTop:"1px"}}>{m.desc}</div>
                    </div>
                  </label>
                ))}
              </div>
              <div style={{marginBottom:"8px"}}>
                <div style={labelS}>Clé API {prov.name}</div>
                <input type="password" value={locKey} onChange={e => setLocKey(e.target.value)}
                  placeholder={`Colle ta clé ${prov.name} ici…`}
                  style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 15px",color:C.cream,fontSize:"14px",fontFamily:"monospace"}}
                />
                <p style={{fontSize:"11px",color:C.muted,marginTop:"6px"}}>Stockée localement dans ton navigateur, envoyée uniquement aux serveurs du fournisseur choisi. Pense à exporter tes données (onglet Sauvegardes) pour les emporter.</p>
              </div>
            </div>
          )}

          {/* ── Onglet Contexte ── */}
          {tab === "ctx" && (
            <div>
              <p style={{fontSize:"13px",color:C.muted,marginBottom:"12px",lineHeight:"1.7"}}>Décris ton contexte personnel ou professionnel. Ces informations enrichissent les recommandations et les prompts générés.</p>
              <div style={{fontSize:"13px",color:C.muted,marginBottom:"14px",lineHeight:"1.7",background:C.navyD,borderRadius:"8px",padding:"11px 13px"}}>Exemples : métier, niveau en IA, cas d'usage principaux, public cible, langue de travail, contraintes spécifiques.</div>
              <textarea style={inpS({minHeight:"150px",resize:"vertical"})}
                placeholder="Ex : Je suis chef de projet dans une startup tech. J'utilise l'IA pour rédiger des specs et analyser des données. Je travaille en français."
                value={locCtx} onChange={e => setLocCtx(e.target.value)}
              />
            </div>
          )}

          {/* ── Onglet Modèles ── */}
          {tab === "models" && (
            <div>
              <p style={{fontSize:"13px",color:C.muted,marginBottom:"16px",lineHeight:"1.6"}}>Coche uniquement les modèles auxquels tu as accès. L'IA ne conseillera que ceux-ci.</p>
              {platforms.map(pl => (
                <div key={pl.id} style={{marginBottom:"16px"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"8px"}}>
                    <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                      <span style={{color:pl.color,fontSize:"15px"}}>{pl.logo}</span>
                      <span style={{fontSize:"14px",fontWeight:"700",fontFamily:"'DM Sans',sans-serif",color:C.gold}}>{pl.name}</span>
                      <span style={{fontSize:"11px",color:C.muted}}>{cnt(pl.id)}/{pl.models.length}</span>
                    </div>
                    <div style={{display:"flex",gap:"5px"}}>
                      <button onClick={()=>toggleAll(pl.id,true)}  style={btnS(false,false,{padding:"4px 10px",fontSize:"11px"})}>Tout</button>
                      <button onClick={()=>toggleAll(pl.id,false)} style={btnS(false,false,{padding:"4px 10px",fontSize:"11px"})}>Aucun</button>
                    </div>
                  </div>
                  <div style={{paddingLeft:"6px"}}>
                    {pl.models.map(m => (
                      <label key={m.id} style={{display:"flex",alignItems:"center",gap:"10px",padding:"7px 10px",borderRadius:"7px",cursor:"pointer",marginBottom:"3px",background:locEnabled[m.id]!==false?`${pl.color}10`:"transparent"}}>
                        <input type="checkbox" checked={locEnabled[m.id]!==false} onChange={e=>setLocEnabled(p=>({...p,[m.id]:e.target.checked}))} style={{accentColor:C.amber,width:"15px",height:"15px",cursor:"pointer"}}/>
                        <div style={{flex:1,display:"flex",alignItems:"center",gap:"8px"}}>
                          <span style={{fontSize:"13px",color:locEnabled[m.id]!==false?C.cream:C.muted}}>{m.name}</span>
                          {m.badge&&<span style={bdgS(m.badge)}>{m.badge}</span>}
                          <span style={{fontSize:"11px",color:C.muted}}>{m.desc}</span>
                        </div>
                      </label>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ── Onglet Sauvegardes ── */}
          {tab === "backup" && (
            <div>
              {/* ── Sauvegarde ── */}
              <div style={{marginBottom:"24px"}}>
                <div style={{fontSize:"14px",fontWeight:"700",color:C.gold,marginBottom:"10px"}}>Sauvegarder</div>
                <p style={{fontSize:"13px",color:C.muted,marginBottom:"14px",lineHeight:"1.7"}}>
                  Télécharge un fichier JSON contenant toutes tes données : configuration API, contexte, modèles activés, prompts et catégories.
                </p>
                {lastBackup && (
                  <div style={{fontSize:"12px",color:C.muted,marginBottom:"14px",background:C.navyD,borderRadius:"8px",padding:"10px 14px"}}>
                    Dernière sauvegarde : <strong style={{color:C.cream}}>{new Date(lastBackup).toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric",hour:"2-digit",minute:"2-digit"})}</strong>
                  </div>
                )}
                <button onClick={onExport} style={btnS(true,false,{fontSize:"14px",padding:"12px 22px",width:"100%"})}>Télécharger la sauvegarde</button>
              </div>

              {/* ── Restauration ── */}
              <div style={{borderTop:`1px solid ${C.amber}20`,paddingTop:"20px"}}>
                <div style={{fontSize:"14px",fontWeight:"700",color:C.gold,marginBottom:"10px"}}>Restaurer</div>
                <p style={{fontSize:"13px",color:C.muted,marginBottom:"14px",lineHeight:"1.7"}}>
                  Importe un fichier de sauvegarde pour restaurer tes données en cas de changement de serveur, de crash ou de migration.
                </p>
                <button onClick={onImport} style={btnS(false,false,{fontSize:"14px",padding:"12px 22px",width:"100%"})}>Importer une sauvegarde</button>
              </div>
            </div>
          )}

          {/* ── Onglet Debug ── */}
          {tab === "debug" && (
            <div>
              <p style={{fontSize:"13px",color:C.muted,marginBottom:"16px",lineHeight:"1.7"}}>Active le panneau de debug pour voir les appels API, les tokens consommés et les erreurs détaillées.</p>
              <label style={{display:"flex",alignItems:"center",gap:"12px",padding:"14px 16px",borderRadius:"10px",cursor:"pointer",background:locDebug?`${C.amber}15`:"transparent",border:`1px solid ${locDebug?C.amber+"40":C.amber+"20"}`}}>
                <div onClick={() => setLocDebug(d=>!d)} style={{width:"44px",height:"24px",borderRadius:"12px",background:locDebug?C.amber:`${C.muted}40`,position:"relative",cursor:"pointer",transition:"background 0.3s",flexShrink:0}}>
                  <div style={{width:"20px",height:"20px",borderRadius:"50%",background:C.cream,position:"absolute",top:"2px",left:locDebug?"22px":"2px",transition:"left 0.3s",boxShadow:"0 1px 3px #0004"}}/>
                </div>
                <div>
                  <div style={{fontSize:"14px",fontWeight:"600",color:locDebug?C.gold:C.muted}}>Panneau debug {locDebug?"actif":"inactif"}</div>
                  <div style={{fontSize:"11px",color:C.muted,marginTop:"2px"}}>Affiche les logs API en bas de page</div>
                </div>
              </label>
            </div>
          )}

          {/* ── Onglet Compte ── */}
          {tab === "account" && (
            <div>
              {currentUser && (
                <div style={{marginBottom:"20px"}}>
                  <div style={{background:C.navyD,borderRadius:"10px",padding:"16px 18px",border:`1px solid ${C.amber}20`,marginBottom:"18px"}}>
                    <div style={{fontSize:"14px",fontWeight:"700",color:C.gold,marginBottom:"8px"}}>{currentUser.username}</div>
                    <div style={{fontSize:"12px",color:C.muted}}>{currentUser.email}</div>
                    {currentUser.is_admin && <span style={{display:"inline-block",marginTop:"8px",fontSize:"11px",fontWeight:"700",color:C.amber,background:`${C.amber}18`,border:`1px solid ${C.amber}40`,borderRadius:"6px",padding:"3px 10px"}}>Administrateur</span>}
                  </div>
                  {currentUser.is_admin && (
                    <a href="/admin.html" style={{display:"flex",alignItems:"center",gap:"10px",padding:"14px 16px",borderRadius:"10px",textDecoration:"none",background:`${C.amber}12`,border:`1px solid ${C.amber}30`,marginBottom:"12px",cursor:"pointer",transition:"background 0.2s"}}>
                      <span style={{fontSize:"18px"}}>🛡️</span>
                      <div>
                        <div style={{fontSize:"14px",fontWeight:"600",color:C.gold}}>Administration</div>
                        <div style={{fontSize:"11px",color:C.muted,marginTop:"2px"}}>Gérer les utilisateurs et les paramètres</div>
                      </div>
                    </a>
                  )}
                  {/* ── Bascule entre comptes ── */}
                  <div style={{marginBottom:"12px"}}>
                    <div style={{fontSize:"12px",fontWeight:"700",color:C.muted,textTransform:"uppercase",letterSpacing:"0.5px",marginBottom:"8px"}}>Mes comptes</div>
                    {loadAccounts().map(acc => {
                      const isCurrent = acc.id === currentUser.id;
                      return (
                        <div key={acc.id} style={{display:"flex",alignItems:"center",gap:"8px",padding:"10px 12px",borderRadius:"10px",marginBottom:"6px",background:isCurrent?`${C.amber}12`:C.navyD,border:`1px solid ${isCurrent?C.amber+"40":C.amber+"18"}`}}>
                          <div onClick={() => { if (!isCurrent) switchAccount(acc); }} style={{flex:1,cursor:isCurrent?"default":"pointer",minWidth:0}}>
                            <div style={{fontSize:"13px",fontWeight:"600",color:isCurrent?C.gold:C.cream,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{acc.username}</div>
                            <div style={{fontSize:"11px",color:C.muted,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{acc.email}</div>
                          </div>
                          {isCurrent
                            ? <span style={{fontSize:"11px",fontWeight:"700",color:C.amber}}>Actif</span>
                            : <>
                                <span onClick={() => switchAccount(acc)} style={{fontSize:"11px",fontWeight:"700",color:C.amber,cursor:"pointer"}}>Basculer</span>
                                <span onClick={() => { forgetAccount(acc.id); onClose(); }} title="Oublier ce compte" style={{fontSize:"14px",color:C.muted,cursor:"pointer"}}>×</span>
                              </>}
                        </div>
                      );
                    })}
                    <button onClick={addAccount} style={{width:"100%",padding:"11px",borderRadius:"10px",border:`1px dashed ${C.amber}40`,background:"transparent",color:C.amber,fontSize:"13px",fontWeight:"600",cursor:"pointer",marginTop:"4px"}}>+ Ajouter un compte</button>
                  </div>
                  <button onClick={onLogout} style={{width:"100%",padding:"12px",borderRadius:"10px",border:`1px solid ${C.error}40`,background:`${C.error}12`,color:C.error,fontSize:"14px",fontWeight:"600",cursor:"pointer",marginTop:"6px"}}>Déconnexion</button>
                </div>
              )}
            </div>
          )}

          {/* Boutons */}
          <div style={{borderTop:`1px solid ${C.amber}20`,paddingTop:"14px",marginTop:"18px",display:"flex",gap:"9px",justifyContent:"flex-end"}}>
            <button style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})} onClick={onClose}>Annuler</button>
            <button style={btnS(true,false,{fontSize:"13px",padding:"9px 18px"})} onClick={saveAll}>Enregistrer</button>
          </div>
        </Modal>
      );
    };

    /* ─── API Providers avec sélection de modèle ─── */
    const API_PROVIDERS = [
      {
        id:"claude", name:"Claude (Anthropic)", needsKey:true,
        hint:"console.anthropic.com",
        models:[
          {id:"claude-haiku-4-5-20251001", name:"Haiku 4.5 — Rapide (Recommandé)", desc:"1$ / 5$ · Rapide, économique, idéal pour l'optimiseur", price:"1 / 5"},
          {id:"claude-sonnet-4-6",          name:"Sonnet 4.6 — Équilibré",          desc:"3$ / 15$ · Excellent en code, rédaction et analyse", price:"3 / 15"},
          {id:"claude-opus-4-6",            name:"Opus 4.6 — Premium",              desc:"5$ / 25$ · Raisonnement complexe, tâches multi-étapes", price:"5 / 25"},
        ]
      },
      {
        id:"openai", name:"OpenAI", needsKey:true,
        hint:"platform.openai.com",
        models:[
          {id:"gpt-5.4-nano",  name:"GPT-5.4 nano — Rapide (Recommandé)", desc:"0.20$ / 1.25$ · Ultra-rapide, économique, tâches simples", price:"0.20 / 1.25"},
          {id:"gpt-5.4-mini",  name:"GPT-5.4 mini — Équilibré",           desc:"0.75$ / 4.50$ · Bon rapport qualité/prix, polyvalent", price:"0.75 / 4.50"},
          {id:"gpt-5.4",       name:"GPT-5.4 — Flagship",                 desc:"2.50$ / 15$ · Dernier modèle phare, rédaction et code", price:"2.50 / 15"},
          {id:"gpt-4.1",       name:"GPT-4.1 — Code & Instruction",       desc:"2$ / 8$ · Suivi d'instructions précis, code", price:"2 / 8"},
          {id:"gpt-4.1-nano",  name:"GPT-4.1 nano — Ultra-économique",    desc:"0.10$ / 0.40$ · Le moins cher du marché", price:"0.10 / 0.40"},
          {id:"gpt-4o-mini",   name:"GPT-4o mini — Ancien économique",    desc:"0.15$ / 0.60$ · Rapide, encore très utilisé", price:"0.15 / 0.60"},
          {id:"o3",             name:"o3 — Raisonnement avancé",            desc:"2$ / 8$ · Raisonnement profond, maths, logique", price:"2 / 8"},
          {id:"o4-mini",        name:"o4-mini — Raisonnement économique",   desc:"1.10$ / 4.40$ · Raisonnement à bon prix", price:"1.10 / 4.40"},
        ]
      },
      {
        id:"gemini", name:"Gemini (Google)", needsKey:true,
        hint:"aistudio.google.com (free tier disponible)",
        models:[
          {id:"gemini-3.1-flash-lite-preview", name:"3.1 Flash-Lite — Rapide (Recommandé)", desc:"0.25$ / 1.50$ · Gratuit, dernier modèle économique", price:"0.25 / 1.50"},
          {id:"gemini-3-flash-preview",        name:"3 Flash — Équilibré",                  desc:"0.50$ / 3$ · Gratuit, rivalise avec les grands modèles", price:"0.50 / 3"},
          {id:"gemini-3.1-pro-preview",        name:"3.1 Pro — Premium",                    desc:"2$ / 12$ · Le plus avancé, raisonnement et code", price:"2 / 12"},
          {id:"gemini-2.5-flash",              name:"2.5 Flash — Ancien rapide",             desc:"0.30$ / 2.50$ · Gratuit, encore très utilisé", price:"0.30 / 2.50"},
          {id:"gemini-2.5-pro",                name:"2.5 Pro — Ancien puissant",             desc:"1.25$ / 10$ · Gratuit, 1M tokens contexte", price:"1.25 / 10"},
        ]
      },
      {
        id:"mistral", name:"Mistral AI", needsKey:true,
        hint:"console.mistral.ai (hébergé en Europe)",
        models:[
          {id:"mistral-small-2603",     name:"Small 4 — Rapide (Recommandé)",     desc:"0.15$ / 0.60$ · Rapide, vision + raisonnement + code", price:"0.15 / 0.60"},
          {id:"mistral-medium-latest",  name:"Medium 3.1 — Équilibré",            desc:"0.40$ / 2$ · Bon compromis, performances classe GPT-4", price:"0.40 / 2"},
          {id:"mistral-large-latest",   name:"Large 3 — Premium",                 desc:"0.50$ / 1.50$ · Le plus puissant, multilingue, code", price:"0.50 / 1.50"},
          {id:"magistral-medium-2509",  name:"Magistral Medium — Raisonnement",   desc:"2$ / 5$ · Raisonnement multi-étapes, logique avancée", price:"2 / 5"},
        ]
      },
    ];

    const PROV_DEFAULT_MODEL = {
      claude: "claude-haiku-4-5-20251001",
      openai: "gpt-5.4-nano",
      gemini: "gemini-3.1-flash-lite-preview",
      mistral: "mistral-small-2603",
    };

    const PROV_LABELS = { claude:"Claude", openai:"OpenAI", gemini:"Gemini", mistral:"Mistral" };

    /* ─── LibEditModal (ajout/modification de prompt bibliothèque) ─── */
    const LibEditModal = ({ initial, onSave, onClose, allModels, categories, enabledModels, onAnalyze, onAddCategory }) => {
      const isNew = !initial;
      const availableModels = allModels.filter(m => m.cat === "text" && enabledModels[m.id] !== false);
      const [title, setTitle]       = useState(initial?.title || "");
      const [category, setCategory] = useState(initial?.category || "challenge");
      const [analyzing, setAnalyzing] = useState(false);
      const [showNewCat, setShowNewCat] = useState(false);
      const [newCatName, setNewCatName] = useState("");
      const [newCatIcon, setNewCatIcon] = useState("📌");
      const [newCatColor, setNewCatColor] = useState("#27AE60");
      const [desc, setDesc]         = useState(initial?.description || "");
      const [body, setBody]         = useState(initial?.prompt || "");
      const initModel = initial?.model || "c_opust";
      const [modelId, setModelId]   = useState(availableModels.find(m=>m.id===initModel) ? initModel : (availableModels[0]?.id||""));

      const extractVars = (text) => {
        const matches = text.match(/\{([A-Z_]+)\}/g) || [];
        return [...new Set(matches.map(m => m.slice(1,-1)))];
      };

      const canSave = title.trim() && body.trim();

      return (
        <Modal title={isNew ? "Ajouter un prompt" : "Modifier le prompt"} icon="📝" onClose={onClose}>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Titre</div>
            <input type="text" value={title} onChange={e => setTitle(e.target.value)}
              placeholder="Ex : Le Contradicteur"
              style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 14px",color:C.cream,fontSize:"14px"}}
            />
          </div>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Catégorie</div>
            <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
              <span style={{fontSize:"20px"}}>{categories.find(c=>c.id===category)?.icon||"📌"}</span>
              <select value={category} onChange={e => setCategory(e.target.value)}
                style={{flex:1,background:C.navyD,border:`1px solid ${(categories.find(c=>c.id===category)?.color||C.amber)}40`,borderRadius:"8px",padding:"10px 14px",color:C.cream,fontSize:"14px",cursor:"pointer"}}>
                {categories.map(cat => (
                  <option key={cat.id} value={cat.id}>{cat.icon} {cat.label}</option>
                ))}
              </select>
              <button onClick={() => setShowNewCat(s=>!s)} title="Nouvelle catégorie"
                style={{background:showNewCat?`${C.amber}20`:"transparent",border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"9px 12px",cursor:"pointer",color:showNewCat?C.gold:C.muted,fontSize:"14px",lineHeight:1,flexShrink:0}}>+</button>
            </div>
            {showNewCat && (
              <div style={{marginTop:"10px",background:C.navyD,borderRadius:"8px",padding:"12px",border:`1px solid ${C.amber}20`}}>
                <div style={{display:"flex",gap:"8px",alignItems:"center",flexWrap:"wrap"}}>
                  <input type="text" value={newCatIcon} onChange={e=>setNewCatIcon(e.target.value)} style={{width:"44px",background:`${C.navy}80`,border:`1px solid ${C.amber}20`,borderRadius:"6px",padding:"6px",color:C.cream,fontSize:"18px",textAlign:"center"}}/>
                  <input type="text" value={newCatName} onChange={e=>setNewCatName(e.target.value)} placeholder="Nom de la catégorie"
                    style={{flex:1,minWidth:"120px",background:`${C.navy}80`,border:`1px solid ${C.amber}20`,borderRadius:"6px",padding:"8px 10px",color:C.cream,fontSize:"13px"}}/>
                  <input type="color" value={newCatColor} onChange={e=>setNewCatColor(e.target.value)} style={{width:"36px",height:"36px",border:"none",cursor:"pointer",background:"transparent",flexShrink:0}}/>
                  <button disabled={!newCatName.trim()} onClick={() => {
                    const newCat = onAddCategory(newCatName.trim(), newCatIcon.trim()||"📌", newCatColor);
                    if (newCat) setCategory(newCat);
                    setShowNewCat(false); setNewCatName(""); setNewCatIcon("📌"); setNewCatColor("#27AE60");
                  }} style={btnS(true,!newCatName.trim(),{fontSize:"12px",padding:"7px 14px"})}>Créer</button>
                </div>
              </div>
            )}
          </div>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Description courte</div>
            <input type="text" value={desc} onChange={e => setDesc(e.target.value)}
              placeholder="En une phrase, à quoi sert ce prompt"
              style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 14px",color:C.cream,fontSize:"14px"}}
            />
          </div>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Prompt</div>
            <p style={{fontSize:"11px",color:C.muted,marginBottom:"6px"}}>Utilise {"{NOM_VARIABLE}"} pour les parties que l'utilisateur remplacera (ex : {"{SUJET}"}, {"{DOMAINE}"}).</p>
            <textarea value={body} onChange={e => setBody(e.target.value)}
              placeholder="Écris ton prompt ici..."
              style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 14px",color:C.cream,fontSize:"13px",fontFamily:"monospace",minHeight:"160px",resize:"vertical",lineHeight:"1.6"}}
            />
            {extractVars(body).length > 0 && (
              <div style={{marginTop:"6px",fontSize:"11px",color:C.amber}}>Variables détectées : {extractVars(body).map(v => `{${v}}`).join(", ")}</div>
            )}
          </div>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Modèle recommandé</div>
            <div style={{display:"flex",gap:"10px",alignItems:"center"}}>
              <select value={modelId} onChange={e => setModelId(e.target.value)}
                style={{flex:1,background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 14px",color:C.cream,fontSize:"14px"}}>
                {availableModels.map(m => (
                  <option key={m.id} value={m.id}>{m.name} ({m.platform})</option>
                ))}
              </select>
              <button
                style={btnS(false,analyzing||!body.trim(),{fontSize:"12px",padding:"10px 14px",whiteSpace:"nowrap"})}
                disabled={analyzing||!body.trim()}
                onClick={async () => {
                  setAnalyzing(true);
                  try {
                    const bestId = await onAnalyze(body, availableModels);
                    if (bestId && availableModels.find(m => m.id === bestId)) setModelId(bestId);
                  } catch(_) {}
                  setAnalyzing(false);
                }}
              >{analyzing ? "Analyse…" : "Suggérer le modèle"}</button>
            </div>
            {!availableModels.find(m => m.id === modelId) && modelId && (
              <p style={{fontSize:"11px",color:C.error,marginTop:"6px"}}>Le modèle actuel n'est plus dans tes modèles disponibles. Choisis-en un autre ou modifie tes paramètres.</p>
            )}
          </div>
          <div style={{borderTop:`1px solid ${C.amber}20`,paddingTop:"14px",display:"flex",gap:"9px",justifyContent:"flex-end"}}>
            <button style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})} onClick={onClose}>Annuler</button>
            <button style={btnS(true,!canSave,{fontSize:"13px",padding:"9px 18px"})} disabled={!canSave}
              onClick={() => onSave({ ...(initial||{}), title:title.trim(), category, description:desc.trim(), prompt:body, model:modelId, variables:extractVars(body) })}
            >{isNew ? "Ajouter" : "Enregistrer"}</button>
          </div>
        </Modal>
      );
    };

    /* ─── AddCategoryModal ─── */
    const AddCategoryModal = ({ onAdd, onClose }) => {
      const [name, setName]   = useState("");
      const [icon, setIcon]   = useState("📌");
      const [color, setColor] = useState("#27AE60");
      return (
        <Modal title="Nouvelle catégorie" icon="🏷" onClose={onClose}>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Nom</div>
            <input type="text" value={name} onChange={e => setName(e.target.value)}
              placeholder="Ex : Productivité"
              style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 14px",color:C.cream,fontSize:"14px"}}
            />
          </div>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Icône (emoji)</div>
            <input type="text" value={icon} onChange={e => setIcon(e.target.value)}
              placeholder="Ex : ⚡"
              style={{width:"60px",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 14px",color:C.cream,fontSize:"18px",textAlign:"center"}}
            />
          </div>
          <div style={{marginBottom:"14px"}}>
            <div style={labelS}>Couleur</div>
            <input type="color" value={color} onChange={e => setColor(e.target.value)}
              style={{width:"50px",height:"36px",border:"none",cursor:"pointer",background:"transparent"}}
            />
          </div>
          <div style={{borderTop:`1px solid ${C.amber}20`,paddingTop:"14px",display:"flex",gap:"9px",justifyContent:"flex-end"}}>
            <button style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})} onClick={onClose}>Annuler</button>
            <button style={btnS(true,!name.trim(),{fontSize:"13px",padding:"9px 18px"})} disabled={!name.trim()}
              onClick={() => onAdd(name.trim(), icon.trim() || "📌", color)}
            >Ajouter</button>
          </div>
        </Modal>
      );
    };

    /* (ApiConfigModal supprimé — fusionné dans SettingsModal) */

    /* ══════════════════════════════════════════════
       COUCHE 1 — SOCLE UNIVERSEL
    ══════════════════════════════════════════════ */
    const SOCLE_UNIVERSEL = `# Socle universel — Prompt Optimizer

## Composants d'un prompt efficace (ordre recommandé)
1. Objectif — ce que l'utilisateur veut obtenir concrètement
2. Contexte — situation, rôle, public cible, domaine
3. Tâche — action précise à réaliser
4. Données fournies — documents, exemples, références à exploiter
5. Format de sortie — structure, longueur, style, langue
6. Contraintes — interdits, limites, règles à respecter
7. Critères de réussite — comment vérifier que le résultat est bon

## Champs minimaux selon la complexité
- Simple : objectif + format
- Standard : objectif + contexte + tâche + format + contraintes
- Complexe : les 7 composants + exemples + vérification

## Règles de composition
- Une instruction = une action.
- Consignes positives : "Écris en prose fluide" plutôt que "N'utilise pas de listes".
- Documents EN PREMIER, instructions EN DERNIER.
- Délimiteurs XML pour séparer les blocs (<context>, <task>, <constraints>, <output_format>).
- Si exemples : 2-3 maximum, le dernier est le plus influent.

## Deux paradigmes

STANDARD : instructions explicites, few-shot 2-3 exemples, chain-of-thought si raisonnement.

RAISONNEMENT (thinking) : objectif de haut niveau + critères — PAS d'étapes prescriptives. ZÉRO exemples. NE PAS demander "réfléchis étape par étape". Vérification : "Avant de conclure, vérifie contre [critères]".

## Règles par type de tâche
- Rédaction : public cible + ton + longueur + structure
- Analyse : données + critères d'évaluation + format de synthèse
- Code : langage + environnement + comportement + cas limites
- Recherche : question précise + périmètre + sources + format rapport
- Image : sujet en premier → medium → éclairage → atmosphère → paramètres
- Raisonnement : problème complet + hypothèses + contraintes + critères validation
- Transformation : source + format cible + règles conversion + quoi préserver

## Garde-fous universels
1. Ne jamais inventer de données non fournies.
2. Signaler les ambiguïtés plutôt que deviner.
3. Respecter la langue de la demande (sauf image : anglais).
4. Ne pas sur-spécifier le format pour les tâches de raisonnement.
5. Pour la recherche : exiger la vérification croisée des sources.

## Hiérarchie de priorité
1. Objectif réel de l'utilisateur
2. Contraintes de sortie explicites
3. Exigences du type de tâche
4. Règles du modèle cible
5. Préférences de style`;

    /* ══════════════════════════════════════════════
       COUCHE 2 — MODULES DE TÂCHE
    ══════════════════════════════════════════════ */
    const MODULES_TACHE = {
    redaction:`# MODULE — RÉDACTION
## Champs prioritaires
1. Public cible — qui va lire ce texte
2. Ton et voix — formel/informel, voix de marque
3. Longueur cible — mots, paragraphes, pages
4. Structure — article, newsletter, page de vente, post, email
5. Intention — informer, convaincre, inspirer, vendre, éduquer
## Format de sortie par défaut
Prose structurée en sections avec sous-titres.
## Garde-fous
- Demander le niveau de langage si non précisé.
- Si "mon ton" mentionné sans description : demander un échantillon.
- Contenu marketing : inclure un appel à l'action.`,

    analyse:`# MODULE — ANALYSE
## Champs prioritaires
1. Données fournies — sources, documents à analyser
2. Critères d'évaluation — axes (coût, qualité, risque…)
3. Format de synthèse — tableau, rapport, résumé exécutif
4. Profondeur — survol ou analyse détaillée
## Format de sortie par défaut
Résumé exécutif → analyse par critère → conclusion avec recommandation.
## Garde-fous
- Exiger une conclusion tranchée, pas un résumé neutre.
- Demander des chiffres si données quantitatives attendues.
- Signaler les limites et données manquantes.`,

    code:`# MODULE — CODE
## Champs prioritaires
1. Langage et environnement — langage, framework, version
2. Comportement attendu — description fonctionnelle
3. Cas limites — erreurs à gérer, conditions aux bornes
4. Contexte d'intégration — fichier existant, nouveau projet
## Format de sortie par défaut
Code commenté + explication courte avant le bloc.
## Garde-fous
- Spécifier si complet/exécutable ou extrait.
- Pour Opus : ajouter "Ne crée que ce qui est demandé."
- Pour bug : fournir code existant + comportement observé + attendu.`,

    recherche:`# MODULE — RECHERCHE
## Champs prioritaires
1. Question de recherche — précise, pas un sujet ouvert
2. Périmètre — temporel, géographique, disciplinaire
3. Types de sources — académiques, officielles, spécialisées
4. Format du livrable — rapport, tableau, synthèse
5. Exigences de citation — citer chaque affirmation
## Format de sortie par défaut
Rapport structuré avec citations. Résumé exécutif en ouverture.
## Garde-fous
- Inclure ce que l'utilisateur sait déjà.
- Signaler les contradictions entre sources.
- Limiter à 3-5 dimensions max.`,

    image:`# MODULE — IMAGE
## Champs prioritaires
1. Sujet principal — en premier, le plus pondéré
2. Style / medium — photo, illustration, peinture, 3D
3. Éclairage et atmosphère
4. Composition — plan large, gros plan, plongée
5. Paramètres techniques — ratio, stylisation, références
## Format de sortie par défaut
Prompt descriptif en anglais, 30-80 mots. Paramètres à la fin.
## Garde-fous
- Toujours en anglais.
- PAS de "4k, masterpiece, highly detailed".
- Texte lisible dans l'image → Gemini Image, guillemets.`,

    raisonnement:`# MODULE — RAISONNEMENT
## Champs prioritaires
1. Problème complet — toutes les données, sans ambiguïté
2. Hypothèses autorisées
3. Contraintes — limites, règles, conditions
4. Critères de validation
## Format de sortie par défaut
Reformulation → raisonnement → conclusion → vérification.
## Garde-fous
- Ne pas prescrire les étapes si mode thinking.
- Exiger vérification explicite.
- Demander au moins 2 approches pour les problèmes multi-solutions.`,

    transformation:`# MODULE — TRANSFORMATION
## Champs prioritaires
1. Source fournie — contenu à transformer
2. Format cible — autre format, registre, longueur, langue
3. Règles de conversion — ce qui change et comment
4. Éléments à préserver — ce qui NE change PAS
## Format de sortie par défaut
Contenu transformé directement, sans préambule.
## Garde-fous
- Toujours spécifier ce qui doit être préservé.
- Simplification : préciser le niveau de lecture cible.
- Traduction : littérale ou adaptation culturelle.`,
    };

    /* ══════════════════════════════════════════════
       COUCHE 3 — FICHES PLATEFORME
    ══════════════════════════════════════════════ */
    const FICHES_PLATEFORME = {
    claude:`# Fiche — CLAUDE (claude.ai)
## Architecture et comportement
- **Sonnet 4.6** : exécuteur littéral — prend les instructions au pied de la lettre, infère peu. Idéal quand les instructions sont claires et complètes.
- **Opus 4.6** : "senior collaborator" — adaptive thinking auto-engagé sur les requêtes complexes. Tendances à gérer : sur-ingénierie, sur-délégation, actions irréversibles. 3× plus coûteux que Sonnet. [DOCUMENTÉ — Anthropic]
- **Research** : architecture multi-agent (Opus lead + Sonnet subagents). 3-5 sous-tâches parallèles. Fenêtre 200K tokens. Coût ~15× le chat standard. Pas de correction possible en cours d'exécution. Artefacts Markdown en sortie. [DOCUMENTÉ — Anthropic Engineering Blog]
## Format optimal
- **XML natif** : <context>, <task>, <constraints>, <output_format>, <examples> — Claude a un parsing XML intégré, c'est son format le plus performant. [DOCUMENTÉ — Anthropic]
- Données EN PREMIER, instructions EN DERNIER (~30% d'amélioration sur tâches longues). [DOCUMENTÉ]
- Multi-sources : wrapper chaque document dans <document><source>nom</source><document_content>contenu</document_content></document>.
- Nested data : YAML > XML > JSON pour les structures imbriquées.
## Techniques clés
- TECH-006 (Research) : Exploiter la fenêtre 200K — injecter des documents de contexte (~15K tokens) comme base de référence pour les mises à jour/vérifications.
- TECH-007 (Research) : Décomposition explicite en 3-5 dimensions principales, laisser l'agent gérer les sous-questions.
- TECH-011 (Research) : Itération post-rapport — les follow-ups séquentiels sont plus efficaces que les mega-prompts. Chaîne de recherche en 3 couches recommandée.
- TECH-014 (Research) : Anticiper les clarifications — pré-répondre aux questions probables pour éviter le flou en cours d'exécution.
- Paramètre effort (Sonnet) : low/medium/high/max — affecte la profondeur de raisonnement et l'utilisation d'outils.
## Forces
- Prose naturelle en français : la plus fluide et naturelle du marché, unanimement reconnue. [DOCUMENTÉ — Arena]
- Suivi d'instructions complexes multiples.
- Code : meilleur en compréhension d'intention vague (SWE-bench 80.8%). [DOCUMENTÉ]
- Consignes positives fortement préférées : "Écris en prose fluide" plutôt que "N'utilise pas de listes".
## Éviter
- Tâches temps réel (pas d'accès web en mode standard/thinking).
- Tableurs/modélisation financière → GPT-5.4 Pro.
- JSON comme format de sortie principal → Markdown + XML.
## Garde-fous
- Résultat long attendu : le spécifier explicitement (Sonnet est plus concis que ses prédécesseurs).
- Research : investir dans la qualité du prompt initial — le budget de recherche est consommé quoi qu'il arrive.
- Opus : ajouter "Ne crée que ce qui est demandé" pour éviter la sur-ingénierie.`,

    chatgpt:`# Fiche — CHATGPT (chatgpt.com)
## Architecture et comportement
- **GPT-5.4 Pro** : "senior collaborator" — fournir objectifs + critères, laisser le modèle déterminer les étapes. Sur-prompting documenté comme contre-productif. ~80% moins d'erreurs factuelles qu'o3. [DOCUMENTÉ — OpenAI]
- **GPT-5.4 Thinking** : mode raisonnement étendu avec reasoning_effort (none/low/medium/high/xhigh) comme dernier levier de réglage.
- **Deep Research** : pipeline 3 étapes — modèle intermédiaire (gpt-4.1) clarifie → réécriture enrichie du prompt → agent o3 spécialisé exécute la recherche. Phase de clarification interactive. 5-30 min d'exécution. Interruption possible depuis février 2026. [DOCUMENTÉ — OpenAI]
- Quota DR : Pro (250/mois), Plus (25/mois), Free (5/mois, o4-mini allégé).
## Format optimal
- **Markdown** : titres, listes, gras — 34-38% plus efficace en tokens que JSON/XML. [DOCUMENTÉ — benchmarks]
- Rôle/persona en ouverture : "Tu es un [rôle] spécialisé en [domaine]." Améliore le style/ton (pas la précision factuelle). [DOCUMENTÉ — Wharton Report]
- GPT-5.4 Pro : contrats de sortie XML (<output_contract>, <verbosity_controls>) pour structurer les attentes. Markdown désactivé par défaut en API. [DOCUMENTÉ — OpenAI]
- Verbes d'action en début : "Compare", "Recommande", "Analyse".
- Format de sortie très explicite : nombre de sections, longueur, type.
## Techniques clés
- TECH-001 (DR) : Les mots-clés du prompt deviennent des signaux de recherche directs — vocabulaire expert = meilleures sources.
- TECH-006 (DR) : Recherche guidée par hypothèses — fournir 3 hypothèses concurrentes + métriques force une exploration équilibrée au lieu du biais de confirmation. [DOCUMENTÉ — OpenAI]
- TECH-007 (DR) : Injection de connaissances préalables — "Je sais déjà X, j'ai besoin d'investiguer Y" réduit le gaspillage de recherche.
- TECH-010 (DR) : Itération séquentielle — "Développe la section 3", "Ajoute 2 sources sur le point 5" exploitent le contexte de recherche. "As-tu oublié quelque chose ?" déclenche une reconsidération.
- TECH-008 (DR) : Clause fail-fast citations — "Cite chaque affirmation ou marque [NON VÉRIFIÉ]". Ne JAMAIS demander d'URLs.
## Forces
- Analyse professionnelle, modélisation financière, tableurs.
- Rédaction technique formelle, rapports structurés.
- Outils natifs : computer-use, code interpreter, recherche web.
- Deep Research : agent le plus mature, rapports les plus complets du marché.
## Éviter
- Prose littéraire ou créative — ton "explainer" caractéristique, peut paraître traduit en français.
- Prompts contradictoires (dégrade fortement, plus sensible que Claude).
## Garde-fous
- Surconfiance documentée : TOUJOURS ajouter "Signale tes incertitudes et les limites de ton analyse".
- DR : ne pas répondre vaguement aux questions de clarification — "fais comme tu veux" → résultat générique.
- DR : plafond de ~1 300 caractères observé pour le prompt initial (non confirmé officiellement). [OBSERVÉ]`,

    gemini:`# Fiche — GEMINI (gemini.google.com)
## Architecture et comportement
- **Gemini 3.1 Pro** : fenêtre 2M tokens (la plus grande du marché). Design "haute efficacité et action" — réponses concises par défaut. Thinking levels recalibrés : MEDIUM en 3.1 ≈ HIGH en 3.0. [DOCUMENTÉ — Google]
- **Deep Research** : processus 4 phases — Planification → Recherche → Raisonnement → Rapport. ~80 requêtes web/tâche standard, ~160 pour tâches complexes. 5-10 min typique (web), jusqu'à 60 min (API). [DOCUMENTÉ — Google]
- Le plan de recherche est **éditable avant exécution** — c'est le levier le plus sous-utilisé. Modifier le plan auto-généré (supprimer axes, repondérer, ajouter sources) améliore significativement le résultat. [DOCUMENTÉ — blog.google]
- Intégration Google Workspace optionnelle (Gmail, Drive, Chat) — active uniquement avec scope précis.
- Knowledge cutoff janvier 2025 ; données temps réel via recherche web uniquement.
## Format optimal
- Instructions APRÈS les données. Contraintes négatives EN DERNIER.
- NE JAMAIS mélanger XML et Markdown dans un même prompt — choisir l'un ou l'autre.
- Pour les longs contextes : instructions après les données, contraintes en dernier.
- Concis par défaut : demander explicitement un résultat détaillé si souhaité.
- "Utilise uniquement le contexte fourni" si fidélité aux données critique.
## Techniques clés
- TECH-006 (DR) : Stratégie à deux voies — (1) prompt détaillé OU (2) prompt simple + modification du plan auto-généré. Les deux fonctionnent, le choix dépend du contexte.
- TECH-007 (DR) : Modification du plan avant exécution — supprimer les axes non pertinents, repondérer les priorités, ajouter des sources spécifiques. C'est le plus gros levier qualité.
- TECH-008 (DR) : Injection de fichiers — jusqu'à 1 500 pages (~10 fichiers max) comme base de vérification.
- TECH-010 (DR) : Exploitation du thinking_level (MINIMAL/LOW/MEDIUM/HIGH) — contrôle le budget de raisonnement. Recalibré en 3.1 Pro.
- TECH-013 (DR) : Itération post-rapport — "développe la section X", "ajoute 2 sources", "vérifie ce point" exploitent le contexte de recherche antérieur.
- Fenêtre 2M tokens : permet de transformer/analyser de très longs documents en une seule passe.
## Forces
- Raisonnement scientifique et abstrait : GPQA 94.3%, le meilleur du marché. [DOCUMENTÉ]
- Rédaction structurée et factuelle (Arena Creative Writing #1). [DOCUMENTÉ]
- Transformation de longs documents (seul modèle capable en une passe grâce aux 2M tokens).
- DR : intégration native Google Workspace — optimal si les sources sont dans l'écosystème Google.
## Éviter
- Prose émotionnelle ou littéraire — style moins naturel en prose libre, surtout en français.
- Contraintes négatives trop larges.
- Sur-structurer les prompts pour Flash — les prompts sur-engineerés le confondent.
## Garde-fous
- Température FIXÉE à 1.0 — baisser provoque boucles et dégradation. C'est contre-intuitif mais documenté. [DOCUMENTÉ — Google DeepMind]
- DR : le plan modifié et le prompt initial ne doivent pas se contredire — sinon rapport incohérent.
- Canvas/visuels interactifs disponibles uniquement en Ultra ; audio overview disponible tous niveaux.`,

    perplexity:`# Fiche — PERPLEXITY (perplexity.ai)
## REMPLACE le socle universel — Perplexity fonctionne DIFFÉREMMENT des autres plateformes.
## Architecture et comportement
- Pipeline 5 étapes autonome : Décomposition → Recherche ciblée → Synthèse partielle → Vérification croisée → Synthèse narrative finale. [DOCUMENTÉ — System Card]
- 20-50 recherches web ciblées par session, 100-200+ sources consultées, 3-5 boucles de raisonnement séquentielles.
- Le system prompt n'influence PAS la phase de recherche web — il n'affecte que la mise en forme finale du rapport. C'est fondamental. [DOCUMENTÉ — architecture pipeline]
- Fenêtre 128K tokens. API max 10 étapes (interface agentique).
- Taux d'hallucination des citations ~13% documenté dans le System Card. [DOCUMENTÉ]
- Le système tend à considérer les domaines .edu comme "académiques" indépendamment de la qualité réelle du contenu. [OBSERVÉ — Aaron Tay]
## CE QUI NE FONCTIONNE PAS sur Perplexity (différences critiques)
- PAS de persona/rôle — ignoré par le pipeline de recherche, gaspillage de tokens.
- PAS d'exemples few-shot — inutile, le modèle ne les utilise pas pour orienter ses recherches.
- PAS de chain-of-thought explicite — le pipeline a son propre raisonnement interne en 5 étapes.
- PAS d'URLs spécifiques demandées — hallucination garantie.
## Structure optimale du prompt
Objectif de recherche (1 phrase précise) → Périmètre (temporel, géographique, disciplinaire) → Contexte déjà connu ("Je sais que X, j'ai besoin de Y") → Questions de recherche (3-5 dimensions) → Format de sortie attendu.
## Techniques clés
- TECH-001 : Termes précis (noms de marques, vocabulaire technique, noms de produits) = signaux de recherche directs. Vocabulaire vague → résultats SEO génériques.
- TECH-005 : Injection de connaissances préalables — "Je sais déjà que X ; investiguer Y" réduit drastiquement le gaspillage de budget de recherche.
- TECH-007 : Chaîne de recherche en 3 couches — (1) requête panoramique (exploration) → (2) requête comparative (structuration) → (3) deep dive (approfondissement). 3-5 prompts séquentiels. [DOCUMENTÉ — praticiens]
- TECH-009 : Recherche guidée par hypothèses — fournir des hypothèses concurrentes + evidence/counter-evidence = exploration équilibrée.
- TECH-012 : Restriction de domaines via search_domain_filter (API) — limiter à .edu, .org, ou domaines spécifiques pour les recherches spécialisées.
- Clause fail-fast : "Cite chaque affirmation ou marque [NON VÉRIFIÉ]".
## Forces
- Le plus rapide : 2-5 min vs 5-30 pour ChatGPT DR.
- Le mieux sourcé avec citations inline auto-générées.
- Itération efficace dans le thread (les follow-ups réutilisent le contexte de recherche).
- Budget API pay-per-search disponible.
## Éviter
- Questions simples / lookups factuels — gaspille des crédits + 2-5 min d'attente.
- Sujets derrière paywall académique — pas d'accès aux bases de données académiques payantes.
- Focus "Social" pour recherche professionnelle — restreint aux réseaux sociaux.
## Garde-fous
- TOUJOURS vérifier les citations manuellement — 13% d'hallucination documenté.
- Pas de compréhension sémantique de l'autorité des sources au-delà du filtrage par domaine.
- Pré-rédiger le prompt avec un autre modèle (GPT-4o) est recommandé pour les recherches complexes : "Écris un prompt Deep Research optimisé pour [sujet]". [OBSERVÉ — workflow optimal]`,

    midjourney:`# Fiche — MIDJOURNEY V7 (midjourney.com)
## REMPLACE le socle universel — Midjourney a un paradigme complètement différent.
## Architecture et comportement
- V7 (défaut depuis juin 2025) : changement de paradigme — du keyword-tagging au brief photographique en langage naturel. [DOCUMENTÉ — Midjourney]
- Le modèle comprend les descriptions en langage naturel, les métaphores, les références culturelles.
- Toujours EN ANGLAIS — le modèle est entraîné en anglais.
## Structure du prompt
Sujet (le plus pondéré, en premier) → Medium (photo, illustration, peinture, 3D) → Environnement → Éclairage (impact disproportionné sur la qualité) → Palette de couleurs → Mood/atmosphère → Composition (plan, angle) → Détails.
## Paramètres essentiels
- --ar [ratio] : rapport d'aspect (16:9, 3:2, 1:1, 9:16...)
- --s [0-1000] (stylize) : contrôle l'esthétisation. ADAPTER selon le cas :
  - Photoréaliste : --s 50-100
  - Éditorial/mode : --s 150-250
  - Artistique/créatif : --s 400-750
  - Expérimental : --s 800-1000
- --chaos [0-100] : contrôle la variation entre les résultats
- --style raw : désactive l'esthétisation par défaut, plus fidèle au prompt
- --draft : 10× plus rapide, 50% moins cher — UTILISER pour l'itération, finaliser sans
- --no [element] : exclure un élément (remplace les negative prompts classiques)
- --oref [URL] : Omni Reference — remplace le deprecated --cref pour la cohérence de personnage
- --sref [URL] : Style Reference — copier le style d'une image de référence
## Techniques clés
- Langage de brief photographique : "shot on Hasselblad", "editorial lighting", "golden hour side light" — plus efficace que les descriptions techniques.
- Pondération négative : element::-1 pour réduire un élément (plus fiable que --no pour les ajustements fins).
- Direction d'éclairage : spécifier le type (softbox 3 points, lumière naturelle, rim light) a un impact disproportionné sur la qualité finale.
- Matérialité et textures : spécifier les matériaux (marble, brushed steel, raw silk) enrichit considérablement le rendu.
## Forces
- Qualité esthétique inégalée pour la direction artistique et créative.
- Contrôle fin via les paramètres --stylize et --chaos.
- Workflow itératif efficace avec --draft.
- Meilleur pour : images artistiques, éditorial, mode, conceptuel.
## Éviter
- Texte lisible dans l'image → utiliser Gemini Image (Nano Banana Pro).
- Mots-clés "4k, masterpiece, highly detailed, trending on artstation" → contre-productifs en V7.
- Balises XML, listes à puces, structures techniques → langage naturel uniquement.
## Garde-fous
- SFW uniquement. Personnalisation activée par défaut.
- Longueur : 30-80 mots hors paramètres.`,

    gemini_image:`# Fiche — GEMINI IMAGE / Nano Banana Pro (gemini.google.com)
## REMPLACE le socle universel — Gemini Image a ses propres frameworks.
## Architecture et comportement
- Nom officiel : Gemini 3 Pro Image. API model ID : gemini-3-pro-image-preview. [DOCUMENTÉ — Google DeepMind]
- Mode Thinking disponible : raisonnement étendu sur les prompts complexes (pensées cachées influençant le résultat).
- Search Grounding : vérification factuelle en temps réel via Google Search avant génération.
- Filigrane SynthID (imperceptible) + C2PA Content Credentials sur toutes les images. [DOCUMENTÉ]
- Résolutions : 1K, 2K, 4K. Ratios : 1:1, 3:2, 2:3, 3:4, 4:3, 4:5, 5:4, 9:16, 16:9, 21:9.
- Jusqu'à 14 images de référence simultanées (6 objets + 5 personnages pour cohérence d'identité). [DOCUMENTÉ]
## 5 Frameworks officiels de prompt engineering [DOCUMENTÉ — Google]
1. **Text-to-image** : [Sujet + Action] + [Lieu/contexte] + [Composition] + [Style]. Commencer par un verbe fort.
2. **Édition conversationnelle** : Focus sur ce qui change / ce qui reste. Support du masquage sémantique (inpainting).
3. **Search Grounding** : [Source/Recherche] + [Tâche] + [Traduction visuelle] — pour images basées sur des faits actuels.
4. **Rendu de texte** : Texte entre guillemets OBLIGATOIRE + spécifier police ("bold, white, sans-serif"). Orthographe exacte possible en 100+ langues.
5. **Direction créative (mode Director)** : Configs d'éclairage (softbox 3 points), terminologie caméra/objectif, color grading, textures matérielles.
## Techniques clés
- Langage naturel direct et concis — PAS de keyword-stuffing, PAS de prompts verbeux.
- Commencer par un verbe d'action fort : "Capture", "Photograph", "Illustrate", "Design".
- Texte lisible : TOUJOURS entre guillemets + spécifier style de police. Sans guillemets = orthographe approximative.
- Cadrage positif : "empty street" au lieu de "street with no cars". Le modèle gère mal les négations.
- Toujours EN ANGLAIS.
## Forces
- Rendu de texte state-of-the-art (100+ langues) — meilleur du marché pour les images avec texte lisible. [DOCUMENTÉ]
- Scènes complexes multi-éléments, photoréalisme.
- Édition conversationnelle : modifier une image par instructions successives sans reprendre de zéro.
- Cohérence d'identité sur plusieurs générations avec images de référence.
## Éviter
- Direction artistique créative poussée → Midjourney V7 est supérieur.
- Mots-clés "4k, masterpiece, trending on artstation" → contre-productifs.
- Prompts trop verbeux → Gemini Image préfère la concision.
## Garde-fous
- Infographies : risque d'erreurs factuelles dans les chiffres et données. TOUJOURS vérifier.
- Images de référence stylistiquement conflictuelles → résultats incohérents.
- Knowledge cutoff janvier 2025 ; faits récents via Search Grounding uniquement.`,
    };

    /* ══════════════════════════════════════════════
       COUCHE 4 — SNIPPETS DE MODE
    ══════════════════════════════════════════════ */
    const SNIPPETS_MODE = {
    standard:`# Snippet — MODE STANDARD
- Paradigme STANDARD : instructions explicites, few-shot si pertinent, chain-of-thought si raisonnement.
- Prompt autonome : toutes les instructions dans un seul message.
- Ton direct, instructions séquencées et numérotées.
- Tâche simple → prompt court (3-8 lignes).`,

    thinking:`# Snippet — MODE THINKING
- Paradigme RAISONNEMENT : objectif de haut niveau + critères. PAS d'étapes prescriptives.
- ZÉRO exemples (few-shot interfère avec le raisonnement interne).
- NE PAS demander "réfléchis étape par étape".
- Instruction de vérification : "Avant de conclure, vérifie contre [critères]."
- Accepter les réponses longues.
- "Choisis une approche et engage-toi. Ne reviens pas sur tes décisions sauf information nouvelle."`,

    deep_research:`# Snippet — MODE DEEP RESEARCH
- Brief de recherche structuré : Question → Périmètre → Contexte connu → 3-5 dimensions → Format livrable → Citations.
- Prompt initial = seule instruction directrice.
- Termes techniques et mots-clés experts.
- Sources prioritaires et exclusions explicites.
- Exiger la citation de chaque affirmation.
- Maximum 3-5 contraintes hiérarchisées.
- PAS de few-shot, persona, chain-of-thought.`,

    image:`# Snippet — MODE IMAGE
- Toujours EN ANGLAIS.
- Langage naturel descriptif — pas de listes, pas de balises.
- Ordre : sujet en premier (le plus pondéré) → medium → éclairage → palette → atmosphère → composition → détails.
- Éclairage et matérialité : impact disproportionné sur la qualité.
- Paramètres plateforme à la fin.
- PAS de "4k, masterpiece, highly detailed".
- Longueur : 30-80 mots hors paramètres.`,
    };

    /* ══════════════════════════════════════════════
       COUCHE 5 — ANTI-PATTERNS PAR PLATEFORME
    ══════════════════════════════════════════════ */
    const ANTI_PATTERNS = {
    claude:`# Anti-patterns — CLAUDE
## Généraux
- AP-CLG1 : NE JAMAIS prescrire "réfléchis étape par étape" en mode thinking/extended — le modèle a son propre raisonnement interne, l'instruction est redondante et peut dégrader la qualité. [DOCUMENTÉ — Anthropic]
- AP-CLG2 : NE JAMAIS fournir d'exemples few-shot en mode thinking — les exemples interfèrent avec le raisonnement interne et réduisent la qualité. Réserver le few-shot au mode standard uniquement (2-3 exemples max). [DOCUMENTÉ — multimodel]
- AP-CLG3 : NE PAS sur-spécifier les étapes pour Opus — "senior collaborator" qui fonctionne mieux avec des objectifs + critères qu'avec des instructions séquencées. La sur-spécification réduit la créativité et peut introduire des erreurs. [OBSERVÉ]
- AP-CLG4 : NE PAS demander du JSON comme format de sortie principal — Claude excelle en Markdown avec balises XML. Le JSON force une rigidité qui dégrade la prose. [DOCUMENTÉ — Anthropic]
- AP-CLG5 : NE PAS omettre les délimiteurs XML pour les documents longs — sans <context>/<task>/<constraints>, le modèle confond données et instructions. Impact : ~30% de dégradation sur tâches longues. [DOCUMENTÉ — Anthropic]
## Spécifiques Research
- AP-CLR1 : NE JAMAIS poser une question vague en mode Research — le budget de recherche (15× le coût standard) est consommé que la question soit bonne ou non. Pas de correction possible en cours d'exécution. [DOCUMENTÉ — Anthropic Help Center]
- AP-CLR2 : NE PAS surcharger avec 15+ dimensions — l'architecture multi-agent (Opus lead + Sonnet subagents) décompose en 3-5 sous-tâches. Plus de 5 dimensions = traitement superficiel de chaque axe. [OBSERVÉ]
- AP-CLR3 : NE PAS demander des URLs spécifiques — le générateur de citations peut halluciner des sources plausibles mais inexistantes. Toujours demander la vérification croisée. [OBSERVÉ — praticiens]`,

    chatgpt:`# Anti-patterns — CHATGPT
## Généraux
- AP-GPG1 : NE PAS sur-prompter GPT-5.4 Pro — le modèle fonctionne comme un "senior collaborator". Les instructions type "SOIS EXHAUSTIF", "NE RATE RIEN" sont documentées comme dégradant la qualité. Préférer objectif + critères concis. [DOCUMENTÉ — OpenAI, cursory degradation documented]
- AP-GPG2 : NE PAS fournir d'exemples few-shot en mode thinking — comme pour Claude thinking, les exemples interfèrent avec le raisonnement interne de GPT-5.4. [DOCUMENTÉ — multimodel]
- AP-GPG3 : NE PAS utiliser de prompts contradictoires — GPT dégrade fortement en présence de contradictions (ex : "sois exhaustif" + "en 5 lignes"). Plus sensible aux contradictions que Claude. [OBSERVÉ]
- AP-GPG4 : NE PAS omettre "Signale tes incertitudes" — surconfiance documentée de GPT, le modèle affirme plutôt que de signaler ses doutes. Ce garde-fou est critique. [DOCUMENTÉ — OpenAI]
- AP-GPG5 : NE PAS utiliser de balises XML — GPT est optimisé pour le Markdown. XML fonctionne mais consomme 34-38% plus de tokens sans gain de qualité. [DOCUMENTÉ — benchmarks]
## Spécifiques Deep Research
- AP-GPD1 : NE JAMAIS demander d'URLs dans le rapport — les URLs de ChatGPT DR sont hallucinatoires (~13% d'erreur documenté). Demander titres + auteurs + dates à la place. [OBSERVÉ — praticiens]
- AP-GPD2 : NE PAS répondre vaguement aux questions de clarification — le modèle intermédiaire (gpt-4.1) réécrit le prompt. "Fais comme tu veux" produit un prompt réécrit générique → recherche générique. [DOCUMENTÉ — Edward Sun, OpenAI]
- AP-GPD3 : NE PAS utiliser Deep Research pour des faits simples — coûte du quota (Pro: 250/mois, Plus: 25/mois) et prend 5-30 min. Utiliser le chat standard avec web pour les lookups. [DOCUMENTÉ — OpenAI Help Center]`,

    gemini:`# Anti-patterns — GEMINI
## Généraux
- AP-GEG1 : NE JAMAIS mélanger XML et Markdown dans un même prompt — Gemini confond les parsers. Choisir l'un ou l'autre, pas les deux. [DOCUMENTÉ — Google]
- AP-GEG2 : NE JAMAIS baisser la température en dessous de 1.0 — Gemini 3/3.1 est calibré pour temperature=1.0. Baisser provoque des boucles et de la dégradation. C'est contre-intuitif mais documenté. [DOCUMENTÉ — Google DeepMind]
- AP-GEG3 : NE PAS sur-structurer les prompts pour Flash — les prompts sur-engineerés confondent Flash. Garder des instructions directes et concises. [OBSERVÉ]
- AP-GEG4 : NE PAS placer les instructions AVANT les données — contrairement à GPT, Gemini fonctionne mieux avec données en premier, instructions après, contraintes en dernier. [DOCUMENTÉ — Google]
- AP-GEG5 : NE PAS demander de la prose émotionnelle ou littéraire — Gemini excelle en rédaction factuelle/structurée mais produit un style moins naturel en prose libre, surtout en français. [OBSERVÉ — Arena]
## Spécifiques Deep Research
- AP-GED1 : NE PAS ignorer le plan de recherche éditable — c'est le levier le plus sous-utilisé de Gemini DR. Modifier le plan auto-généré (supprimer axes non pertinents, repondérer priorités) avant exécution. [DOCUMENTÉ — blog.google]
- AP-GED2 : NE PAS activer Workspace sans périmètre — Gmail/Drive/Chat sans filtrage ajoutent du bruit à la recherche au lieu de l'enrichir. Activer Workspace uniquement avec scope précis. [OBSERVÉ]
- AP-GED3 : Attention au décalage thinking_level entre versions — MEDIUM en Gemini 3.1 ≈ HIGH en Gemini 3.0. Les niveaux ont été recalibrés. [DOCUMENTÉ — Google]`,

    perplexity:`# Anti-patterns — PERPLEXITY
## CRITIQUES (différences fondamentales avec les autres plateformes)
- AP-PER1 : NE JAMAIS utiliser de persona/rôle — le system prompt de Perplexity n'influence PAS le pipeline de recherche web. Un persona est des tokens gaspillés qui n'affectent que la mise en forme finale. [DOCUMENTÉ — System Card Perplexity]
- AP-PER2 : NE JAMAIS fournir d'exemples few-shot — inutile et coûteux, le modèle ne les utilise pas pour orienter ses recherches. [DOCUMENTÉ — architecture pipeline]
- AP-PER3 : NE JAMAIS demander de chain-of-thought explicite — le pipeline 5 étapes (décomposition → recherche ciblée → synthèse partielle → vérification croisée → synthèse narrative) a son propre raisonnement interne. [DOCUMENTÉ — architecture]
- AP-PER4 : NE JAMAIS demander d'URLs spécifiques — taux d'hallucination des citations ~13% documenté dans le System Card. Demander titres + auteurs. Toujours vérifier les citations manuellement. [DOCUMENTÉ — System Card]
- AP-PER5 : NE PAS répondre brièvement aux questions de clarification de l'agent intermédiaire — "oui", "peu importe" → prompt réécrit vague → recherche vague. [OBSERVÉ — praticiens]
## Erreurs fréquentes
- AP-PER6 : NE PAS dépasser 5 dimensions de recherche — le budget est fixe (20-50 recherches). Plus de dimensions = traitement superficiel de chaque axe. Idéal : 3-5 dimensions. [OBSERVÉ]
- AP-PER7 : NE PAS utiliser Deep Research pour des lookups simples — gaspille des crédits + 2-5 min d'attente. Le chat standard avec web suffit pour les faits vérifiables. [DOCUMENTÉ]
- AP-PER8 : NE PAS utiliser le focus "Social" pour recherche professionnelle — restreint les sources au contenu social media, dégrade la qualité pour les recherches sérieuses. [OBSERVÉ]`,

    midjourney:`# Anti-patterns — MIDJOURNEY V7
## Critiques
- AP-MJ1 : NE JAMAIS utiliser les mots-clés "4k, masterpiece, highly detailed, trending on artstation" — en V7, ces termes sont contre-productifs et dégradent la qualité. V7 comprend le langage naturel. [DOCUMENTÉ — Midjourney]
- AP-MJ2 : NE PAS utiliser de balises XML ou de listes à puces — Midjourney attend du langage naturel descriptif type brief photographique, pas de structures techniques. [DOCUMENTÉ]
- AP-MJ3 : NE PAS utiliser de negative prompts classiques ("no X, no Y") — en V7, utiliser plutôt le paramètre --no ou la syntaxe pondérée (element::-1). Les négations textuelles sont ignorées ou mal interprétées. [DOCUMENTÉ — Midjourney]
- AP-MJ4 : NE PAS demander du texte lisible dans l'image — Midjourney ne gère pas le rendu de texte. Utiliser Gemini Image (Nano Banana Pro) pour les images avec texte. [OBSERVÉ]
- AP-MJ5 : NE PAS omettre les paramètres de style — sans --stylize et --chaos, le résultat est au défaut (--s 100). Adapter selon le cas : photoréaliste (--s 50-100), éditorial (--s 150-250), artistique (--s 400-750). [DOCUMENTÉ — Midjourney]
- AP-MJ6 : NE PAS ignorer --draft pour l'itération — 10× plus rapide, 50% moins cher. Itérer en draft, finaliser sans. [DOCUMENTÉ — Midjourney]`,

    gemini_image:`# Anti-patterns — GEMINI IMAGE (Nano Banana Pro)
## Critiques
- AP-GI1 : NE JAMAIS utiliser les mots-clés "4k, masterpiece, trending on artstation" — comme Midjourney V7, Gemini Image préfère le langage naturel direct. Ces mots-clés n'améliorent rien. [DOCUMENTÉ — Google DeepMind]
- AP-GI2 : NE PAS utiliser de prompts trop verbeux — Gemini 3 Pro Image fonctionne mieux avec des instructions concises et directes qu'avec des descriptions exhaustives. [DOCUMENTÉ — Google]
- AP-GI3 : NE PAS spécifier de négations ("no cars", "without people") — le modèle gère mal les négations. Préférer le cadrage positif : "empty street" au lieu de "street with no cars". [OBSERVÉ]
- AP-GI4 : NE PAS demander du texte sans guillemets — pour du texte lisible dans l'image, encadrer le texte exact entre guillemets ET spécifier la police. Sans guillemets, l'orthographe sera approximative. [DOCUMENTÉ — Google]
- AP-GI5 : NE PAS mélanger des références d'images de styles conflictuels — jusqu'à 14 images de référence possibles, mais elles doivent être stylistiquement cohérentes. [OBSERVÉ]
- AP-GI6 : NE PAS utiliser pour des infographies factuelles — le modèle peut introduire des erreurs dans les chiffres et les données. Vérifier toute donnée factuelle dans l'image. [DOCUMENTÉ — Google]`,
    };

    /* ══════════════════════════════════════════════
       COUCHE 6 — RÈGLES DE PARADIGME
    ══════════════════════════════════════════════ */
    const PARADIGM_RULES = {
    standard:`# Paradigme STANDARD — Règles détaillées
## Quand ce paradigme s'applique
Modèles en mode standard (Claude Sonnet standard, Gemini 3.1 Pro standard). Le modèle exécute littéralement ce qu'on lui demande.
## Principes actifs
1. **Few-shot efficace** : 2-3 exemples, le dernier est le plus influent (biais de récence documenté). Sélectionner par similarité avec la tâche, pas au hasard.
2. **Chain-of-thought explicite** : "Raisonne étape par étape avant de répondre" améliore de +4-13.5% selon le modèle pour les tâches de raisonnement/math. [DOCUMENTÉ — Schulhoff et al., Tam et al.]
3. **Instructions séquencées détaillées** : Numéroter les étapes. Le modèle exécute dans l'ordre. Plus les instructions sont explicites, meilleur est le résultat.
4. **Persona/rôle efficace** : "Tu es un expert en [domaine]" améliore le style et le ton, mais PAS la précision factuelle. [DOCUMENTÉ — Wharton Report 2025]
5. **Format très explicite** : Spécifier structure, longueur, sections, colonnes. Le modèle standard ne devine pas bien les attentes implicites.
## Erreurs fréquentes en mode standard
- Objectifs trop vagues → résultats génériques.
- Pas assez d'exemples → le modèle improvise le format.
- Instructions contradictoires → dégradation sévère.`,

    reasoning:`# Paradigme RAISONNEMENT — Règles détaillées
## Quand ce paradigme s'applique
Modèles en mode thinking ou deep_research (Claude Sonnet/Opus thinking, GPT-5.4 Pro/Thinking, tous les Deep Research). Le modèle a un raisonnement interne autonome.
## INVERSIONS CRITIQUES par rapport au mode standard
1. **ZÉRO exemples few-shot** : Les exemples interfèrent avec le raisonnement interne du modèle. Fournir des exemples à un modèle thinking DÉGRADE la qualité. C'est l'inverse exact du mode standard. [DOCUMENTÉ — OpenAI, Anthropic, Google]
2. **NE PAS prescrire de chain-of-thought** : "Réfléchis étape par étape" est REDONDANT — le modèle le fait déjà. L'instruction ajoute 20-80% d'overhead de tokens sans gain mesurable. [DOCUMENTÉ — multimodel benchmarks]
3. **Objectifs, pas étapes** : Fournir l'objectif final + critères de succès + contraintes. LAISSER le modèle choisir sa propre approche. La prescription d'étapes réduit la qualité. [DOCUMENTÉ — OpenAI, Anthropic]
4. **Critères de vérification, pas de processus** : "Vérifie que X, Y, Z sont satisfaits" plutôt que "D'abord fais A, puis vérifie B, puis corrige C". [OBSERVÉ]
5. **Accepter les réponses longues** : Les modèles thinking produisent naturellement des réponses plus détaillées. Tronquer ou forcer la brièveté dégrade le raisonnement. [OBSERVÉ]
6. **Engagement décisionnel** : Demander "Choisis une approche et engage-toi. Ne reviens pas sur tes décisions sauf information nouvelle." Empêche les boucles d'hésitation. [OBSERVÉ]
## Erreurs fréquentes en mode raisonnement
- Fournir des exemples → dégradation.
- Prescrire des étapes → le modèle ignore son raisonnement interne pour suivre les étapes, avec un résultat inférieur.
- Demander de la brièveté → le raisonnement est tronqué, conclusions incorrectes.`,
    };

    /* ══════════════════════════════════════════════
       COUCHE 7 — EXEMPLARS (ancres de calibration)
    ══════════════════════════════════════════════ */
    const EXEMPLARS = {
    claude: {
      redaction:`# Calibration — Claude + Rédaction
Un prompt de rédaction optimal pour Claude utilise des balises XML pour structurer le contexte, spécifie le public cible et le ton dès le début, place les documents de référence AVANT les instructions, et demande explicitement la longueur souhaitée. En mode thinking (Opus/Sonnet), formuler l'objectif éditorial + critères de qualité sans prescrire d'étapes. En mode standard (Sonnet), inclure 2-3 exemples du ton attendu et des instructions séquencées.`,
      analyse:`# Calibration — Claude + Analyse
Un prompt d'analyse optimal pour Claude structure les données dans des balises <document> avec <source>, formule les critères d'évaluation dans <constraints>, et demande explicitement un format de sortie (tableau comparatif, rapport structuré). En mode thinking, fournir l'objectif d'analyse + critères de réussite et laisser le modèle choisir sa méthodologie. Exiger une conclusion tranchée, pas un résumé neutre.`,
      recherche:`# Calibration — Claude Research
Un prompt de recherche optimal pour Claude Research investit dans la précision initiale — question de recherche exacte, périmètre temporel/géographique/disciplinaire, dimensions de recherche (3-5 max), format de livrable, et contexte déjà connu. Pré-répondre aux clarifications probables. Exploiter la fenêtre 200K en injectant des documents de référence. Itérer par follow-ups séquentiels plutôt qu'un méga-prompt.`,
    },
    chatgpt: {
      redaction:`# Calibration — ChatGPT + Rédaction
Un prompt de rédaction optimal pour ChatGPT ouvre avec un rôle/persona ("Tu es un rédacteur spécialisé en..."), utilise le Markdown pour structurer, commence par un verbe d'action, et spécifie très explicitement le format de sortie (nombre de sections, longueur, type). Pour GPT-5.4 Pro : objectif + critères seulement, pas d'étapes. Ajouter "Signale tes incertitudes".`,
      analyse:`# Calibration — ChatGPT + Analyse
Un prompt d'analyse optimal pour ChatGPT exploite ses forces en modélisation financière et données structurées. Rôle/persona professionnel en ouverture, verbe d'action ("Analyse", "Compare", "Évalue"), données en Markdown, format de sortie très explicite (colonnes, métriques). Pour GPT-5.4 Pro : critères de décision + contraintes, laisser le modèle structurer son approche.`,
      recherche:`# Calibration — ChatGPT Deep Research
Un prompt de recherche optimal pour ChatGPT DR est un brief structuré : question précise (mots-clés experts = signaux de recherche directs) → périmètre → contexte connu → 3-5 dimensions → format → "Cite chaque affirmation ou marque [NON VÉRIFIÉ]". Ne jamais demander d'URLs. Fournir des hypothèses concurrentes si possible pour forcer l'exploration équilibrée.`,
    },
    gemini: {
      redaction:`# Calibration — Gemini + Rédaction
Un prompt de rédaction optimal pour Gemini place les données/contexte EN PREMIER, les instructions APRÈS, les contraintes négatives EN DERNIER. Ne pas mélanger XML et Markdown. Demander explicitement un résultat détaillé (concis par défaut). Gemini excelle en rédaction factuelle et structurée. Température fixée à 1.0.`,
      analyse:`# Calibration — Gemini + Analyse
Un prompt d'analyse optimal pour Gemini exploite le raisonnement scientifique (GPQA 94.3%) et la fenêtre 2M tokens pour les corpus longs. Données en premier, instructions après. "Utilise uniquement le contexte fourni" si fidélité critique. Format explicite attendu. Thinking level ajustable (MEDIUM en 3.1 ≈ HIGH en 3.0).`,
      recherche:`# Calibration — Gemini Deep Research
Un prompt de recherche optimal pour Gemini DR peut suivre deux stratégies : (1) prompt détaillé ou (2) prompt simple + modification du plan auto-généré avant exécution. Le plan éditable est le plus gros levier qualité. Injection de fichiers possible (jusqu'à 1 500 pages). Exiger citations. Itérer par "développe section X" en follow-up.`,
    },
    };

    /* ══════════════════════════════════════════════
       MATRICE DE SCORING v3 ANNOTÉE
    ══════════════════════════════════════════════ */
    const SCORING_MATRIX = {
      redaction:{
        c_sonnet:{s:4,d:"Prose naturelle en français, copywriting, newsletters — le plus fluide en français"},
        c_sont:  {s:3,d:"Rédaction argumentative complexe nécessitant un raisonnement structuré"},
        c_opust: {s:5,d:"Documents longs, essais complexes, prose littéraire — meilleure qualité d'écriture absolue"},
        c_res:   {s:1,d:"Non adapté"},g54p:{s:3,d:"Rédaction professionnelle formelle, documents techniques, rapports"},
        g54t:    {s:3,d:"Rédaction professionnelle formelle"},gdr:{s:1,d:"Non adapté"},
        g31p:    {s:4,d:"Rédaction factuelle, SEO, essais informatifs, contenus s'appuyant sur des données"},
        gdr2:{s:1,d:"Non adapté"},gimp:{s:0,d:"Image"},pdr:{s:0,d:"Non adapté"},mjv7:{s:0,d:"Image"},
      },
      analyse:{
        c_sonnet:{s:3,d:"Analyses simples, comparaisons rapides"},
        c_sont:  {s:4,d:"Analyse multi-critères avec raisonnement structuré, synthèse de documents"},
        c_opust: {s:5,d:"Analyse qualitative profonde, documents longs, évaluation nuancée — meilleur avec outils"},
        c_res:   {s:2,d:"Analyse via recherche web, force = collecte"},
        g54p:    {s:5,d:"Analyse quantitative, modélisation financière, tableurs, données structurées"},
        g54t:    {s:3,d:"Analyse correcte mais inférieur au mode Pro"},
        gdr:     {s:2,d:"Collecte plus qu'analyse"},g31p:{s:4,d:"Analyse scientifique, raisonnement abstrait, gros corpus 2M tokens"},
        gdr2:{s:2,d:"Analyse via recherche, fort sur Google Workspace"},gimp:{s:0,d:"Image"},
        pdr:{s:1,d:"Collecte de données"},mjv7:{s:0,d:"Image"},
      },
      code:{
        c_sonnet:{s:4,d:"Code courant, scripts, intégrations"},
        c_sont:  {s:4,d:"Debug complexe, architecture, refactoring"},
        c_opust: {s:5,d:"Architecture système, refactoring multi-fichiers, spécifications vagues — meilleur en compréhension d'intention"},
        c_res:   {s:1,d:"Non adapté"},
        g54p:    {s:4,d:"Exécution terminal, computer-use, workflows code + outils bureautiques"},
        g54t:    {s:3,d:"Code correct mais inférieur au mode Pro"},gdr:{s:1,d:"Non adapté"},
        g31p:    {s:4,d:"Algorithmique, coding compétitif, gros repos fenêtre 2M"},
        gdr2:{s:1,d:"Non adapté"},gimp:{s:0,d:"Image"},pdr:{s:0,d:"Non adapté"},mjv7:{s:0,d:"Image"},
      },
      recherche:{
        c_sonnet:{s:1,d:"Pas d'accès web"},c_sont:{s:1,d:"Pas d'accès web"},c_opust:{s:1,d:"Pas d'accès web"},
        c_res:   {s:3,d:"Recherche multi-agent, fenêtre 200K — plus récent, moins mature que concurrents"},
        g54p:    {s:1,d:"Pas d'accès web"},g54t:{s:1,d:"Pas d'accès web"},
        gdr:     {s:5,d:"Agent le plus mature, rapports les plus complets, 5-30 min, phase de clarification"},
        g31p:    {s:1,d:"Pas d'accès web"},
        gdr2:    {s:4,d:"Intégration Google Workspace native — meilleur si sources dans l'écosystème Google"},
        gimp:{s:0,d:"Image"},
        pdr:     {s:4,d:"Le plus rapide (2-5 min), le mieux sourcé — idéal pour faits vérifiables"},
        mjv7:{s:0,d:"Image"},
      },
      image:{
        c_sonnet:{s:0,d:"N/A"},c_sont:{s:0,d:"N/A"},c_opust:{s:0,d:"N/A"},c_res:{s:0,d:"N/A"},
        g54p:{s:0,d:"N/A"},g54t:{s:0,d:"N/A"},gdr:{s:0,d:"N/A"},g31p:{s:0,d:"N/A"},gdr2:{s:0,d:"N/A"},
        gimp:{s:4,d:"Meilleur rendu de texte (100+ langues), scènes complexes, photoréalisme, édition conversationnelle"},
        pdr:{s:0,d:"N/A"},
        mjv7:{s:5,d:"Qualité esthétique inégalée, contrôle fin (stylize, chaos, sref), direction artistique"},
      },
      raisonnement:{
        c_sonnet:{s:1,d:"Limité sans thinking"},
        c_sont:  {s:3,d:"Bon raisonnement, un cran en dessous d'Opus — problèmes de difficulté moyenne"},
        c_opust: {s:5,d:"Raisonnement profond avec adaptive thinking, Arena #1, meilleur sur problèmes à horizon long"},
        c_res:{s:1,d:"Non adapté"},
        g54p:    {s:5,d:"Plafond absolu en raisonnement professionnel (GDPval 83%), tâches multi-étapes, juridique, financier"},
        g54t:    {s:3,d:"Raisonnement correct, inférieur au mode Pro"},gdr:{s:1,d:"Non adapté"},
        g31p:    {s:4,d:"Leader raisonnement scientifique et abstrait (GPQA 94.3%, ARC-AGI-2 77.1%)"},
        gdr2:{s:1,d:"Non adapté"},gimp:{s:0,d:"Image"},pdr:{s:1,d:"Non adapté"},mjv7:{s:0,d:"Image"},
      },
      transformation:{
        c_sonnet:{s:4,d:"Exécution littérale, suit les instructions à la lettre — reformatage précis"},
        c_sont:  {s:3,d:"Fonctionnel mais thinking surdimensionné"},
        c_opust: {s:3,d:"Fonctionnel mais surdimensionné et plus lent"},
        c_res:{s:1,d:"Non adapté"},g54p:{s:3,d:"Fonctionnel"},g54t:{s:3,d:"Fonctionnel"},gdr:{s:1,d:"Non adapté"},
        g31p:    {s:5,d:"Fenêtre 2M tokens — seul modèle capable de transformer de très longs documents en une passe"},
        gdr2:{s:1,d:"Non adapté"},gimp:{s:0,d:"Image"},pdr:{s:0,d:"Non adapté"},mjv7:{s:0,d:"Image"},
      },
    };

    /* ══════════════════════════════════════════════
       BIBLIOTHÈQUE DE PROMPTS
    ══════════════════════════════════════════════ */
    const DEFAULT_LIB_CATEGORIES = [
      { id:"challenge",     label:"Se challenger",  icon:"🔥", color:"#E74C3C" },
      { id:"apprentissage", label:"Apprendre",      icon:"🎓", color:"#3498DB" },
      { id:"reflexion",     label:"Réfléchir",      icon:"🪞", color:"#9B59B6" },
      { id:"creation",      label:"Créer",          icon:"💡", color:"#F39C12" },
    ];

    const DEFAULT_PROMPTS = [
      {
        id:"lib_001", title:"Le Contradicteur", category:"challenge",
        description:"L'IA démonte ton idée sans ménagement pour révéler ses failles.",
        prompt:`Ton rôle : démolir mon idée sur {SUJET}. Pas de complaisance. Pas de "c'est intéressant mais...".

Règles :
1. Identifie chaque faille logique, chaque hypothèse non vérifiée, chaque angle mort.
2. Sois brutal et direct. Si l'idée est mauvaise, dis-le.
3. Pour chaque critique, explique POURQUOI c'est un problème réel, pas théorique.
4. Termine par un verdict : cette idée tient-elle debout ou non ? Tranche.
5. Si tu trouves un point fort, mentionne-le en une phrase, pas plus.

Mon idée : {SUJET}`,
        model:"c_opust", variables:["SUJET"], rating:0, builtIn:true
      },
      {
        id:"lib_002", title:"L'Avocat du Diable", category:"challenge",
        description:"L'IA prend systématiquement la position inverse et argumente.",
        prompt:`Tu es mon adversaire intellectuel sur {SUJET}. Tu prends la position exactement inverse de la mienne et tu la défends avec conviction.

Règles :
1. Ne cherche pas l'équilibre. Défends la position contraire à fond.
2. Utilise des arguments factuels, pas des opinions.
3. Anticipe mes contre-arguments et démonte-les préventivement.
4. Sois incisif. Pas de "d'un autre côté" ni de nuances molles.
5. Conclus par : "Voilà pourquoi tu as tort."

Ma position : {SUJET}`,
        model:"g54p", variables:["SUJET"], rating:0, builtIn:true
      },
      {
        id:"lib_003", title:"Le Mentor Exigeant", category:"reflexion",
        description:"10 questions inconfortables pour te forcer à réfléchir en profondeur.",
        prompt:`Tu es un mentor qui ne supporte pas la médiocrité. Pose-moi 10 questions inconfortables sur {SUJET}.

Règles :
1. Chaque question doit me mettre face à un angle mort, une incohérence ou un manque d'ambition.
2. Pas de questions faciles ou complaisantes. Si la réponse est évidente, la question est mauvaise.
3. Formule chaque question pour qu'elle pique — qu'elle provoque une vraie réflexion, pas une réponse automatique.
4. Les questions doivent couvrir : ma stratégie, mes peurs, mes excuses, mes contradictions, et ce que j'évite de regarder en face.
5. Après les 10 questions, ajoute : "Maintenant réponds honnêtement. Pas à moi — à toi."

Sujet : {SUJET}`,
        model:"c_opust", variables:["SUJET"], rating:0, builtIn:true
      },
      {
        id:"lib_004", title:"L'Explorateur Pédagogue", category:"apprentissage",
        description:"Apprends un sujet progressivement, du niveau débutant au niveau expert.",
        prompt:`Apprends-moi {SUJET} en 4 niveaux progressifs.

Niveau 1 — Comme si j'avais 5 ans : explication ultra-simple avec une analogie du quotidien.
Niveau 2 — Lycéen curieux : les concepts clés, le vocabulaire, les grandes lignes.
Niveau 3 — Professionnel : les nuances, les débats, les applications concrètes, les erreurs courantes.
Niveau 4 — Expert : les frontières du savoir actuel, les questions ouvertes, ce que même les spécialistes ne savent pas encore.

Pour chaque niveau, donne-moi une ressource (livre, article, vidéo) pour aller plus loin.
Sois concis à chaque niveau — pas de remplissage.`,
        model:"c_sonnet", variables:["SUJET"], rating:0, builtIn:true
      },
      {
        id:"lib_005", title:"Le Stratège Lucide", category:"reflexion",
        description:"Analyse froide de ta stratégie pour révéler ce que tu ne vois pas.",
        prompt:`Analyse ma stratégie sur {SUJET} avec la froideur d'un consultant qui n'a rien à me vendre.

Règles :
1. Identifie ce que je ne vois pas : angles morts, risques ignorés, opportunités manquées.
2. Évalue la cohérence : mes actions sont-elles alignées avec mon objectif déclaré ?
3. Cherche les "mensonges confortables" — les hypothèses que je prends pour des vérités parce que ça m'arrange.
4. Donne-moi 3 scénarios : optimiste réaliste, pessimiste probable, et le pire cas que j'évite de considérer.
5. Termine par UNE action que je devrais faire cette semaine et que je repousse probablement.

Ma stratégie : {SUJET}`,
        model:"g54p", variables:["SUJET"], rating:0, builtIn:true
      },
      {
        id:"lib_006", title:"Le Créatif Débridé", category:"creation",
        description:"20 idées folles sans filtre pour casser tes schémas de pensée.",
        prompt:`Génère 20 idées sur {SUJET}. Pas 20 idées raisonnables — 20 idées qui me surprennent.

Règles :
1. Les 5 premières : des idées que n'importe qui pourrait avoir. Évacue le banal.
2. Les 5 suivantes : des combinaisons inattendues — croise {SUJET} avec des domaines qui n'ont rien à voir.
3. Les 5 suivantes : des idées qui me mettraient mal à l'aise ou qui semblent impossibles.
4. Les 5 dernières : des idées tellement audacieuses que je n'oserais en parler à personne.
5. Pour chaque idée : une phrase maximum. Pas d'explication, pas de justification.
6. Après la liste : choisis les 3 qui ont le plus de potentiel et explique pourquoi en 2 lignes chacune.`,
        model:"c_opust", variables:["SUJET"], rating:0, builtIn:true
      },
    ];

    /* ══════════════════════════════════════════════
       PLATEFORMES & MODÈLES
    ══════════════════════════════════════════════ */
    const PLATFORMS = [
      { id:"claude", name:"Claude.ai", color:"#CC6B2C", logo:"✦", cat:"text", models:[
        {id:"c_sonnet",name:"Sonnet 4.6",      platform_key:"claude",      mode:"standard",      badge:null,       desc:"Rédaction, coding, usage général"},
        {id:"c_sont",  name:"Sonnet 4.6",      platform_key:"claude",      mode:"thinking",      badge:"Thinking", desc:"Raisonnement étendu"},
        {id:"c_opust", name:"Opus 4.6",        platform_key:"claude",      mode:"thinking",      badge:"Thinking", desc:"Raisonnement max, tâches complexes"},
        {id:"c_res",   name:"Claude Research",  platform_key:"claude",      mode:"deep_research", badge:"Agent",    desc:"Recherche web itérative"},
      ]},
      { id:"chatgpt", name:"ChatGPT", color:"#10A37F", logo:"⬡", cat:"text", models:[
        {id:"g54p",name:"GPT-5.4 Pro",     platform_key:"chatgpt",  mode:"thinking",      badge:"Pro",      desc:"Analyse, knowledge work, modélisation"},
        {id:"g54t",name:"GPT-5.4 Thinking",platform_key:"chatgpt",  mode:"thinking",      badge:"Thinking", desc:"Raisonnement standard"},
        {id:"gdr", name:"ChatGPT Deep Research", platform_key:"chatgpt", mode:"deep_research", badge:"Agent", desc:"Recherche approfondie — 5 à 30 min"},
      ]},
      { id:"gemini", name:"Gemini", color:"#4285F4", logo:"◈", cat:"text", models:[
        {id:"g31p",name:"3.1 Pro",        platform_key:"gemini",      mode:"standard",      badge:null,   desc:"Long contexte 2M tokens, transformation"},
        {id:"gdr2",name:"Gemini Deep Research", platform_key:"gemini",  mode:"deep_research", badge:"Agent",desc:"Recherche — intégration Google Workspace"},
      ]},
      { id:"gemini_img", name:"Gemini Image", color:"#4285F4", logo:"◈", cat:"image", models:[
        {id:"gimp",name:"3.1 Pro Image",  platform_key:"gemini_image",mode:"image",         badge:"Image",desc:"Rendu de texte, scènes complexes"},
      ]},
      { id:"perplexity", name:"Perplexity", color:"#20B2AA", logo:"◎", cat:"text", models:[
        {id:"pdr",name:"Perplexity Deep Research", platform_key:"perplexity", mode:"deep_research", badge:"Agent",desc:"Recherche sourcée rapide (2-5 min)"},
      ]},
      { id:"midjourney", name:"Midjourney", color:"#9B59B6", logo:"⬢", cat:"image", models:[
        {id:"mjv7",name:"v7",             platform_key:"midjourney",  mode:"image",         badge:null,   desc:"Direction artistique, photographie"},
      ]},
    ];

    const ALL_MODELS = PLATFORMS.flatMap(pl => pl.models.map(m => ({...m,platform:pl.name,pcolor:pl.color,plogo:pl.logo,pid:pl.id,cat:pl.cat})));
    const ALL_IDS    = ALL_MODELS.map(m => m.id);

    /* ─── API Helper ─── */
    const API_BASE = "/api";
    const apiFetch = async (path, opts = {}) => {
      const token = localStorage.getItem("po:token");
      const headers = { "Content-Type": "application/json", ...opts.headers };
      if (token) headers["Authorization"] = `Bearer ${token}`;
      const res = await fetch(`${API_BASE}${path}`, { ...opts, headers });
      if (res.status === 401) {
        // token expiré : on le retire aussi des comptes mémorisés
        saveAccounts(loadAccounts().filter(a => a.token !== token));
        localStorage.removeItem("po:token");
        window.location.reload();
        throw new Error("Session expirée");
      }
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Erreur serveur");
      return data;
    };

    /* ─── Écran d'authentification ─── */
    const AUTH_INPUT = {width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 15px",color:C.cream,fontSize:"14px"};

    const AuthCard = ({ subtitle, children }) => (
      <div style={{minHeight:"100vh",background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
        <div style={{background:C.navyL,border:`1px solid ${C.amber}40`,borderRadius:"16px",padding:"36px 32px",maxWidth:"400px",width:"100%"}}>
          <div style={{textAlign:"center",marginBottom:"28px"}}>
            <div style={{fontSize:"32px",color:C.amber,marginBottom:"12px"}}>✦</div>
            <h1 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"6px"}}>Prompt Optimizer</h1>
            <p style={{fontSize:"13px",color:C.muted}}>{subtitle}</p>
          </div>
          {children}
        </div>
      </div>
    );

    /* ─── Nouveau mot de passe (arrivée depuis le lien email) ─── */
    const ResetPasswordScreen = ({ token }) => {
      const [password, setPassword] = useState("");
      const [confirm, setConfirm] = useState("");
      const [error, setError] = useState("");
      const [done, setDone] = useState(false);
      const [loading, setLoading] = useState(false);

      const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (password !== confirm) return setError("Les deux mots de passe ne correspondent pas");
        setLoading(true);
        try {
          const data = await fetch(`${API_BASE}/auth/reset-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ token, password }),
          }).then(r => r.json());
          if (data.error) throw new Error(data.error);
          localStorage.removeItem("po:token");
          setDone(true);
        } catch (err) { setError(err.message); }
        finally { setLoading(false); }
      };

      if (done) {
        return (
          <AuthCard subtitle="Mot de passe mis à jour">
            <p style={{fontSize:"14px",color:C.cream,textAlign:"center",marginBottom:"20px"}}>
              Ton mot de passe a été modifié. Tu peux maintenant te connecter.
            </p>
            <button onClick={() => { window.location.href = "/"; }}
              style={{...btnS(true, false),width:"100%",fontSize:"15px",padding:"13px"}}>Aller à la connexion</button>
          </AuthCard>
        );
      }

      return (
        <AuthCard subtitle="Choisis un nouveau mot de passe">
          <form onSubmit={submit}>
            <div style={{marginBottom:"14px"}}>
              <div style={labelS}>Nouveau mot de passe</div>
              <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                placeholder="••••••••" minLength={6} style={AUTH_INPUT}/>
            </div>
            <div style={{marginBottom:"20px"}}>
              <div style={labelS}>Confirmer le mot de passe</div>
              <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                placeholder="••••••••" minLength={6} style={AUTH_INPUT}/>
            </div>
            {error && <p style={{color:C.error,fontSize:"13px",marginBottom:"14px",textAlign:"center"}}>{error}</p>}
            <button type="submit" disabled={loading}
              style={{...btnS(true, loading),width:"100%",fontSize:"15px",padding:"13px",marginBottom:"16px"}}>
              {loading ? "Chargement…" : "Enregistrer le mot de passe"}
            </button>
          </form>
          <p style={{fontSize:"13px",color:C.muted,textAlign:"center"}}>
            <span onClick={() => { window.location.href = "/"; }} style={{color:C.amber,cursor:"pointer",fontWeight:"600",textDecoration:"underline"}}>Retour à la connexion</span>
          </p>
        </AuthCard>
      );
    };

    const AuthScreen = ({ onAuth }) => {
      const [mode, setMode] = useState("login"); // login | register | forgot
      const isLogin = mode === "login";
      const [email, setEmail] = useState("");
      const [username, setUsername] = useState("");
      const [password, setPassword] = useState("");
      const [error, setError] = useState("");
      const [info, setInfo] = useState("");
      const [loading, setLoading] = useState(false);

      const switchMode = (m) => { setMode(m); setError(""); setInfo(""); };

      const submit = async (e) => {
        e.preventDefault();
        setError(""); setInfo(""); setLoading(true);
        try {
          const endpoint = isLogin ? "/auth/login" : "/auth/register";
          const body = isLogin ? { email, password } : { email, username, password };
          const data = await fetch(`${API_BASE}${endpoint}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(body),
          }).then(r => r.json());
          if (data.error) throw new Error(data.error);
          localStorage.setItem("po:token", data.token);
          onAuth(data.token, data.user);
        } catch (err) { setError(err.message); }
        finally { setLoading(false); }
      };

      const submitForgot = async (e) => {
        e.preventDefault();
        setError(""); setInfo(""); setLoading(true);
        try {
          const data = await fetch(`${API_BASE}/auth/forgot-password`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
          }).then(r => r.json());
          if (data.error) throw new Error(data.error);
          setInfo(data.message);
        } catch (err) { setError(err.message); }
        finally { setLoading(false); }
      };

      if (mode === "forgot") {
        return (
          <AuthCard subtitle="Réinitialise ton mot de passe">
            <form onSubmit={submitForgot}>
              <div style={{marginBottom:"20px"}}>
                <div style={labelS}>Email</div>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  placeholder="ton@email.fr" style={AUTH_INPUT}/>
              </div>
              {error && <p style={{color:C.error,fontSize:"13px",marginBottom:"14px",textAlign:"center"}}>{error}</p>}
              {info && <p style={{color:C.amber,fontSize:"13px",marginBottom:"14px",textAlign:"center"}}>{info}</p>}
              <button type="submit" disabled={loading}
                style={{...btnS(true, loading),width:"100%",fontSize:"15px",padding:"13px",marginBottom:"16px"}}>
                {loading ? "Envoi…" : "Recevoir le lien de réinitialisation"}
              </button>
            </form>
            <p style={{fontSize:"13px",color:C.muted,textAlign:"center"}}>
              <span onClick={() => switchMode("login")} style={{color:C.amber,cursor:"pointer",fontWeight:"600",textDecoration:"underline"}}>Retour à la connexion</span>
            </p>
          </AuthCard>
        );
      }

      return (
        <div style={{minHeight:"100vh",background:C.navy,display:"flex",alignItems:"center",justifyContent:"center",padding:"20px"}}>
          <div style={{background:C.navyL,border:`1px solid ${C.amber}40`,borderRadius:"16px",padding:"36px 32px",maxWidth:"400px",width:"100%"}}>
            <div style={{textAlign:"center",marginBottom:"28px"}}>
              <div style={{fontSize:"32px",color:C.amber,marginBottom:"12px"}}>✦</div>
              <h1 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"6px"}}>Prompt Optimizer</h1>
              <p style={{fontSize:"13px",color:C.muted}}>{isLogin ? "Connecte-toi pour accéder à tes prompts" : "Crée ton compte"}</p>
            </div>
            <form onSubmit={submit}>
              <div style={{marginBottom:"14px"}}>
                <div style={labelS}>Email</div>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required
                  placeholder="ton@email.fr"
                  style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 15px",color:C.cream,fontSize:"14px"}}/>
              </div>
              {!isLogin && (
                <div style={{marginBottom:"14px"}}>
                  <div style={labelS}>Nom d'utilisateur</div>
                  <input type="text" value={username} onChange={e => setUsername(e.target.value)} required
                    placeholder="Pierre"
                    style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 15px",color:C.cream,fontSize:"14px"}}/>
                </div>
              )}
              <div style={{marginBottom:"20px"}}>
                <div style={labelS}>Mot de passe</div>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} required
                  placeholder="••••••••" minLength={6}
                  style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"12px 15px",color:C.cream,fontSize:"14px"}}/>
              </div>
              {error && <p style={{color:C.error,fontSize:"13px",marginBottom:"14px",textAlign:"center"}}>{error}</p>}
              <button type="submit" disabled={loading}
                style={{...btnS(true, loading),width:"100%",fontSize:"15px",padding:"13px",marginBottom:"16px"}}>
                {loading ? "Chargement…" : isLogin ? "Se connecter" : "Créer mon compte"}
              </button>
            </form>
            {isLogin && (
              <p style={{fontSize:"13px",color:C.muted,textAlign:"center",marginBottom:"10px"}}>
                <span onClick={() => switchMode("forgot")} style={{color:C.amber,cursor:"pointer",fontWeight:"600",textDecoration:"underline"}}>
                  Mot de passe oublié ?
                </span>
              </p>
            )}
            <p style={{fontSize:"13px",color:C.muted,textAlign:"center"}}>
              {isLogin ? "Pas encore de compte ? " : "Déjà un compte ? "}
              <span onClick={() => switchMode(isLogin ? "register" : "login")} style={{color:C.amber,cursor:"pointer",fontWeight:"600",textDecoration:"underline"}}>
                {isLogin ? "S'inscrire" : "Se connecter"}
              </span>
            </p>
          </div>
        </div>
      );
    };

    /* ═══════════════════════════════
       COMPOSANT PRINCIPAL
    ═══════════════════════════════ */
    const DodgeButton = () => {
      const [offset, setOffset] = useState({x:0,y:0});
      const dodge = () => {
        const rx = (Math.random() - 0.5) * 260;
        const ry = (Math.random() - 0.5) * 200;
        setOffset({x: rx, y: ry});
      };
      return <button onMouseEnter={dodge} style={{background:"transparent",border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 20px",color:C.muted,fontSize:"13px",fontWeight:"600",cursor:"pointer",position:"relative",transition:"transform 0.15s ease-out",transform:`translate(${offset.x}px, ${offset.y}px)`,zIndex:1}}>Plus tard</button>;
    };

    function App() {
      const [mode,          setMode]         = useState(null); // null | "optimize" | "advise"
      const [step,          setStep]         = useState(1);
      const [cat,           setCat]          = useState("text");
      const [request,       setRequest]      = useState("");
      const [taskType,      setTaskType]     = useState("redaction");
      const [taskType2,     setTaskType2]    = useState(null);
      const [model,         setModel]        = useState(null);
      const [questions,     setQs]           = useState([]);
      const [answers,       setAs]           = useState([]);
      const [aLoading,      setAL]           = useState({});
      const [allAL,         setAAL]          = useState(false);
      const [prompt,        setPrompt]       = useState("");
      const [extraInfo,     setExtraInfo]    = useState("");
      const [loading,       setLoading]      = useState(false);
      const [error,         setError]        = useState("");
      const [copied,        setCopied]       = useState(false);
      const [loaderPhase,   setLoaderPhase]  = useState(null);
      const [apiStatus,     setApiStatus]    = useState("");
      const [debugLog,      setDebugLog]     = useState([]);
      const [showDebug,     setShowDebug]    = useState(false);
      const [showSettings,  setShowSettings] = useState(null); // null | "api" | "ctx" | "models" | "debug"
      const [showTerminal,  setShowTerminal] = useState(false); // overlay terminal Claude Code (admin only)
      const [apiProvider,   setApiProvider]  = useState("claude");
      const [apiKey,        setApiKey]       = useState("");
      const [apiModel,      setApiModel]     = useState("");
      const [allProviders,  setAllProviders] = useState({});
      const [enabled,       setEnabled]      = useState(() => Object.fromEntries(ALL_IDS.map(id => [id,true])));
      const [ctx,           setCtx]          = useState("");
      const [ctxDraft,      setCtxDraft]     = useState("");
      const [ready,         setReady]        = useState(false);
      const [authToken,     setAuthToken]    = useState(() => localStorage.getItem("po:token") || "");
      const [currentUser,   setCurrentUser]  = useState(null);
      const [adviseChecked, setAdviseChecked]= useState({});
      const [adviseRecs,    setAdviseRecs]   = useState([]);
      /* ── Bibliothèque ── */
      const [library,       setLibrary]      = useState([]);
      const [libCategories, setLibCategories]= useState([...DEFAULT_LIB_CATEGORIES]);
      const [libFilter,     setLibFilter]    = useState("all");  // catégorie
      const [libFilterModel,setLibFilterModel]= useState("all"); // modèle recommandé
      const [libFilterRating,setLibFilterRating]= useState(0);   // note min (0 = tous)
      const [libSort,       setLibSort]      = useState("title"); // title | rating | model | category
      const [libSelected,   setLibSelected]  = useState(null);
      const [libEditing,    setLibEditing]   = useState(null);
      const [libShowEdit,   setLibShowEdit]  = useState(false);
      const [libShowAddCat, setLibShowAddCat]= useState(false);
      const [libVars,       setLibVars]      = useState({});
      const [libCopied,     setLibCopied]    = useState(false);
      const [libViewMode,  setLibViewMode]  = useState("list"); // list | grid | compact
      const [libExpanded,  setLibExpanded]  = useState({});      // {id: true/false}
      const [libSidebarOpen, setLibSidebarOpen] = useState(false);
      const libCatMap = Object.fromEntries(libCategories.map(c => [c.id, c]));
      const isInitialLoad = useRef(true);
      const cancelRef = useRef(false);
      const [confirmAction, setConfirmAction] = useState(null); // { message, onConfirm }
      const askConfirm = (message, onConfirm) => setConfirmAction({ message, onConfirm });
      const [showRating, setShowRating] = useState(false);
      const [ratingStars, setRatingStars] = useState(0);
      const [ratingMsg, setRatingMsg] = useState(null); // "reject" | "accept"

      /* ── Injection CSS fonts ── */
      useEffect(() => {
        const el = document.createElement("style"); el.textContent = FONTS_CSS;
        document.head.appendChild(el); return () => el.remove();
      }, []);

      /* ── Rafraîchir le profil utilisateur (is_admin, etc.) ── */
      useEffect(() => {
        if (!authToken) return;
        apiFetch("/auth/me").then(data => {
          if (data.user) { setCurrentUser(data.user); rememberAccount(authToken, data.user); }
        }).catch(() => {});
      }, [authToken]);

      /* ── Chargement depuis le backend ── */
      useEffect(() => {
        if (!authToken) return;
        (async () => {
          try {
            const [configData, promptsData, catsData] = await Promise.all([
              apiFetch("/keys/config"),
              apiFetch("/prompts"),
              apiFetch("/prompts/categories"),
            ]);
            // API keys & settings
            const providers = configData.providers || {};
            setAllProviders(providers);
            const firstProvider = Object.keys(providers)[0];
            if (firstProvider) {
              setApiProvider(firstProvider);
              setApiKey(providers[firstProvider].key || "");
              setApiModel(providers[firstProvider].model || "");
            }
            if (configData.ctx) { setCtx(configData.ctx); setCtxDraft(configData.ctx); }
            if (configData.enabled && Object.keys(configData.enabled).length) setEnabled(prev => ({...prev, ...configData.enabled}));
            if (configData.lastBackup) setLastBackup(configData.lastBackup);
            if (configData.showDebug) setShowDebug(true);
            // Prompts
            const saved = promptsData.prompts || [];
            // Toujours inclure les built-in, fusionnés avec les prompts sauvegardés
            const savedIds = new Set(saved.map(p => p.id));
            const missingBuiltIn = DEFAULT_PROMPTS.filter(p => !savedIds.has(p.id));
            setLibrary([...missingBuiltIn, ...saved]);
            // Categories
            if (catsData.categories?.length) setLibCategories(catsData.categories);
          } catch (e) { console.error("Load error:", e); }
          setReady(true);
        })();
      }, [authToken]);

      /* ── Premier lancement : ouvrir la config API si aucune clé ── */
      useEffect(() => {
        if (!ready) return;
        if (!apiKey.trim()) setShowSettings("api");
      }, [ready]);

      /* ── Sauvegarde vers le backend (debounced) ── */
      const saveTimerRef = useRef(null);
      const saveToBackend = (fn) => {
        if (!ready || isInitialLoad.current || !authToken) return;
        clearTimeout(saveTimerRef.current);
        saveTimerRef.current = setTimeout(fn, 800);
      };

      useEffect(() => {
        saveToBackend(() => apiFetch("/settings", { method: "PUT", body: JSON.stringify({ context: ctx }) }).catch(() => {}));
      }, [ctx, ready]);

      useEffect(() => {
        saveToBackend(() => apiFetch("/settings", { method: "PUT", body: JSON.stringify({ enabled_models: enabled }) }).catch(() => {}));
      }, [enabled, ready]);

      useEffect(() => {
        if (!ready || isInitialLoad.current || !authToken) return;
        // Save all prompts in bulk
        const timer = setTimeout(() => {
          apiFetch("/prompts/bulk", { method: "POST", body: JSON.stringify({ prompts: library, categories: libCategories }) }).catch(() => {});
        }, 1200);
        return () => clearTimeout(timer);
      }, [library, ready]);

      useEffect(() => {
        if (!ready || isInitialLoad.current || !authToken) return;
        const timer = setTimeout(() => {
          apiFetch("/prompts/bulk", { method: "POST", body: JSON.stringify({ prompts: [], categories: libCategories }) }).catch(() => {});
        }, 1200);
        return () => clearTimeout(timer);
      }, [libCategories, ready]);

      useEffect(() => {
        if (!ready || isInitialLoad.current || !authToken) return;
        const timer = setTimeout(() => {
          apiFetch(`/keys/${apiProvider}`, { method: "PUT", body: JSON.stringify({ key: apiKey, model: apiModel }) }).catch(() => {});
          setAllProviders(prev => ({ ...prev, [apiProvider]: { key: apiKey, model: apiModel } }));
        }, 1200);
        return () => clearTimeout(timer);
      }, [apiProvider, apiKey, apiModel, ready]);

      /* ── Désactiver le flag après les effets de sauvegarde ── */
      useEffect(() => {
        if (ready && isInitialLoad.current) isInitialLoad.current = false;
      }, [ready]);

      /* ── Auth handlers ── */
      const handleAuth = (token, user) => { rememberAccount(token, user); setAuthToken(token); setCurrentUser(user); };
      const handleLogout = () => {
        if (currentUser) forgetAccount(currentUser.id);
        localStorage.removeItem("po:token");
        setAuthToken(""); setCurrentUser(null); setReady(false);
        setApiKey(""); setApiProvider("claude"); setApiModel("");
        setLibrary([]); setCtx(""); setCtxDraft("");
      };

      /* ── Export/Import complet de toutes les données ── */
      const exportAllData = () => {
        const data = {
          version: "1.0",
          exportDate: new Date().toISOString(),
          config: { provider: apiProvider, key: apiKey, model: apiModel, ctx, enabled },
          library,
          categories: libCategories,
        };
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = url; a.download = `prompt-optimizer-backup-${new Date().toISOString().slice(0,10)}.json`; a.click();
        URL.revokeObjectURL(url);
        const now = new Date().toISOString();
        setLastBackup(now);
        apiFetch("/settings", { method: "PUT", body: JSON.stringify({ last_backup: now }) }).catch(() => {});
      };

      const [importPreview, setImportPreview] = useState(null);
      const [importChecks, setImportChecks] = useState({ config:true, library:true, categories:true });
      const [lastBackup, setLastBackup] = useState("");
      const [successMsg, setSuccessMsg] = useState("");
      const [showHelpJoke, setShowHelpJoke] = useState(false);

      const startImportAll = () => {
        const input = document.createElement("input"); input.type = "file"; input.accept = ".json";
        input.onchange = async (e) => {
          const file = e.target.files[0]; if (!file) return;
          try {
            const text = await file.text();
            const data = JSON.parse(text);
            if (!data.version && !data.config && !data.library) throw new Error("Format non reconnu");
            setImportPreview(data);
            setImportChecks({ config: !!data.config, library: !!data.library, categories: !!data.categories });
          } catch(_) { setError("Fichier invalide. Utilise un export Prompt Optimizer."); }
        };
        input.click();
      };

      const confirmImportAll = () => {
        if (!importPreview) return;
        if (importChecks.config && importPreview.config) {
          const c = importPreview.config;
          if (c.provider) setApiProvider(c.provider);
          if (c.key) setApiKey(c.key);
          if (c.model) setApiModel(c.model);
          if (c.ctx) { setCtx(c.ctx); setCtxDraft(c.ctx); }
          if (c.enabled) setEnabled(prev => ({...prev, ...c.enabled}));
        }
        if (importChecks.categories && importPreview.categories) {
          setLibCategories(importPreview.categories);
        }
        if (importChecks.library && importPreview.library) {
          setLibrary(importPreview.library);
        }
        setImportPreview(null);
        setSuccessMsg("Restauration effectuée avec succès !");
        setTimeout(() => setSuccessMsg(""), 4000);
      };


      /* ── Placeholders dynamiques selon contexte utilisateur ── */
      const placeholders = React.useMemo(() => {
        if (!ctx.trim()) return {
          context: "Ex : Je suis chef de projet dans une startup tech. J'utilise l'IA pour rédiger des specs et analyser des données. Je travaille en français.",
          text: "Ex : Je veux rédiger un email professionnel pour relancer un client qui n'a pas répondu à mon devis...",
          image: "Ex : Une illustration minimaliste d'un bureau de travail moderne, tons pastel, vue en plongée...",
          adviseText: "Ex : Je veux rédiger un article de blog sur les tendances de mon secteur...",
          adviseImage: "Ex : Une affiche promotionnelle pour un événement professionnel...",
        };
        const c = ctx.trim().toLowerCase();
        const words = c.slice(0, 120);
        return {
          context: `Ex : ${ctx.slice(0, 180)}${ctx.length > 180 ? "…" : ""}`,
          text: `Ex : Je veux créer un contenu en lien avec mon activité (${words.length > 80 ? words.slice(0, 80) + "…" : words})...`,
          image: `Ex : Une image professionnelle en rapport avec mon activité...`,
          adviseText: `Ex : Je veux produire un document pour mon activité...`,
          adviseImage: `Ex : Un visuel professionnel pour mon activité...`,
        };
      }, [ctx]);

      /* ── Navigation modes ── */
      const restart = () => { setMode(null); setStep(1); setRequest(""); setModel(null); setQs([]); setAs([]); setPrompt(""); setError(""); setTaskType("redaction"); setTaskType2(null); setExtraInfo(""); setAdviseRecs([]); setLibSelected(null); setLibShowEdit(false); setLibFilter("all"); };
      const enterOptimize = () => { setMode("optimize"); setStep(1); setRequest(""); setModel(null); setQs([]); setAs([]); setPrompt(""); setError(""); setTaskType("redaction"); };
      const enterAdvise = () => {
        setMode("advise"); setStep(1); setRequest(""); setError(""); setAdviseRecs([]);
        const init = {}; ALL_IDS.forEach(id => { init[id] = enabled[id] !== false; }); setAdviseChecked(init);
      };
      const enterLibrary = () => { setMode("library"); setLibSelected(null); setLibShowEdit(false); setLibFilter("all"); setError(""); };

      /* ── Bibliothèque : CRUD ── */
      const libSave = (p) => {
        if (p.id) {
          setLibrary(prev => prev.map(x => x.id === p.id ? p : x));
        } else {
          setLibrary(prev => [...prev, { ...p, id: "lib_user_" + Date.now(), builtIn: false }]);
        }
        setLibShowEdit(false); setLibEditing(null);
      };
      const libDelete = (id) => {
        setLibrary(prev => prev.filter(p => p.id !== id));
        if (libSelected?.id === id) setLibSelected(null);
      };
      const libUse = (p) => {
        setLibSelected(p);
        const vars = {};
        (p.variables || []).forEach(v => { vars[v] = ""; });
        setLibVars(vars);
        setLibCopied(false);
      };
      const libGetFilled = () => {
        if (!libSelected) return "";
        let text = libSelected.prompt;
        Object.entries(libVars).forEach(([k,v]) => {
          text = text.replace(new RegExp(`\\{${k}\\}`, "g"), v || `{${k}}`);
        });
        return text;
      };
      const libRate = (id, rating) => {
        setLibrary(prev => prev.map(p => p.id === id ? {...p, rating} : p));
        if (libSelected?.id === id) setLibSelected(prev => ({...prev, rating}));
      };
      const libAddCategory = (label, icon, color) => {
        const id = label.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9]/g,"_");
        if (libCategories.find(c => c.id === id)) return id;
        setLibCategories(prev => [...prev, {id, label, icon, color}]);
        return id;
      };
      const libDeleteCategory = (catId) => {
        setLibCategories(prev => prev.filter(c => c.id !== catId));
        /* Reclasser les prompts orphelins dans la première catégorie restante */
        setLibrary(prev => prev.map(p => p.category === catId ? {...p, category: libCategories.find(c=>c.id!==catId)?.id || "challenge"} : p));
        if (libFilter === catId) setLibFilter("all");
      };
      const analyzePromptForModel = async (promptText, availableModels) => {
        const modList = availableModels.map(m => {
          const scores = Object.entries(SCORING_MATRIX).map(([task, models]) => models[m.id] ? `${task}:${models[m.id].s}/5` : null).filter(Boolean).join(", ");
          return `${m.id}: ${m.name} (${m.platform}, mode ${m.mode}) — Scores: ${scores}`;
        }).join("\n");
        const sys = `Tu es un classificateur déterministe. On te donne un prompt et des modèles avec leurs scores par type de tâche.

PROCÉDURE STRICTE :
1. Identifie le type de tâche principal du prompt (redaction, analyse, code, recherche, raisonnement, transformation).
2. Parmi les modèles disponibles, prends celui qui a le score le plus élevé pour ce type de tâche.
3. En cas d'égalité : privilégie le modèle en mode thinking pour les tâches complexes, le mode standard pour les tâches simples.

RÉPONSE : Uniquement l'ID du modèle choisi. Rien d'autre. Pas d'explication.`;
        const result = await api(sys, `Prompt :\n${promptText}\n\nModèles disponibles :\n${modList}`, 30);
        const trimmed = result.trim().replace(/["`'\s]/g,"");
        if (availableModels.find(m => m.id === trimmed)) return trimmed;
        const partial = availableModels.find(m => trimmed.includes(m.id));
        return partial ? partial.id : null;
      };
      /* ── Export/Import prompts ── */
      const libExport = () => {
        const data = JSON.stringify({ prompts: library, categories: libCategories, exportDate: new Date().toISOString() }, null, 2);
        const blob = new Blob([data], { type: "application/json" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a"); a.href = url; a.download = `prompts-export-${new Date().toISOString().slice(0,10)}.json`; a.click();
        URL.revokeObjectURL(url);
      };
      const [libImportData, setLibImportData] = useState(null); // {prompts:[], categories:[]}
      const [libImportChecked, setLibImportChecked] = useState({});
      const libStartImport = () => {
        const input = document.createElement("input"); input.type = "file"; input.accept = ".json";
        input.onchange = async (e) => {
          const file = e.target.files[0]; if (!file) return;
          try {
            const text = await file.text();
            const data = JSON.parse(text);
            const prompts = data.prompts || data; // support tableau brut ou objet {prompts, categories}
            if (!Array.isArray(prompts)) throw new Error("Format invalide");
            const checked = {};
            prompts.forEach(p => { checked[p.id || p.title] = true; });
            setLibImportData({ prompts, categories: data.categories || [] });
            setLibImportChecked(checked);
          } catch(_) { setError("Fichier invalide. Utilise un export JSON de Prompt Optimizer."); }
        };
        input.click();
      };
      const libConfirmImport = () => {
        if (!libImportData) return;
        const toImport = libImportData.prompts.filter(p => libImportChecked[p.id || p.title]);
        const existingIds = library.map(p => p.id);
        const newPrompts = toImport.map(p => {
          if (existingIds.includes(p.id)) return { ...p, id: "lib_import_" + Date.now() + "_" + Math.random().toString(36).slice(2,6), builtIn: false };
          return { ...p, builtIn: false };
        });
        setLibrary(prev => [...prev, ...newPrompts]);
        /* Importer les catégories manquantes */
        if (libImportData.categories?.length) {
          const existingCatIds = libCategories.map(c => c.id);
          const newCats = libImportData.categories.filter(c => !existingCatIds.includes(c.id));
          if (newCats.length) setLibCategories(prev => [...prev, ...newCats]);
        }
        setLibImportData(null); setLibImportChecked({});
      };

      const libCopy = () => {
        const text = libGetFilled();
        const doSuccess = () => { setLibCopied(true); setTimeout(() => setLibCopied(false), 2000); };
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(text).then(doSuccess).catch(() => {
            try { const ta=document.createElement("textarea");ta.value=text;ta.style.cssText="position:fixed;opacity:0";document.body.appendChild(ta);ta.focus();ta.select();document.execCommand("copy");document.body.removeChild(ta);doSuccess(); } catch(_) {}
          });
        }
      };
      const cancelAll = () => {
        cancelRef.current = true; setLoaderPhase(null); setLoading(false); setAAL(false);
        setApiStatus(""); log("Annulé par l'utilisateur"); setError("Opération annulée.");
      };

      /* ── Debug logger ── */
      const log = (msg) => setDebugLog(p => [...p, `${new Date().toLocaleTimeString()} — ${msg}`]);

      /* ── Modèle effectif utilisé pour les appels API ── */
      const getEffectiveModel = () => {
        const prov = API_PROVIDERS.find(p => p.id === apiProvider);
        if (!prov) return PROV_DEFAULT_MODEL[apiProvider] || "";
        const valid = prov.models.find(m => m.id === apiModel);
        return valid ? apiModel : (prov.models[0]?.id || PROV_DEFAULT_MODEL[apiProvider] || "");
      };

      /* ── Appel API unitaire par provider ── */
      const callProvider = async (sys, user, maxTok) => {
        const prov = apiProvider;
        const modelId = getEffectiveModel();

        if (prov === "claude") {
          const r = await fetch("https://api.anthropic.com/v1/messages", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "x-api-key": apiKey,
              "anthropic-version": "2023-06-01",
              "anthropic-dangerous-direct-browser-access": "true",
            },
            body: JSON.stringify({ model: modelId, max_tokens: maxTok, system: sys, messages: [{ role: "user", content: user }] }),
          });
          const d = await r.json();
          if (d.error) throw new Error(d.error.message || JSON.stringify(d.error));
          const block = d.content?.find(b => b.type === "text");
          if (!block) throw new Error("Pas de réponse texte (Claude)");
          return { text: block.text, model: d.model || modelId, inTok: d.usage?.input_tokens, outTok: d.usage?.output_tokens };
        }

        if (prov === "openai") {
          const r = await fetch("https://api.openai.com/v1/chat/completions", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiKey}` },
            body: JSON.stringify({ model: modelId, max_completion_tokens: maxTok, messages: [{ role: "system", content: sys }, { role: "user", content: user }] }),
          });
          const d = await r.json();
          if (d.error) throw new Error(d.error.message || JSON.stringify(d.error));
          const txt = d.choices?.[0]?.message?.content;
          if (!txt) throw new Error("Pas de réponse texte (OpenAI)");
          return { text: txt, model: d.model || modelId, inTok: d.usage?.prompt_tokens, outTok: d.usage?.completion_tokens };
        }

        if (prov === "mistral") {
          const r = await fetch("https://api.mistral.ai/v1/chat/completions", {
            method: "POST",
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${apiKey}` },
            body: JSON.stringify({ model: modelId, max_tokens: maxTok, messages: [{ role: "system", content: sys }, { role: "user", content: user }] }),
          });
          const d = await r.json();
          if (d.error) throw new Error(d.error.message || JSON.stringify(d.error));
          const txt = d.choices?.[0]?.message?.content;
          if (!txt) throw new Error("Pas de réponse texte (Mistral)");
          return { text: txt, model: d.model || modelId, inTok: d.usage?.prompt_tokens, outTok: d.usage?.completion_tokens };
        }

        if (prov === "gemini") {
          const r = await fetch(`https://generativelanguage.googleapis.com/v1beta/models/${modelId}:generateContent?key=${apiKey}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              system_instruction: { parts: [{ text: sys }] },
              contents: [{ role: "user", parts: [{ text: user }] }],
              generationConfig: { maxOutputTokens: maxTok },
            }),
          });
          const d = await r.json();
          if (d.error) throw new Error(d.error.message || JSON.stringify(d.error));
          const txt = d.candidates?.[0]?.content?.parts?.[0]?.text;
          if (!txt) throw new Error("Pas de réponse texte (Gemini)");
          return { text: txt, model: d.modelVersion || modelId, inTok: d.usageMetadata?.promptTokenCount, outTok: d.usageMetadata?.candidatesTokenCount };
        }

        throw new Error(`Provider inconnu : ${prov}`);
      };

      /* ── api() : appel unique, pas de retry ── */
      const api = async (sys, user, maxTok = 1000) => {
        const provLabel = PROV_LABELS[apiProvider] || apiProvider;
        const modelLabel = getEffectiveModel();
        cancelRef.current = false;
        log(`API → ${provLabel} [${modelLabel}] | sys ${sys.length}c | user ${user.length}c | max_tokens ${maxTok}`);
        if (cancelRef.current) throw new Error("Annulé.");
        setApiStatus(`${provLabel} — appel en cours…`);
        const t0 = Date.now();
        try {
          const res = await callProvider(sys, user, maxTok);
          log(`  OK en ${Date.now()-t0}ms — ${res.model} — ${res.text.length}c (in:${res.inTok} out:${res.outTok})`);
          setApiStatus("");
          return res.text;
        } catch(e) {
          log(`  ERREUR en ${Date.now()-t0}ms : ${e.message}`);
          setApiStatus("");
          throw e;
        }
      };

      /* ── Parsing JSON robuste ── */
      const safeParseJSON = (txt) => {
        const clean = txt.replace(/```json\n?|```/g, "").trim();
        const os = clean.indexOf("{"), oe = clean.lastIndexOf("}");
        if (os !== -1 && oe > os) { try { return JSON.parse(clean.slice(os, oe+1)); } catch(_) {} }
        const as = clean.indexOf("["), ae = clean.lastIndexOf("]");
        if (as !== -1 && ae > as) { try { return JSON.parse(clean.slice(as, ae+1)); } catch(_) {} }
        return null;
      };

      /* ── Classification par LLM — pas de fallback, erreur si échec ── */
      const classifyWithAPI = async (text) => {
        const sys = `Tu es un classificateur de tâches. Analyse la demande utilisateur et détermine le ou les types de tâche.

TYPES DISPONIBLES (exactement ces valeurs) :
- redaction : écriture, copywriting, newsletters, posts, pages de vente, emails, contenus éditoriaux
- analyse : évaluation, comparaison, diagnostic, audit, mesure, matrices, SWOT, décryptage
- code : programmation, scripts, fonctions, API, debug, algorithmes, refactoring
- recherche : investigation, veille, état de l'art, rapport de recherche, deep research, sources multiples
- image : génération d'image, illustration, photo, design visuel
- raisonnement : logique, résolution de problèmes, réflexion, philosophie, argumentation, éthique, dilemmes
- transformation : conversion, traduction, reformulation, simplification, résumé, adaptation, réécriture

RÈGLES :
1. Si la demande combine deux types (ex : "recherche puis rédige un rapport"), indique les deux.
2. Le type PRIMARY est celui qui domine la demande.
3. Le type SECONDARY est optionnel — seulement si la demande est clairement hybride.

RÉPONSE : JSON uniquement, rien d'autre.
{"primary":"type","secondary":"type_ou_null"}`;
        const txt = await api(sys, `Demande : ${text}`, 100);
        const parsed = safeParseJSON(txt);
        if (!parsed || !parsed.primary) throw new Error("Échec de la classification de la demande. Vérifie ta clé API.");
        const valid = ["redaction","analyse","code","recherche","image","raisonnement","transformation"];
        if (!valid.includes(parsed.primary)) throw new Error(`Type de tâche non reconnu : "${parsed.primary}". Réessaie.`);
        return {
          primary: parsed.primary,
          secondary: parsed.secondary && valid.includes(parsed.secondary) ? parsed.secondary : null
        };
      };

      /* ── Build system prompt — 4 à 7 couches selon options ── */
      const buildSys = (m, tt, opts = {}) => {
        const t = tt || taskType;
        const layers = [
          SOCLE_UNIVERSEL,
          MODULES_TACHE[t] || MODULES_TACHE.redaction,
          FICHES_PLATEFORME[m.platform_key] || "",
          SNIPPETS_MODE[m.mode] || SNIPPETS_MODE.standard,
        ];
        if (opts.antiPatterns) layers.push(ANTI_PATTERNS[m.platform_key] || "");
        if (opts.paradigm) {
          const isReasoning = ["thinking","deep_research"].includes(m.mode);
          layers.push(isReasoning ? PARADIGM_RULES.reasoning : PARADIGM_RULES.standard);
        }
        if (opts.exemplars && EXEMPLARS?.[m.platform_key]?.[t]) {
          layers.push(EXEMPLARS[m.platform_key][t]);
        }
        return layers.filter(Boolean).join("\n\n---\n\n");
      };

      /* ── Génération des questions (Mode Optimize → step 2) ── */
      const genQuestionsForOptimize = async (m) => {
        setModel(m); setLoading(true); setError(""); setLoaderPhase("questions");
        try {
          const ctxPart = ctx.trim() ? `\nContexte utilisateur : ${ctx}` : "";
          const classification = cat === "image" ? { primary: "image", secondary: null } : await classifyWithAPI(request);
          const tt = classification.primary;
          setTaskType(tt);
          setTaskType2(classification.secondary);
          const isReasoning = ["thinking","deep_research"].includes(m.mode);
          const secondaryModule = classification.secondary ? (MODULES_TACHE[classification.secondary] || "") : "";
          const sys = buildSys(m, tt, { antiPatterns: true, paradigm: true }) + (secondaryModule ? `\n\n---\n\n${secondaryModule}` : "") + `\n\n---\n\nMISSION : ANALYSE DE LA DEMANDE ET QUESTIONS DE CLARIFICATION

Tu prépares un prompt optimisé pour **${m.name}** (${m.platform}, mode ${m.mode}).
Type de tâche détecté : **${tt}**.

ÉTAPE 1 — ANALYSE DE COMPLÉTUDE
Examine la demande de l'utilisateur et évalue ce qui est déjà présent vs ce qui manque, en te basant sur les **champs prioritaires** du module de tâche injecté ci-dessus.

Pour chaque champ prioritaire du module, détermine :
- Est-il déjà renseigné (explicitement ou implicitement) dans la demande ? → PAS de question.
- Est-il absent ET nécessaire pour produire un prompt de qualité ? → Question.
- Est-il absent mais non essentiel (le modèle peut inférer un bon défaut) ? → PAS de question.

ÉTAPE 2 — GÉNÉRATION DES QUESTIONS (uniquement celles qui sont nécessaires)
- Nombre de questions : entre 1 et 8 selon ce qui MANQUE réellement.
  - Demande déjà complète et bien structurée → 1 à 2 questions (sur le format de sortie ou le niveau de profondeur souhaité — il y a toujours au moins une préférence à clarifier).
  - Demande partielle mais claire → 2 à 4 questions sur les manques.
  - Demande vague ou ambiguë → 4 à 8 questions pour couvrir les champs critiques.
- Il doit TOUJOURS y avoir au moins 1 question. Même une demande parfaite peut être affinée (format, longueur, ton, niveau de détail).
- NE JAMAIS poser une question dont la réponse est déjà dans la demande.
- NE JAMAIS poser une question juste pour "remplir" — chaque question doit apporter une information qui changera concrètement le prompt généré.
- NE JAMAIS reformuler la demande sous forme de question (ex : si l'utilisateur dit "écris un article sur X", ne pas demander "Sur quel sujet veux-tu un article ?").

RÈGLES SPÉCIFIQUES :
1. Chaque question doit cibler un **champ prioritaire manquant** du module de tâche.
2. Les questions doivent être **informées par les anti-patterns** de la plateforme.${isReasoning ? `
3. MODE RAISONNEMENT : NE PAS demander d'exemples à inclure (few-shot contre-productif). Demander plutôt les critères de réussite et les contraintes.` : `
3. MODE STANDARD : Demander si l'utilisateur a des exemples du résultat attendu (le few-shot est efficace dans ce mode).`}
4. Pour les modes deep_research : demander le périmètre (temporel, géographique, disciplinaire) et ce que l'utilisateur sait déjà.
5. Questions concrètes et actionnables — pas de questions philosophiques ou évidentes.
6. En français, ton direct et bienveillant.

FORMAT : tableau JSON de strings uniquement — ["Question ?","Question ?"]`;
          const txt = await api(sys, `Demande : ${request}${ctxPart}`, 700);
          const parsed = safeParseJSON(txt);
          const raw = Array.isArray(parsed) ? parsed : (parsed ? Object.values(parsed) : []);
          const qs = raw.map(q => {
            if (typeof q === "string") return q;
            if (typeof q === "object" && q !== null) return q.question||q.text||q.label||Object.values(q).find(v=>typeof v==="string"&&v.length>5)||"";
            return String(q);
          }).filter(q => q.length > 0);
          if (qs.length === 0) throw new Error("Aucune question générée. Réessaie.");
          setQs(qs); setAs(new Array(qs.length).fill("")); setStep(2);
        } catch(e) { setError(e.message || "Erreur génération des questions. Réessaie."); }
        finally { setLoaderPhase(null); setLoading(false); }
      };

      /* ── Transition Advise → Optimize avec un modèle ── */
      const continueWithModel = (m) => {
        setMode("optimize"); setStep(1); setModel(m); setPrompt(""); setError(""); setQs([]); setAs([]); setExtraInfo("");
      };

      /* ── Analyse pour le mode Conseiller ── */
      const analyzeForAdvise = async () => {
        if (!request.trim()) return;
        if (!apiKey.trim()) { setShowSettings("api"); return; }
        setLoading(true); setError(""); setAdviseRecs([]); setLoaderPhase("analyze");
        try {
          const classification = cat === "image" ? { primary: "image", secondary: null } : await classifyWithAPI(request);
          const tt = classification.primary;
          setTaskType(tt);
          const checkedModels = ALL_MODELS.filter(m => m.cat === cat && adviseChecked[m.id] !== false);
          if (!checkedModels.length) { setError("Sélectionne au moins un modèle."); setLoaderPhase(null); setLoading(false); return; }
          const preScored = checkedModels
            .map(m => ({ ...m, baseScore: SCORING_MATRIX[tt]?.[m.id]?.s || 0, staticReason: SCORING_MATRIX[tt]?.[m.id]?.d || "" }));
          const ctxPart = ctx.trim() ? `\nContexte : ${ctx}` : "";
          const modList = preScored.map(m => `${m.id} (score de base: ${m.baseScore}/5): ${m.staticReason}`).join("\n");
          const txt = await api(
            `Tu es un conseiller expert qui aide à choisir le meilleur modèle IA pour une demande précise.

MISSION : Pour chaque modèle, attribue un score de pertinence de 0 à 5 pour CETTE demande spécifique. Puis écris UNE phrase expliquant ton verdict.

IMPORTANT — Le score doit refléter ton VERDICT, pas une capacité générale. Si tu écris qu'un modèle "convient mal" ou est "surdimensionné", son score DOIT être bas (1-2). Si tu écris qu'un modèle est "idéal" ou "parfait", son score DOIT être élevé (4-5). Le score et la raison doivent être COHÉRENTS.

GRILLE DE SCORING :
- 5 = Choix idéal pour cette demande précise
- 4 = Très bon choix, fonctionne bien
- 3 = Acceptable mais pas optimal
- 2 = Fonctionne mais surdimensionné, trop lent, ou sous-optimal
- 1 = Inadapté ou très mauvais rapport effort/résultat
- 0 = Incapable de réaliser cette tâche

CRITÈRES DE JUGEMENT :
- Proportionnalité : un outil lourd (Deep Research 5-30 min) pour une question simple = score bas (1-2), même si l'outil est puissant.
- Accès web : si la demande nécessite des données récentes et que le modèle n'a pas d'accès web = score 0-1.
- Rapidité : à qualité égale, le plus rapide l'emporte.
- Langue : si rédaction en français, Claude > GPT > Gemini.
- Complexité : réserver les scores élevés aux modèles dont la puissance est réellement nécessaire.

FORMAT JSON STRICT — un tableau d'objets :
[{"id":"model_id","score":4,"reason":"Explication courte"},...]

Respecter l'ORDRE des modèles fournis. Un objet par modèle. CHAQUE modèle doit avoir un score COHÉRENT avec sa raison.
IMPORTANT : Chaque raison doit faire MAXIMUM 15 mots. Sois concis.`,
            `Demande : ${request}${ctxPart}\n\nModèles :\n${modList}`,
            1500
          );
          const parsed = safeParseJSON(txt);
          const aiResults = Array.isArray(parsed) ? parsed : [];
          if (!aiResults.length) throw new Error("Échec de l'analyse des modèles. Vérifie ta clé API.");
          const finalRecs = preScored.map((m, i) => {
            const aiResult = aiResults.find(r => r.id === m.id) || aiResults[i] || {};
            const adjustedScore = typeof aiResult.score === "number" ? Math.max(0, Math.min(5, aiResult.score)) : m.baseScore;
            return { model: m, score: adjustedScore, reason: aiResult.reason || m.staticReason };
          }).sort((a, b) => b.score - a.score);
          setAdviseRecs(finalRecs);
          setStep(2);
        } catch(e) { setError(e.message || "Erreur analyse. Réessaie."); }
        finally { setLoaderPhase(null); setLoading(false); }
      };

      /* ── Auto-réponse individuelle ── */
      const autoOne = async (idx) => {
        setAL(p => ({...p,[idx]:true}));
        try {
          const sys = `Réponds en 1-2 phrases concises en français. UNIQUEMENT la réponse, sans intro.`;
          const userCtx = ctx.trim() ? `\nContexte utilisateur : ${ctx}` : "";
          const ans = await api(sys, `Contexte : prompt pour ${model?.name} (${taskType}).${userCtx}\nDemande initiale : ${request}\nQuestion : ${questions[idx]}`, 200);
          setAs(p => { const n=[...p]; n[idx]=ans.trim(); return n; });
        } catch(e) { setError(e.message || `Erreur sur la question ${idx+1}.`); }
        setAL(p => ({...p,[idx]:false}));
      };

      /* ── Auto-réponse toutes ── */
      const autoAll = async () => {
        setAAL(true); setLoaderPhase("autoall");
        try {
          const qList = questions.map((q,i) => `${i+1}. ${q}`).join("\n");
          const sys = `Réponds à chaque question en 1-2 phrases concises en français. JSON uniquement : ["rep1","rep2",...]`;
          const userCtx = ctx.trim() ? `\nContexte utilisateur : ${ctx}` : "";
          const txt = await api(sys, `Contexte : prompt pour ${model?.name} (${taskType}).${userCtx}\nDemande : ${request}\n\nQuestions :\n${qList}`, 600);
          const parsed = safeParseJSON(txt);
          const raw = Array.isArray(parsed) ? parsed : (parsed ? Object.values(parsed) : []);
          setAs(prev => {
            const next = [...prev];
            raw.forEach((a, i) => { if (i < next.length) next[i] = (typeof a === "string" ? a : String(a)).trim(); });
            return next;
          });
        } catch(e) { setError(e.message || "Erreur génération des réponses."); }
        finally { setLoaderPhase(null); setAAL(false); }
      };

      /* ── Questions complémentaires basées sur les réponses ── */
      const askMoreQuestions = async () => {
        setLoading(true); setError(""); setLoaderPhase("questions");
        try {
          const ctxPart = ctx.trim() ? `\nContexte utilisateur : ${ctx}` : "";
          const qas = questions.map((q,i) => `Q: ${q}\nR: ${answers[i]||"(non répondu)"}`).join("\n\n");
          const extraPart = extraInfo.trim() ? `\nInformations supplémentaires fournies par l'utilisateur : ${extraInfo}` : "";
          const sys = buildSys(model, taskType, { antiPatterns: true, paradigm: true }) + `\n\n---\n\nMISSION : QUESTIONS COMPLÉMENTAIRES

Tu prépares un prompt optimisé pour **${model.name}** (${model.platform}, mode ${model.mode}).
Type de tâche : **${taskType}**.

L'utilisateur a déjà répondu à des questions de clarification (voir ci-dessous). Analyse ses réponses et détermine s'il reste des informations CRITIQUES manquantes pour produire un prompt de qualité optimale.

RÈGLES :
1. NE PAS reposer des questions déjà posées ou dont la réponse est implicite dans les réponses précédentes.
2. NE poser que 1 à 3 questions MAXIMUM — uniquement celles qui apporteraient une amélioration concrète au prompt.
3. Si les réponses sont déjà suffisantes, renvoyer un tableau vide [].
4. Questions concrètes, actionnables, en français.

FORMAT : tableau JSON de strings uniquement — ["Question ?","Question ?"] ou []`;
          const txt = await api(sys, `Demande initiale : ${request}${ctxPart}${extraPart}\n\nQuestions et réponses précédentes :\n${qas}`, 400);
          const parsed = safeParseJSON(txt);
          const raw = Array.isArray(parsed) ? parsed : (parsed ? Object.values(parsed) : []);
          const newQs = raw.map(q => typeof q === "string" ? q : "").filter(q => q.length > 0);
          if (newQs.length === 0) {
            setError("Aucune question complémentaire nécessaire — les réponses sont suffisantes.");
          } else {
            setQs(prev => [...prev, ...newQs]);
            setAs(prev => [...prev, ...new Array(newQs.length).fill("")]);
          }
        } catch(e) { setError(e.message || "Erreur génération des questions complémentaires."); }
        finally { setLoaderPhase(null); setLoading(false); }
      };

      /* ── Vérification post-génération ── */
      const verifyPrompt = async (generatedPrompt, m, tt) => {
        const isReasoning = ["thinking","deep_research"].includes(m.mode);
        const verifySys = `Tu es un vérificateur expert en prompt engineering. Ta mission : vérifier qu'un prompt généré respecte TOUTES les règles de la plateforme cible.

${ANTI_PATTERNS[m.platform_key] || ""}

---

${isReasoning ? PARADIGM_RULES.reasoning : PARADIGM_RULES.standard}

---

${FICHES_PLATEFORME[m.platform_key] || ""}

---

INSTRUCTIONS DE VÉRIFICATION :
1. Vérifie que le prompt ne contient AUCUN anti-pattern listé ci-dessus.
2. Vérifie que le paradigme correct est appliqué (${isReasoning ? "RAISONNEMENT — pas de few-shot, pas de CoT explicite, objectifs et critères" : "STANDARD — instructions explicites, few-shot si pertinent"}).
3. Vérifie la complétude : tous les champs prioritaires du type de tâche "${tt}" sont présents.
4. Vérifie la cohérence : pas de contradictions internes dans le prompt.
5. Vérifie le format : adapté à ${m.platform} — ${m.name}.

RÈGLE ABSOLUE : Tu ne dois JAMAIS remplacer le prompt par un commentaire, un verdict, ou une suggestion de changer de modèle. Ta réponse est TOUJOURS soit "OK" soit un prompt corrigé complet.

RÉPONSE : Si le prompt est correct, réponds EXACTEMENT "OK".
Si le prompt a des problèmes, réponds avec le prompt CORRIGÉ en entier (pas de commentaires, pas d'explication — juste le prompt corrigé complet, prêt à utiliser, avec la note technique après "---").`;

        const result = await api(verifySys, `PROMPT À VÉRIFIER :\n\n${generatedPrompt}`, 4500);
        const trimmed = result.trim();
        if (trimmed === "OK" || trimmed === '"OK"' || trimmed.toLowerCase() === "ok") {
          return generatedPrompt;
        }
        return trimmed;
      };

      /* ── Stratégie de prompt (conditionnel : deep_research ou multi-type) ── */
      const generateStrategy = async (m, tt, tt2, userRequest, ctxPart, qas) => {
        const sys = buildSys(m, tt, { antiPatterns: true, paradigm: true }) + `\n\n---\n\nMISSION : STRATÉGIE DE PROMPT

Tu dois produire une STRATÉGIE de prompt pour **${m.name}** (${m.platform}, mode ${m.mode}).
${m.mode === "deep_research" ? `Ce modèle est un agent de recherche autonome. Le prompt ne sera pas un prompt conversationnel classique — c'est un BRIEF DE RECHERCHE qui sera la seule instruction directrice de l'agent.

La stratégie doit définir :
1. La structure optimale du brief (sections, ordre, hiérarchie)
2. Les dimensions de recherche à couvrir (3-5 max)
3. Le format du livrable attendu
4. Les garde-fous spécifiques (citations, vérification, périmètre)
5. Ce qui doit être inclus dans le contexte connu (pour éviter les recherches redondantes)` : `Ce prompt couvre deux types de tâche : "${tt}" (principal) et "${tt2}" (secondaire).

La stratégie doit définir :
1. L'ordre optimal des parties du prompt (quel type traiter en premier)
2. Comment articuler les deux types sans contradiction
3. Les champs prioritaires à combiner des deux modules de tâche
4. Le format de sortie qui sert les deux objectifs`}

RÉPONSE : La stratégie en 5-10 lignes, concise et directement utilisable par le modèle de génération. Pas de prose — juste les directives.`;

        return await api(sys, `Demande : ${userRequest}${ctxPart}\n\nRéponses Q&A :\n${qas}`, 500);
      };

      /* ── Génération du prompt final ── */
      const generate = async () => {
        setLoading(true); setError(""); setLoaderPhase("generate");
        try {
          const isImg = model.mode === "image";
          const ctxPart = ctx.trim() ? `\nContexte utilisateur : ${ctx}` : "";
          const qas = questions.map((q,i) => `Q: ${q}\nR: ${answers[i]||"(non précisé)"}`).join("\n\n");
          const secondaryMod = taskType2 ? (MODULES_TACHE[taskType2] || "") : "";
          /* ── Appel stratégie conditionnel ── */
          const needsStrategy = model.mode === "deep_research" || taskType2;
          let strategyDirective = "";
          if (needsStrategy) {
            strategyDirective = await generateStrategy(model, taskType, taskType2, request, ctxPart, qas);
          }
          const sys = buildSys(model, null, { antiPatterns: true, paradigm: true, exemplars: true }) + (secondaryMod ? `\n\n---\n\n${secondaryMod}` : "") + (strategyDirective ? `\n\n---\n\nSTRATÉGIE DE PROMPT (à appliquer) :\n${strategyDirective}` : "") + `\n\n---\n\nRÈGLES DE GÉNÉRATION :

RÈGLE ABSOLUE : Tu DOIS TOUJOURS produire un prompt optimisé. Tu n'as JAMAIS le droit de refuser, de suggérer un autre modèle, de dire que la demande est trop simple, ou de produire autre chose qu'un prompt. L'utilisateur a choisi son modèle — ton travail est de créer le MEILLEUR prompt possible pour CE modèle, quelle que soit la demande. Même si la demande semble simple pour le modèle choisi, génère un prompt qui en tirera le meilleur résultat.

1. Respecter scrupuleusement TOUTES les couches injectées — socle, module de tâche, fiche plateforme, snippet de mode, anti-patterns, et règles de paradigme.
2. Prompt prêt à coller dans ${model.platform} — ${model.name}.
3. ${isImg?"Prompt TOUJOURS en anglais.":"Rédiger dans la langue de la demande."}
4. FORMATAGE MARKDOWN : titres (## ###), listes (- ou 1.), **gras**. Structuré et aéré.
5. AUCUN emoji ni symbole décoratif.
6. NE PAS ajouter de titre général — commencer directement.
7. Prompt COMPLET et non tronqué.
8. ANTI-PATTERNS : vérifier que le prompt généré ne contient AUCUN des anti-patterns listés pour cette plateforme. C'est critique.
9. PARADIGME : appliquer strictement le paradigme indiqué (standard OU raisonnement). Ne jamais mélanger.
10. FORMAT DE SORTIE STRICT — respecter cet ordre EXACT :
  a) LE PROMPT À COPIER-COLLER — directement, sans introduction, sans "Voici le prompt", sans explication, sans chaîne de pensée. Juste le prompt brut prêt à coller.
  b) Une ligne "---" seule (séparateur).
  c) Après le séparateur UNIQUEMENT : note technique (2-3 lignes), conseils d'utilisation, remarques sur le prompt. Tout ce qui N'EST PAS le prompt lui-même va APRÈS le séparateur.
11. INTERDIT AVANT LE SÉPARATEUR : toute phrase de type "Voici le prompt optimisé", "Ce prompt est conçu pour...", "Conseils d'utilisation", réflexion sur ta démarche, explication de tes choix. Ces éléments vont APRÈS le "---".`;
          const extraPart = extraInfo.trim() ? `\n\nINFORMATIONS SUPPLÉMENTAIRES DE L'UTILISATEUR :\n${extraInfo}` : "";
          const rawPrompt = await api(sys, `DEMANDE : ${request}${ctxPart}\n\nRÉPONSES :\n${qas}${extraPart}`, 4000);
          /* ── Appel de vérification ── */
          const verified = await verifyPrompt(rawPrompt, model, taskType);
          setPrompt(verified); setStep(3);
        } catch(e) { setError(e.message || "Erreur génération. Réessaie."); }
        finally { setLoaderPhase(null); setLoading(false); }
      };

      /* ── Copier ── */
      const copyPrompt = () => {
        const lastSep = prompt.lastIndexOf("\n---");
        const part = (lastSep > 0 ? prompt.slice(0, lastSep) : prompt).trim();
        const doSuccess = () => { setCopied(true); setTimeout(() => setCopied(false), 2000); };
        if (navigator.clipboard?.writeText) {
          navigator.clipboard.writeText(part).then(doSuccess).catch(() => {
            try { const ta=document.createElement("textarea");ta.value=part;ta.style.cssText="position:fixed;opacity:0";document.body.appendChild(ta);ta.focus();ta.select();document.execCommand("copy");document.body.removeChild(ta);doSuccess(); } catch(_) {}
          });
        } else {
          try { const ta=document.createElement("textarea");ta.value=part;ta.style.cssText="position:fixed;opacity:0";document.body.appendChild(ta);ta.focus();ta.select();document.execCommand("copy");document.body.removeChild(ta);doSuccess(); } catch(_) {}
        }
      };

      /* ── StepBar (mode-aware) ── */
      const STEPS = mode === "optimize"
        ? [{n:1,label:"Modèle & Demande"},{n:2,label:"Affinage"},{n:3,label:"Prompt"}]
        : mode === "advise"
        ? [{n:1,label:"Sélection"},{n:2,label:"Résultat"}]
        : [];
      const StepBar = () => (
        <div style={{display:"flex",alignItems:"center",gap:0,marginBottom:"28px"}}>
          {STEPS.map((s,i) => {
            const done=step>s.n, active=step===s.n;
            return (
              <div key={s.n} style={{display:"flex",alignItems:"center",flex:i<STEPS.length-1?1:"auto"}}>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"5px",minWidth:"60px"}}>
                  <div className="po-step-circle" style={{width:"32px",height:"32px",borderRadius:"50%",display:"flex",alignItems:"center",justifyContent:"center",background:done?C.success:active?C.amber:`${C.amber}18`,border:`2px solid ${done?C.success:active?C.amber:`${C.amber}30`}`,fontSize:done?"15px":"13px",fontWeight:"800",color:done||active?C.navyD:C.muted,transition:"all 0.3s"}}>{done?"✓":s.n}</div>
                  <span className="po-step-label" style={{fontSize:"11px",fontWeight:active?"700":"400",color:active?C.gold:done?C.success:C.muted,whiteSpace:"nowrap"}}>{s.label}</span>
                </div>
                {i<STEPS.length-1&&<div style={{flex:1,height:"2px",background:done?C.success:`${C.amber}20`,margin:"0 4px 16px",transition:"background 0.3s"}}/>}
              </div>
            );
          })}
        </div>
      );

      const lastSepIdx = prompt.lastIndexOf("\n---");
      const mainPrompt = (lastSepIdx > 0 ? prompt.slice(0, lastSepIdx) : prompt).trim();
      const promptNotes = lastSepIdx > 0 ? prompt.slice(lastSepIdx + 4).trim() : "";
      const provModel  = API_PROVIDERS.find(p => p.id === apiProvider)?.models.find(m => m.id === apiModel);
      const headerApiLabel = apiKey.trim()
        ? `✓ ${PROV_LABELS[apiProvider]||apiProvider}${provModel ? " · "+provModel.name.split(" — ")[0] : ""}`
        : "🔌 Configurer API";

      /* ────────────────────── RENDER ────────────────────── */
      const resetToken = new URLSearchParams(window.location.search).get("reset_token");
      if (resetToken) return <ResetPasswordScreen token={resetToken} />;
      if (!authToken) return <AuthScreen onAuth={handleAuth} />;

      return (
        <div style={{minHeight:"100vh",background:C.navy,color:C.cream}}>
          {/* ══ Pop-up notation humoristique ══ */}
          {showRating && ready && (
            <div style={{position:"fixed",inset:0,background:"#000D",zIndex:300,display:"flex",alignItems:"flex-start",justifyContent:"center",paddingTop:"18vh",padding:"18vh 16px 16px"}}>
              <div style={{background:C.navyL,border:`1px solid ${C.amber}40`,borderRadius:"14px",width:"100%",maxWidth:"420px",padding:"28px 24px",textAlign:"center"}}>
                {!ratingMsg && (<>
                  <div style={{fontSize:"28px",marginBottom:"14px"}}>✦</div>
                  <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"18px",fontWeight:"800",color:C.gold,marginBottom:"8px"}}>Tu aimes Prompt Optimizer ?</h2>
                  <p style={{fontSize:"13px",color:C.muted,marginBottom:"20px",lineHeight:"1.6"}}>Donne une note à cette application !</p>
                  <div style={{display:"flex",justifyContent:"center",gap:"6px",marginBottom:"22px"}}>
                    {[1,2,3,4,5].map(n => (
                      <span key={n} onClick={() => setRatingStars(n)} style={{fontSize:"32px",cursor:"pointer",transition:"transform 0.15s",transform:ratingStars>=n?"scale(1.15)":"scale(1)",filter:ratingStars>=n?"none":"grayscale(1) opacity(0.3)"}}>⭐</span>
                    ))}
                  </div>
                  <div style={{display:"flex",gap:"9px",justifyContent:"center",position:"relative",minHeight:"44px",alignItems:"center"}}>
                    <DodgeButton />
                    <button onClick={() => { if(ratingStars===5) setRatingMsg("accept"); else if(ratingStars>0) setRatingMsg("reject"); }} style={{background:ratingStars>0?`${C.amber}25`:`${C.muted}15`,border:`1px solid ${ratingStars>0?C.amber+"50":C.muted+"30"}`,borderRadius:"8px",padding:"10px 20px",color:ratingStars>0?C.gold:C.muted,fontSize:"13px",fontWeight:"700",cursor:ratingStars>0?"pointer":"default",opacity:ratingStars>0?1:0.5}}>Envoyer</button>
                  </div>
                </>)}
                {ratingMsg === "reject" && (<>
                  <div style={{fontSize:"36px",marginBottom:"14px"}}>😤</div>
                  <p style={{fontSize:"15px",color:C.cream,fontWeight:"600",lineHeight:"1.7",marginBottom:"20px"}}>Je refuse ta note, parce que ce n'est pas 5 étoiles.</p>
                  <button onClick={() => { setRatingMsg(null); setRatingStars(0); }} style={{background:`${C.amber}20`,border:`1px solid ${C.amber}50`,borderRadius:"8px",padding:"10px 22px",color:C.gold,fontSize:"13px",fontWeight:"700",cursor:"pointer"}}>Réessayer</button>
                </>)}
                {ratingMsg === "accept" && (<>
                  <div style={{fontSize:"36px",marginBottom:"14px"}}>🏆😜</div>
                  <p style={{fontSize:"15px",color:C.gold,fontWeight:"700",lineHeight:"1.7",marginBottom:"6px"}}>J'en étais sûr, c'est une application incroyable, mais c'est normal, c'est moi qui l'ai faite.</p>
                  <p style={{fontSize:"13px",color:C.muted,fontStyle:"italic",marginBottom:"20px"}}>Pierre</p>
                  <button onClick={() => setShowRating(false)} style={{background:`${C.amber}20`,border:`1px solid ${C.amber}50`,borderRadius:"8px",padding:"10px 22px",color:C.gold,fontSize:"13px",fontWeight:"700",cursor:"pointer"}}>Fermer</button>
                </>)}
              </div>
            </div>
          )}
          {loaderPhase && <LoaderOverlay phase={loaderPhase} onCancel={cancelAll} status={apiStatus}/>}
          {showSettings && <SettingsModal
            onClose={() => setShowSettings(null)}
            initialTab={showSettings}
            apiProvider={apiProvider} apiKey={apiKey} apiModel={apiModel}
            setApiProvider={setApiProvider} setApiKey={setApiKey} setApiModel={setApiModel}
            allProviders={allProviders}
            ctxDraft={ctxDraft} setCtxDraft={setCtxDraft} setCtx={setCtx}
            enabled={enabled} setEnabled={setEnabled} platforms={PLATFORMS}
            showDebug={showDebug} setShowDebug={setShowDebug}
            onExport={exportAllData} onImport={startImportAll}
            lastBackup={lastBackup}
            currentUser={currentUser} onLogout={handleLogout}
          />}

          {/* ══ Terminal Claude Code (admin) — superposition plein écran ══ */}
          {showTerminal && currentUser?.is_admin && (
            <div style={{position:"fixed",inset:0,zIndex:200,background:"#091E30",display:"flex",flexDirection:"column"}}>
              <div style={{display:"flex",alignItems:"center",gap:"10px",padding:"10px 16px",background:C.navyD,borderBottom:`1px solid ${C.amber}30`}}>
                <span style={{fontSize:"16px"}}>🖥️</span>
                <span style={{fontSize:"15px",fontWeight:"800",fontFamily:"'DM Sans',sans-serif",color:C.gold}}>Terminal Claude Code</span>
                <span style={{fontSize:"12px",color:C.muted}}>· /docker/promptoptimizer</span>
                <div style={{flex:1}}></div>
                <button title="Fermer le terminal" onClick={() => setShowTerminal(false)} style={{background:"transparent",border:`1px solid ${C.amber}40`,borderRadius:"8px",padding:"6px 14px",cursor:"pointer",color:C.gold,fontSize:"14px",fontWeight:"700"}}>✕ Fermer</button>
              </div>
              <iframe
                src={`/api/terminal/frame?token=${encodeURIComponent(authToken || "")}`}
                style={{flex:1,width:"100%",border:0,display:"block"}}
                title="Terminal Claude Code">
              </iframe>
            </div>
          )}

          {/* HEADER */}
          <div className="po-header" style={{background:C.navyD,borderBottom:`1px solid ${C.amber}30`,padding:"12px 22px",display:"flex",alignItems:"center",gap:"12px",position:"sticky",top:0,zIndex:10}}>
            <div style={{fontSize:"21px",color:C.amber,cursor:"pointer",userSelect:"none"}} onClick={restart}>✦</div>
            <div style={{flex:1,minWidth:0}}>
              <div className="po-header-title" style={{fontSize:"22px",fontWeight:"800",fontFamily:"'DM Sans',sans-serif",color:C.gold,lineHeight:"1.3"}}>Prompt Optimizer</div>
              <div className="po-header-sub" style={{fontSize:"12px",color:C.muted,letterSpacing:"2px",textTransform:"uppercase",lineHeight:"1.8",marginTop:"2px"}}>Pierre Diquelou · Prompt Engineering</div>
            </div>
            {currentUser && (
              <span style={{fontSize:"13px",color:C.muted}}>{currentUser.username}</span>
            )}
            {currentUser?.is_admin && (
              <button title="Terminal Claude Code" onClick={() => setShowTerminal(true)} style={{background:`${C.amber}18`,border:`1px solid ${C.amber}40`,borderRadius:"8px",padding:"7px 12px",cursor:"pointer",color:C.gold,fontSize:"15px"}}>🖥️</button>
            )}
            <button title={ctx.trim()?"Contexte renseigné":"Ajouter mon contexte"} onClick={() => { setCtxDraft(ctx); setShowSettings("ctx"); }} style={{background:ctx.trim()?`${C.success}18`:"transparent",border:`1px solid ${ctx.trim()?C.success+"50":C.amber+"30"}`,borderRadius:"8px",padding:"7px 12px",cursor:"pointer",color:ctx.trim()?C.success:C.muted,fontSize:"15px"}}>👤</button>
            <button title="Paramètres" onClick={() => setShowSettings("api")} style={{background:apiKey.trim()?"transparent":`${C.error}18`,border:`1px solid ${apiKey.trim()?C.amber+"30":C.error+"50"}`,borderRadius:"8px",padding:"7px 12px",cursor:"pointer",color:apiKey.trim()?C.muted:C.error,fontSize:"15px"}}>⚙️</button>
            {mode && <button onClick={restart} style={btnS(false,false,{padding:"8px 14px",fontSize:"13px"})}>✦ Accueil</button>}
          </div>

          <div className="po-main" style={{maxWidth:mode==="library"?"960px":"700px",margin:"0 auto",padding:"30px 18px 70px",transition:"max-width 0.3s"}}>

            {/* ══ Modale de confirmation ══ */}
            {confirmAction && (
              <ConfirmModal
                message={confirmAction.message}
                onConfirm={() => { confirmAction.onConfirm(); setConfirmAction(null); }}
                onCancel={() => setConfirmAction(null)}
              />
            )}

            {/* ══ Modale d'import complet ══ */}
            {importPreview && (
              <Modal title="Restauration" icon="📥" onClose={() => setImportPreview(null)}>
                <p style={{fontSize:"13px",color:C.muted,marginBottom:"16px",lineHeight:"1.7"}}>
                  Sauvegarde du {new Date(importPreview.exportDate).toLocaleDateString("fr-FR",{day:"numeric",month:"long",year:"numeric",hour:"2-digit",minute:"2-digit"})}. Choisis ce que tu veux restaurer :
                </p>
                <div style={{marginBottom:"16px"}}>
                  {[
                    {key:"config", label:"Configuration", desc:"Clé API, fournisseur, modèle, contexte, modèles activés", available:!!importPreview.config},
                    {key:"library", label:`Bibliothèque de prompts (${importPreview.library?.length||0} prompts)`, desc:"Remplace tous les prompts actuels", available:!!importPreview.library},
                    {key:"categories", label:`Catégories (${importPreview.categories?.length||0})`, desc:"Remplace les catégories actuelles", available:!!importPreview.categories},
                  ].map(item => (
                    <label key={item.key} style={{display:"flex",alignItems:"center",gap:"10px",padding:"12px 14px",borderRadius:"8px",cursor:item.available?"pointer":"default",marginBottom:"4px",background:importChecks[item.key]?`${C.amber}12`:"transparent",border:`1px solid ${importChecks[item.key]?C.amber+"30":C.amber+"10"}`,opacity:item.available?1:0.4}}>
                      <input type="checkbox" checked={importChecks[item.key]} disabled={!item.available} onChange={e=>setImportChecks(p=>({...p,[item.key]:e.target.checked}))} style={{accentColor:C.amber,width:"16px",height:"16px",cursor:"pointer"}}/>
                      <div>
                        <div style={{fontSize:"14px",fontWeight:"600",color:C.cream}}>{item.label}</div>
                        <div style={{fontSize:"11px",color:C.muted,marginTop:"2px"}}>{item.desc}</div>
                      </div>
                    </label>
                  ))}
                </div>
                <div style={{background:`${C.error}10`,border:`1px solid ${C.error}30`,borderRadius:"8px",padding:"10px 14px",marginBottom:"16px"}}>
                  <p style={{fontSize:"12px",color:C.error,lineHeight:"1.6"}}>Les éléments importés remplaceront les données actuelles. Cette action est irréversible.</p>
                </div>
                <div style={{borderTop:`1px solid ${C.amber}20`,paddingTop:"14px",display:"flex",gap:"9px",justifyContent:"flex-end"}}>
                  <button style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})} onClick={() => setImportPreview(null)}>Annuler</button>
                  <button style={btnS(true,false,{fontSize:"13px",padding:"9px 18px"})} onClick={confirmImportAll}>Restaurer la sélection</button>
                </div>
              </Modal>
            )}

            {successMsg && (
              <div style={{background:`${C.success}15`,border:`1px solid ${C.success}40`,borderRadius:"10px",padding:"12px 18px",marginBottom:"18px",display:"flex",alignItems:"center",gap:"10px",animation:"fadeIn 0.3s"}}>
                <span style={{fontSize:"18px"}}>✓</span>
                <p style={{color:C.success,fontSize:"14px",fontWeight:"600",margin:0}}>{successMsg}</p>
              </div>
            )}

            {/* ══ ACCUEIL ══ */}
            {!mode && ready && (
              <div>
                {!apiKey.trim() && (
                  <div style={{background:`${C.error}12`,border:`1px solid ${C.error}40`,borderRadius:"10px",padding:"12px 16px",marginBottom:"22px",display:"flex",alignItems:"center",gap:"12px"}}>
                    <span style={{fontSize:"20px"}}>⚠</span>
                    <div style={{flex:1}}>
                      <div style={{fontSize:"13px",fontWeight:"700",color:C.error}}>Aucune clé API configurée</div>
                      <div style={{fontSize:"12px",color:C.muted,marginTop:"2px"}}>Configure une clé Claude, OpenAI ou Gemini pour utiliser l'optimiseur.</div>
                    </div>
                    <button onClick={() => setShowSettings("api")} style={{background:`${C.error}20`,border:`1px solid ${C.error}50`,borderRadius:"6px",padding:"7px 14px",color:C.error,fontSize:"12px",fontWeight:"700",cursor:"pointer",whiteSpace:"nowrap"}}>Configurer →</button>
                  </div>
                )}
                <h2 className="po-hero-title" style={{fontFamily:"'DM Sans',sans-serif",fontSize:"26px",fontWeight:"800",color:C.gold,marginBottom:"8px",lineHeight:"1.3",textAlign:"center"}}>Que veux-tu faire ?</h2>
                <p style={{fontSize:"15px",color:C.muted,marginBottom:"32px",lineHeight:"1.8",textAlign:"center"}}>Choisis un mode pour commencer.</p>
                <div className="po-home-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"18px"}}>
                  <div onClick={enterOptimize} style={{background:C.navyL,border:`2px solid ${C.amber}40`,borderRadius:"16px",padding:"28px 22px",cursor:"pointer",transition:"all 0.2s"}}>
                    <div style={{fontSize:"32px",marginBottom:"14px"}}>⚡</div>
                    <div style={{fontSize:"18px",fontWeight:"800",fontFamily:"'DM Sans',sans-serif",color:C.gold,marginBottom:"10px",lineHeight:"1.3"}}>Optimiser un prompt</div>
                    <p style={{fontSize:"13px",color:C.muted,lineHeight:"1.7"}}>J'ai choisi mon modèle IA, génère le meilleur prompt possible pour ma demande.</p>
                    <div style={{marginTop:"16px",fontSize:"12px",fontWeight:"700",color:C.amber,textTransform:"uppercase",letterSpacing:"1px"}}>3 étapes →</div>
                  </div>
                  <div onClick={enterAdvise} style={{background:C.navyL,border:`2px solid ${C.amber}40`,borderRadius:"16px",padding:"28px 22px",cursor:"pointer",transition:"all 0.2s"}}>
                    <div style={{fontSize:"32px",marginBottom:"14px"}}>🧭</div>
                    <div style={{fontSize:"18px",fontWeight:"800",fontFamily:"'DM Sans',sans-serif",color:C.gold,marginBottom:"10px",lineHeight:"1.3"}}>Trouver le bon modèle</div>
                    <p style={{fontSize:"13px",color:C.muted,lineHeight:"1.7"}}>J'hésite entre plusieurs modèles, trouve lequel convient le mieux à ma demande.</p>
                    <div style={{marginTop:"16px",fontSize:"12px",fontWeight:"700",color:C.amber,textTransform:"uppercase",letterSpacing:"1px"}}>2 étapes →</div>
                  </div>
                </div>
                <div onClick={enterLibrary} style={{marginTop:"18px",background:C.navyL,border:`2px solid ${C.amber}40`,borderRadius:"16px",padding:"28px 22px",cursor:"pointer",transition:"all 0.2s",display:"flex",alignItems:"center",gap:"22px"}}>
                  <div style={{fontSize:"32px"}}>📚</div>
                  <div style={{flex:1}}>
                    <div style={{fontSize:"18px",fontWeight:"800",fontFamily:"'DM Sans',sans-serif",color:C.gold,marginBottom:"6px",lineHeight:"1.3"}}>Bibliothèque de prompts</div>
                    <p style={{fontSize:"13px",color:C.muted,lineHeight:"1.7"}}>Des prompts prêts à l'emploi pour te challenger, apprendre et créer. Personnalise-les et ajoute les tiens.</p>
                  </div>
                  <div style={{fontSize:"12px",fontWeight:"700",color:C.amber,textTransform:"uppercase",letterSpacing:"1px",whiteSpace:"nowrap"}}>{library.length} prompts →</div>
                </div>
                <div style={{textAlign:"center",marginTop:"28px"}}>
                  <button onClick={() => setShowHelpJoke(true)} style={{background:"transparent",border:`1px solid ${C.muted}30`,borderRadius:"8px",padding:"10px 20px",color:C.muted,fontSize:"12px",cursor:"pointer",transition:"all 0.2s"}}>Si tu as un problème, clique ici.</button>
                </div>
              </div>
            )}

            {showHelpJoke && (
              <Modal title="Support technique" icon="🛠" onClose={() => setShowHelpJoke(false)}>
                <div style={{textAlign:"center",padding:"20px 0"}}>
                  <div style={{fontSize:"48px",marginBottom:"18px"}}>😤</div>
                  <p style={{fontSize:"18px",fontWeight:"700",color:C.gold,lineHeight:"1.7"}}>Arrête de râler, débrouille-toi.</p>
                </div>
              </Modal>
            )}

            {/* ══ MODE OPTIMIZE ══ */}
            {mode === "optimize" && (
              <div>
                <StepBar/>

                {/* Étape 1 : Modèle + Demande */}
                {step === 1 && (
                  <div>
                    <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"8px",lineHeight:"1.3"}}>Choisis ton modèle et décris ta demande</h2>
                    <p style={{fontSize:"14px",color:C.muted,marginBottom:"22px",lineHeight:"1.8"}}>Sélectionne le modèle que tu veux utiliser, puis décris ce que tu veux obtenir.</p>
                    <div style={{display:"flex",gap:"9px",marginBottom:"20px"}}>
                      {[{id:"text",l:"Texte & Chat"},{id:"image",l:"Génération d'image"}].map(c => (
                        <button key={c.id} onClick={() => { setCat(c.id); setModel(null); }} style={{background:cat===c.id?`${C.amber}18`:"transparent",border:`2px solid ${cat===c.id?C.amber:C.amber+"28"}`,color:cat===c.id?C.gold:C.muted,borderRadius:"9px",padding:"8px 18px",fontSize:"14px",fontWeight:"600",cursor:"pointer",transition:"all 0.2s"}}>{c.l}</button>
                      ))}
                    </div>
                    <div style={{marginBottom:"20px"}}>
                      <div style={labelS}>Modèle cible</div>
                      {PLATFORMS.filter(pl => pl.cat === cat).map(pl => {
                        const avModels = pl.models.filter(m => enabled[m.id] !== false);
                        if (!avModels.length) return null;
                        return (
                          <div key={pl.id} style={{marginBottom:"10px"}}>
                            <div style={{display:"flex",alignItems:"center",gap:"7px",marginBottom:"7px"}}>
                              <span style={{color:pl.color,fontSize:"13px"}}>{pl.logo}</span>
                              <span style={{fontSize:"12px",fontWeight:"700",color:C.muted,textTransform:"uppercase",letterSpacing:"1px"}}>{pl.name}</span>
                            </div>
                            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:"7px",paddingLeft:"4px"}}>
                              {avModels.map(m => {
                                const mFull = {...m,platform:pl.name,pcolor:pl.color,plogo:pl.logo,cat:pl.cat,pid:pl.id};
                                const sel = model?.id === m.id;
                                return (
                                  <div key={m.id} onClick={() => setModel(mFull)} style={{display:"flex",alignItems:"center",gap:"10px",padding:"10px 13px",borderRadius:"9px",cursor:"pointer",background:sel?`${pl.color}20`:C.navyD,border:`2px solid ${sel?pl.color:C.amber+"18"}`,transition:"all 0.15s"}}>
                                    <div style={{width:"16px",height:"16px",borderRadius:"50%",border:`2px solid ${sel?pl.color:C.muted}`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                                      {sel && <div style={{width:"8px",height:"8px",borderRadius:"50%",background:pl.color}}/>}
                                    </div>
                                    <div style={{flex:1,minWidth:0}}>
                                      <div style={{fontSize:"13px",fontWeight:"700",color:sel?C.cream:C.muted,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{m.name}</div>
                                      {m.badge && <span style={{...bdgS(m.badge),fontSize:"10px"}}>{m.badge}</span>}
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                    <div style={labelS}>Ta demande</div>
                    <textarea style={inpS({minHeight:"120px",resize:"vertical"})}
                      placeholder={cat==="text"?placeholders.text:placeholders.image}
                      value={request} onChange={e => setRequest(e.target.value)}
                    />
                    {error && <p style={{color:C.error,fontSize:"13px",marginTop:"9px"}}>{error}</p>}
                    <div style={{marginTop:"18px",display:"flex",alignItems:"center",gap:"14px",flexWrap:"wrap"}}>
                      <button style={btnS(true, loading||!model||!request.trim())} disabled={loading||!model||!request.trim()} onClick={() => genQuestionsForOptimize(model)}>
                        {loading ? "Analyse en cours…" : "Analyser ma demande →"}
                      </button>
                      {model && <span style={{fontSize:"13px",color:C.muted}}>Modèle : <strong style={{color:C.cream}}>{model.name}</strong></span>}
                    </div>
                  </div>
                )}

                {/* Étape 2 : Questions */}
                {step === 2 && model && (
                  <div>
                    <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"6px",lineHeight:"1.3"}}>Affine ton prompt</h2>
                    <div style={{display:"flex",alignItems:"center",gap:"9px",marginBottom:"5px",flexWrap:"wrap"}}>
                      <span style={{fontSize:"16px",color:model.pcolor}}>{model.plogo}</span>
                      <span style={{fontSize:"14px",color:C.muted}}>{model.platform} · <strong style={{color:C.cream}}>{model.name}</strong>{model.badge&&<span style={{...bdgS(model.badge),marginLeft:"7px"}}>{model.badge}</span>}</span>
                      <span style={{background:`${C.amber}15`,border:`1px solid ${C.amber}35`,borderRadius:"5px",padding:"2px 9px",fontSize:"11px",fontWeight:"700",color:C.gold}}>{TASK_LABELS[taskType]}</span>
                    </div>
                    <button onClick={() => setStep(1)} style={{fontSize:"13px",color:C.amber,background:"transparent",border:"none",cursor:"pointer",padding:"0 0 20px",textDecoration:"underline",textDecorationColor:`${C.amber}50`}}>← Modifier le modèle / la demande</button>
                    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:"16px"}}>
                      <button style={btnS(false,allAL,{fontSize:"13px",padding:"9px 16px"})} onClick={autoAll} disabled={allAL}>Répondre à toutes les questions</button>
                    </div>
                    {questions.map((q,i) => (
                      <div key={i} style={{marginBottom:"16px",background:C.navyD,borderRadius:"10px",padding:"15px",border:`1px solid ${C.amber}15`}}>
                        <p style={{fontSize:"14px",fontWeight:"600",color:C.gold,marginBottom:"10px"}}>{i+1}. {q}</p>
                        <textarea style={inpS({minHeight:"56px",resize:"vertical",marginBottom:"9px"})}
                          placeholder="Ta réponse (optionnel)…"
                          value={answers[i]||""} onChange={e => { const n=[...answers]; n[i]=e.target.value; setAs(n); }}
                        />
                        <button style={btnS(false,!!aLoading[i],{fontSize:"12px",padding:"6px 13px"})} onClick={() => autoOne(i)} disabled={!!aLoading[i]}>
                          {aLoading[i]?"Génération…":"Répondre à ma place"}
                        </button>
                      </div>
                    ))}
                    {/* Champ libre + questions complémentaires */}
                    <div style={{marginTop:"8px",background:C.navyD,borderRadius:"10px",padding:"15px",border:`1px solid ${C.amber}15`,marginBottom:"16px"}}>
                      <p style={{fontSize:"13px",fontWeight:"600",color:C.muted,marginBottom:"10px"}}>Informations complémentaires (optionnel)</p>
                      <textarea style={inpS({minHeight:"56px",resize:"vertical",marginBottom:"10px"})}
                        placeholder="Ajoute ici toute information que les questions n'ont pas abordée…"
                        value={extraInfo} onChange={e => setExtraInfo(e.target.value)}
                      />
                      <button style={btnS(false,loading,{fontSize:"12px",padding:"7px 14px"})} onClick={askMoreQuestions} disabled={loading}>
                        {loading?"Génération…":"Poser d'autres questions"}
                      </button>
                    </div>
                    {error && <p style={{color:C.error,fontSize:"13px",marginBottom:"12px"}}>{error}</p>}
                    <div style={{marginTop:"10px",display:"flex",gap:"10px",flexWrap:"wrap"}}>
                      <button style={btnS(true,loading)} onClick={generate} disabled={loading}>
                        {loading?"Génération en cours…":"Générer le prompt optimisé →"}
                      </button>
                    </div>
                  </div>
                )}

                {/* Étape 3 : Prompt généré */}
                {step === 3 && model && (
                  <div>
                    <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"6px",lineHeight:"1.3"}}>Ton prompt optimisé</h2>
                    <div style={{display:"flex",alignItems:"center",gap:"9px",marginBottom:"20px",flexWrap:"wrap"}}>
                      <span style={{fontSize:"16px",color:model.pcolor}}>{model.plogo}</span>
                      <span style={{fontSize:"14px",color:C.muted}}>{model.platform} · <strong style={{color:C.cream}}>{model.name}</strong>{model.badge&&<span style={{...bdgS(model.badge),marginLeft:"7px"}}>{model.badge}</span>}</span>
                      <span style={{background:`${C.amber}15`,border:`1px solid ${C.amber}35`,borderRadius:"5px",padding:"2px 9px",fontSize:"11px",fontWeight:"700",color:C.gold}}>{TASK_LABELS[taskType]}</span>
                    </div>
                    <div style={{background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"12px",padding:"20px",marginBottom:"14px"}}>
                      <div style={{maxHeight:"500px",overflowY:"auto"}}>{renderMd(mainPrompt)}</div>
                    </div>
                    <div style={{display:"flex",gap:"10px",flexWrap:"wrap",marginBottom:"16px"}}>
                      <button style={btnS(true,false,{fontSize:"15px",padding:"13px 28px"})} onClick={copyPrompt}>
                        {copied?"Copié dans le presse-papier !":"Copier le prompt"}
                      </button>
                      <button style={btnS(false,loading)} onClick={generate} disabled={loading}>{loading?"Régénération…":"Régénérer"}</button>
                      <button style={btnS(false,false)} onClick={() => setStep(2)}>← Modifier les réponses</button>
                      <button style={btnS(false,false)} onClick={() => setStep(1)}>← Changer de modèle</button>
                    </div>
                    {promptNotes && (
                      <div style={{background:`${C.amber}08`,border:`1px solid ${C.amber}18`,borderRadius:"10px",padding:"14px 18px",marginBottom:"16px"}}>
                        <div style={{fontSize:"12px",fontWeight:"700",color:C.amber,textTransform:"uppercase",letterSpacing:"1px",marginBottom:"8px"}}>Notes & conseils d'utilisation</div>
                        <div style={{fontSize:"13px",color:C.muted,lineHeight:"1.7"}}>{renderMd(promptNotes)}</div>
                      </div>
                    )}
                    <div style={{paddingTop:"16px",borderTop:`1px solid ${C.amber}15`,display:"flex",gap:"10px",flexWrap:"wrap"}}>
                      <button style={btnS(true,false,{background:`${C.amber}15`,color:C.gold,border:`1px solid ${C.amber}40`,fontSize:"14px",padding:"10px 20px"})} onClick={restart}>✦ Nouveau prompt</button>
                      <button style={btnS(false,false,{fontSize:"14px",padding:"10px 20px"})} onClick={() => {
                        setLibEditing({ title:"", category:libCategories[0]?.id||"challenge", description:request.length>80?request.slice(0,80)+"…":request, prompt:mainPrompt, model:model.id, variables:[], rating:0 });
                        setLibShowEdit(true); setMode("library");
                      }}>📚 Enregistrer dans la bibliothèque</button>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ══ MODE ADVISE ══ */}
            {mode === "advise" && (
              <div>
                <StepBar/>

                {/* Étape 1 : Sélection modèles + demande */}
                {step === 1 && (
                  <div>
                    <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"8px",lineHeight:"1.3"}}>Décris ta demande et sélectionne les modèles</h2>
                    <p style={{fontSize:"14px",color:C.muted,marginBottom:"22px",lineHeight:"1.8"}}>Je vais analyser ta demande et classer les modèles du meilleur au moins adapté.</p>
                    <div style={{display:"flex",gap:"9px",marginBottom:"18px"}}>
                      {[{id:"text",l:"Texte & Chat"},{id:"image",l:"Génération d'image"}].map(c => (
                        <button key={c.id} onClick={() => setCat(c.id)} style={{background:cat===c.id?`${C.amber}18`:"transparent",border:`2px solid ${cat===c.id?C.amber:C.amber+"28"}`,color:cat===c.id?C.gold:C.muted,borderRadius:"9px",padding:"8px 18px",fontSize:"14px",fontWeight:"600",cursor:"pointer",transition:"all 0.2s"}}>{c.l}</button>
                      ))}
                    </div>
                    <textarea style={inpS({minHeight:"110px",resize:"vertical",marginBottom:"22px"})}
                      placeholder={cat==="text"?placeholders.adviseText:placeholders.adviseImage}
                      value={request} onChange={e => setRequest(e.target.value)}
                    />
                    <div style={{marginBottom:"20px"}}>
                      <div style={labelS}>Modèles à comparer</div>
                      {PLATFORMS.filter(pl => pl.cat === cat).map(pl => {
                        const toggleAll = (v) => { const u={...adviseChecked}; pl.models.forEach(m=>{u[m.id]=v;}); setAdviseChecked(u); };
                        return (
                          <div key={pl.id} style={{marginBottom:"10px",background:C.navyD,borderRadius:"10px",padding:"12px 14px",border:`1px solid ${C.amber}15`}}>
                            <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"10px"}}>
                              <div style={{display:"flex",alignItems:"center",gap:"8px"}}>
                                <span style={{color:pl.color,fontSize:"14px"}}>{pl.logo}</span>
                                <span style={{fontSize:"14px",fontWeight:"700",color:C.gold}}>{pl.name}</span>
                              </div>
                              <div style={{display:"flex",gap:"5px"}}>
                                <button onClick={()=>toggleAll(true)} style={btnS(false,false,{padding:"3px 9px",fontSize:"11px"})}>Tout</button>
                                <button onClick={()=>toggleAll(false)} style={btnS(false,false,{padding:"3px 9px",fontSize:"11px"})}>Aucun</button>
                              </div>
                            </div>
                            {pl.models.map(m => (
                              <label key={m.id} style={{display:"flex",alignItems:"center",gap:"10px",padding:"7px 8px",borderRadius:"7px",cursor:"pointer",marginBottom:"3px",background:adviseChecked[m.id]!==false?`${pl.color}10`:"transparent"}}>
                                <input type="checkbox" checked={adviseChecked[m.id]!==false} onChange={e=>setAdviseChecked(p=>({...p,[m.id]:e.target.checked}))} style={{accentColor:C.amber,width:"15px",height:"15px",cursor:"pointer"}}/>
                                <div style={{flex:1,display:"flex",alignItems:"center",gap:"8px"}}>
                                  <span style={{fontSize:"13px",color:adviseChecked[m.id]!==false?C.cream:C.muted}}>{m.name}</span>
                                  {m.badge&&<span style={bdgS(m.badge)}>{m.badge}</span>}
                                  <span style={{fontSize:"11px",color:C.muted}}>{m.desc}</span>
                                </div>
                              </label>
                            ))}
                          </div>
                        );
                      })}
                    </div>
                    {error && <p style={{color:C.error,fontSize:"13px",marginBottom:"12px"}}>{error}</p>}
                    <button
                      style={btnS(true, loading||!request.trim()||!ALL_MODELS.filter(m=>m.cat===cat&&adviseChecked[m.id]!==false).length)}
                      disabled={loading||!request.trim()||!ALL_MODELS.filter(m=>m.cat===cat&&adviseChecked[m.id]!==false).length}
                      onClick={analyzeForAdvise}
                    >
                      {loading ? "Analyse en cours…" : "Trouver le meilleur modèle →"}
                    </button>
                  </div>
                )}

                {/* Étape 2 : Résultats classés */}
                {step === 2 && (
                  <div>
                    <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,marginBottom:"6px",lineHeight:"1.3"}}>Résultats</h2>
                    <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"4px",flexWrap:"wrap"}}>
                      <p style={{fontSize:"13px",color:C.muted}}>Demande : <em style={{color:C.cream}}>"{request.length>70?request.slice(0,70)+"…":request}"</em></p>
                      <span style={{background:`${C.amber}15`,border:`1px solid ${C.amber}35`,borderRadius:"5px",padding:"2px 9px",fontSize:"11px",fontWeight:"700",color:C.gold}}>Tâche : {TASK_LABELS[taskType]||taskType}</span>
                    </div>
                    <button onClick={() => setStep(1)} style={{fontSize:"13px",color:C.amber,background:"transparent",border:"none",cursor:"pointer",padding:"0 0 20px",textDecoration:"underline",textDecorationColor:`${C.amber}50`}}>← Modifier ma sélection</button>
                    {adviseRecs.map((rec,i) => {
                      const m = rec.model;
                      const isWinner = i === 0;
                      const barPct = (rec.score / 5) * 100;
                      return (
                        <div key={m.id} style={{marginBottom:"10px",background:isWinner?`${C.success}0D`:C.navyD,border:`1px solid ${isWinner?C.success+"50":C.amber+"18"}`,borderRadius:"12px",padding:"14px 16px"}}>
                          {isWinner && (
                            <div style={{display:"flex",alignItems:"center",gap:"7px",marginBottom:"10px",paddingBottom:"10px",borderBottom:`1px solid ${C.success}30`}}>
                              <div style={{width:"8px",height:"8px",borderRadius:"50%",background:C.success}}/>
                              <span style={{fontSize:"11px",fontWeight:"700",color:C.success,textTransform:"uppercase",letterSpacing:"1px"}}>Meilleur choix pour ta demande</span>
                            </div>
                          )}
                          <div style={{display:"flex",alignItems:"flex-start",gap:"13px"}}>
                            <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"2px",minWidth:"32px"}}>
                              <span style={{fontSize:"17px",color:m.pcolor}}>{m.plogo}</span>
                              <span style={{fontSize:"11px",fontWeight:"700",color:isWinner?C.success:C.muted}}>#{i+1}</span>
                            </div>
                            <div style={{flex:1}}>
                              <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"5px",flexWrap:"wrap"}}>
                                <span style={{fontSize:"14px",fontWeight:"700",color:C.cream}}>{m.name}</span>
                                {m.badge && <span style={bdgS(m.badge)}>{m.badge}</span>}
                                <span style={{fontSize:"11px",color:C.muted}}>{m.platform}</span>
                              </div>
                              <div style={{display:"flex",alignItems:"center",gap:"9px",marginBottom:"7px"}}>
                                <div style={{flex:1,height:"5px",background:`${C.amber}18`,borderRadius:"3px",overflow:"hidden"}}>
                                  <div style={{width:`${barPct}%`,height:"100%",background:isWinner?C.success:C.amber,borderRadius:"3px"}}/>
                                </div>
                                <span style={{fontSize:"12px",fontWeight:"700",color:isWinner?C.success:C.gold,minWidth:"24px"}}>{rec.score}/5</span>
                              </div>
                              <p style={{fontSize:"12px",color:C.mutedL,lineHeight:"1.6",marginBottom:"10px"}}>{rec.reason}</p>
                              <button onClick={() => continueWithModel(m)} style={btnS(isWinner,false,{fontSize:"12px",padding:"7px 14px"})}>
                                Créer le prompt avec ce modèle →
                              </button>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    {error && <p style={{color:C.error,fontSize:"13px",marginTop:"12px"}}>{error}</p>}
                  </div>
                )}
              </div>
            )}
            {/* ══ MODE LIBRARY ══ */}
            {mode === "library" && (
              <div>
                {/* ── Modale d'édition/ajout ── */}
                {libShowEdit && <LibEditModal
                  initial={libEditing}
                  onSave={libSave}
                  onClose={() => { setLibShowEdit(false); setLibEditing(null); }}
                  allModels={ALL_MODELS}
                  categories={libCategories}
                  enabledModels={enabled}
                  onAnalyze={analyzePromptForModel}
                  onAddCategory={libAddCategory}
                />}

                {/* ── Vue détail : utilisation d'un prompt ── */}
                {!libShowEdit && libSelected && (
                  <div>
                    <button onClick={() => setLibSelected(null)} style={{fontSize:"13px",color:C.amber,background:"transparent",border:"none",cursor:"pointer",padding:"0 0 16px",textDecoration:"underline",textDecorationColor:`${C.amber}50`}}>← Retour à la bibliothèque</button>
                    <div style={{display:"flex",alignItems:"center",gap:"10px",marginBottom:"6px",flexWrap:"wrap"}}>
                      <span style={{fontSize:"24px"}}>{libCatMap[libSelected.category]?.icon}</span>
                      <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"24px",fontWeight:"800",color:C.gold,lineHeight:"1.3"}}>{libSelected.title}</h2>
                      <span style={{background:(libCatMap[libSelected.category]?.color||C.muted)+"20",color:libCatMap[libSelected.category]?.color||C.muted,border:`1px solid ${(libCatMap[libSelected.category]?.color||C.muted)}40`,borderRadius:"6px",padding:"3px 10px",fontSize:"11px",fontWeight:"700"}}>{libCatMap[libSelected.category]?.label}</span>
                    </div>
                    <p style={{fontSize:"14px",color:C.muted,marginBottom:"6px",lineHeight:"1.7"}}>{libSelected.description}</p>
                    {(() => { const recModel = ALL_MODELS.find(m => m.id === libSelected.model); return recModel ? (
                      <div style={{fontSize:"12px",color:C.muted,marginBottom:"20px"}}>Modèle recommandé : <strong style={{color:C.cream}}>{recModel.name}</strong> <span style={{color:recModel.pcolor}}>({recModel.platform})</span></div>
                    ) : null; })()}

                    {/* Variables */}
                    {(libSelected.variables || []).length > 0 && (
                      <div style={{marginBottom:"20px"}}>
                        <div style={labelS}>Remplis les variables</div>
                        {libSelected.variables.map(v => (
                          <div key={v} style={{marginBottom:"10px"}}>
                            <div style={{fontSize:"12px",fontWeight:"700",color:C.amber,marginBottom:"4px"}}>{`{${v}}`}</div>
                            <textarea style={inpS({minHeight:"56px",resize:"vertical"})}
                              placeholder={`Remplace {${v}} par ton contenu...`}
                              value={libVars[v]||""} onChange={e => setLibVars(p => ({...p,[v]:e.target.value}))}
                            />
                          </div>
                        ))}
                      </div>
                    )}

                    {/* Aperçu */}
                    <div style={labelS}>Aperçu du prompt</div>
                    <div style={{background:C.navyD,border:`1px solid ${C.amber}30`,borderRadius:"12px",padding:"20px",marginBottom:"16px",maxHeight:"350px",overflowY:"auto"}}>
                      <pre style={{fontSize:"13px",lineHeight:"1.7",color:C.cream,whiteSpace:"pre-wrap",wordBreak:"break-word",margin:0}}>{libGetFilled()}</pre>
                    </div>

                    <div style={{display:"flex",gap:"10px",flexWrap:"wrap"}}>
                      <button style={btnS(true,false,{fontSize:"15px",padding:"13px 28px"})} onClick={libCopy}>
                        {libCopied?"Copié !":"Copier le prompt"}
                      </button>
                      <button style={btnS(false,false)} onClick={() => { setLibEditing({...libSelected}); setLibShowEdit(true); }}>Modifier</button>
                    </div>
                  </div>
                )}

                {/* ── Modale ajout catégorie ── */}
                {libShowAddCat && <AddCategoryModal
                  onAdd={(name, icon, color) => { libAddCategory(name, icon, color); setLibShowAddCat(false); }}
                  onClose={() => setLibShowAddCat(false)}
                />}

                {/* ── Modale d'import sélectif ── */}
                {libImportData && (
                  <Modal title="Importer des prompts" icon="📥" onClose={() => { setLibImportData(null); setLibImportChecked({}); }}>
                    <p style={{fontSize:"13px",color:C.muted,marginBottom:"16px",lineHeight:"1.7"}}>
                      {libImportData.prompts.length} prompt{libImportData.prompts.length>1?"s":""} trouvé{libImportData.prompts.length>1?"s":""}. Coche ceux que tu veux importer.
                    </p>
                    <div style={{display:"flex",gap:"8px",marginBottom:"14px"}}>
                      <button style={btnS(false,false,{fontSize:"11px",padding:"5px 12px"})} onClick={() => { const c={}; libImportData.prompts.forEach(p=>{c[p.id||p.title]=true;}); setLibImportChecked(c); }}>Tout cocher</button>
                      <button style={btnS(false,false,{fontSize:"11px",padding:"5px 12px"})} onClick={() => setLibImportChecked({})}>Tout décocher</button>
                    </div>
                    <div style={{maxHeight:"350px",overflowY:"auto",marginBottom:"16px"}}>
                      {libImportData.prompts.map((p,i) => {
                        const key = p.id || p.title;
                        const cat = libCatMap[p.category] || libImportData.categories?.find(c=>c.id===p.category) || {icon:"📌",label:p.category||"?",color:C.muted};
                        return (
                          <label key={i} style={{display:"flex",alignItems:"center",gap:"10px",padding:"10px 12px",borderRadius:"8px",cursor:"pointer",marginBottom:"4px",background:libImportChecked[key]?`${C.amber}12`:"transparent",border:`1px solid ${libImportChecked[key]?C.amber+"30":C.amber+"10"}`}}>
                            <input type="checkbox" checked={!!libImportChecked[key]} onChange={e=>setLibImportChecked(prev=>({...prev,[key]:e.target.checked}))} style={{accentColor:C.amber,width:"15px",height:"15px",cursor:"pointer"}}/>
                            <span style={{fontSize:"16px"}}>{cat.icon}</span>
                            <div style={{flex:1}}>
                              <div style={{fontSize:"13px",fontWeight:"600",color:C.cream}}>{p.title}</div>
                              <div style={{fontSize:"11px",color:C.muted}}>{p.description}</div>
                            </div>
                            <span style={{background:cat.color+"20",color:cat.color,borderRadius:"4px",padding:"2px 6px",fontSize:"9px",fontWeight:"700"}}>{cat.label}</span>
                          </label>
                        );
                      })}
                    </div>
                    <div style={{borderTop:`1px solid ${C.amber}20`,paddingTop:"14px",display:"flex",gap:"9px",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{fontSize:"12px",color:C.muted}}>{Object.values(libImportChecked).filter(Boolean).length} sélectionné{Object.values(libImportChecked).filter(Boolean).length>1?"s":""}</span>
                      <div style={{display:"flex",gap:"9px"}}>
                        <button style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})} onClick={() => { setLibImportData(null); setLibImportChecked({}); }}>Annuler</button>
                        <button style={btnS(true,!Object.values(libImportChecked).some(Boolean),{fontSize:"13px",padding:"9px 18px"})} disabled={!Object.values(libImportChecked).some(Boolean)} onClick={libConfirmImport}>
                          Importer la sélection
                        </button>
                      </div>
                    </div>
                  </Modal>
                )}

                {/* ── Vue liste : sidebar + grille ── */}
                {!libShowEdit && !libSelected && (
                  <div className="po-lib-layout" style={{display:"flex",gap:"20px",alignItems:"flex-start"}}>
                    {/* ══ SIDEBAR GAUCHE ══ */}
                    <div className="po-lib-sidebar" style={{width:"220px",flexShrink:0,position:"sticky",top:"80px"}}>
                      {/* Toggle mobile pour la sidebar */}
                      <button className="po-sidebar-toggle" onClick={() => setLibSidebarOpen(s=>!s)}
                        style={{display:"none",width:"100%",background:`${C.amber}12`,border:`1px solid ${C.amber}30`,borderRadius:"8px",padding:"10px 14px",cursor:"pointer",color:C.gold,fontSize:"13px",fontWeight:"600",marginBottom:"10px",textAlign:"left"}}>
                        {libSidebarOpen ? "▲ Masquer filtres" : "▼ Filtres, catégories & tri"}
                      </button>
                      <div className={`po-sidebar-content${libSidebarOpen?" open":""}`}>
                      {/* Catégories en dossiers */}
                      <div style={{marginBottom:"20px"}}>
                        <div style={{fontSize:"10px",fontWeight:"700",color:C.muted,textTransform:"uppercase",letterSpacing:"1.5px",marginBottom:"10px",padding:"0 8px"}}>Catégories</div>
                        <div onClick={() => setLibFilter("all")}
                          style={{display:"flex",alignItems:"center",gap:"9px",padding:"9px 12px",borderRadius:"8px",cursor:"pointer",marginBottom:"2px",background:libFilter==="all"?`${C.amber}15`:"transparent",color:libFilter==="all"?C.gold:C.muted,fontSize:"13px",fontWeight:libFilter==="all"?"600":"400",transition:"all 0.15s"}}>
                          <span style={{fontSize:"14px"}}>📁</span>
                          <span style={{flex:1}}>Tous les prompts</span>
                          <span style={{fontSize:"11px",color:C.muted}}>{library.length}</span>
                        </div>
                        {libCategories.map(cat => {
                          const count = library.filter(p => p.category === cat.id).length;
                          const isActive = libFilter === cat.id;
                          return (
                            <div key={cat.id} style={{display:"flex",alignItems:"center",gap:"9px",padding:"9px 12px",borderRadius:"8px",cursor:"pointer",marginBottom:"2px",background:isActive?`${cat.color}15`:"transparent",transition:"all 0.15s"}}
                              onClick={() => setLibFilter(cat.id)}>
                              <span style={{fontSize:"14px"}}>{cat.icon}</span>
                              <span style={{flex:1,fontSize:"13px",fontWeight:isActive?"600":"400",color:isActive?cat.color:C.muted}}>{cat.label}</span>
                              <span style={{fontSize:"11px",color:C.muted}}>{count}</span>
                              {libCategories.length > 1 && (
                                <span title="Supprimer" onClick={e => { e.stopPropagation(); askConfirm(`Supprimer la catégorie "${cat.label}" ? Les prompts seront reclassés.`, () => libDeleteCategory(cat.id)); }}
                                  style={{fontSize:"11px",color:`${C.error}60`,cursor:"pointer",padding:"2px",lineHeight:1}}>✕</span>
                              )}
                            </div>
                          );
                        })}
                        <div onClick={() => setLibShowAddCat(true)}
                          style={{display:"flex",alignItems:"center",gap:"9px",padding:"9px 12px",borderRadius:"8px",cursor:"pointer",marginTop:"4px",color:`${C.amber}80`,fontSize:"13px"}}>
                          <span style={{fontSize:"14px"}}>+</span>
                          <span>Nouvelle catégorie</span>
                        </div>
                      </div>

                      {/* Séparateur */}
                      <div style={{height:"1px",background:`${C.amber}15`,margin:"8px 8px 16px"}}/>

                      {/* Filtres */}
                      <div style={{marginBottom:"16px"}}>
                        <div style={{fontSize:"10px",fontWeight:"700",color:C.muted,textTransform:"uppercase",letterSpacing:"1.5px",marginBottom:"10px",padding:"0 8px"}}>Filtres</div>
                        {(() => {
                          const sideSelect = {width:"100%",background:C.navyD,border:`1px solid ${C.amber}20`,borderRadius:"8px",padding:"8px 10px",color:C.cream,fontSize:"12px",cursor:"pointer",marginBottom:"8px"};
                          const uniqueModels = [...new Set(library.map(p=>p.model))].map(id=>ALL_MODELS.find(m=>m.id===id)).filter(Boolean);
                          return (<>
                            <select value={libFilterModel} onChange={e=>setLibFilterModel(e.target.value)} style={sideSelect}>
                              <option value="all">Tous les modèles</option>
                              {uniqueModels.map(m => <option key={m.id} value={m.id}>{m.name}</option>)}
                            </select>
                            <select value={libFilterRating} onChange={e=>setLibFilterRating(Number(e.target.value))} style={sideSelect}>
                              <option value={0}>Toutes les notes</option>
                              {[1,2,3,4,5].map(n => <option key={n} value={n}>{"★".repeat(n)} et +</option>)}
                            </select>
                          </>);
                        })()}
                      </div>

                      {/* Séparateur */}
                      <div style={{height:"1px",background:`${C.amber}15`,margin:"8px 8px 16px"}}/>

                      {/* Tri */}
                      <div>
                        <div style={{fontSize:"10px",fontWeight:"700",color:C.muted,textTransform:"uppercase",letterSpacing:"1.5px",marginBottom:"10px",padding:"0 8px"}}>Tri</div>
                        <select value={libSort} onChange={e=>setLibSort(e.target.value)} style={{width:"100%",background:C.navyD,border:`1px solid ${C.amber}20`,borderRadius:"8px",padding:"8px 10px",color:C.cream,fontSize:"12px",cursor:"pointer"}}>
                          <option value="title">A → Z</option>
                          <option value="rating">Meilleures notes</option>
                          <option value="category">Catégorie</option>
                          <option value="model">Modèle</option>
                        </select>
                      </div>
                      </div>{/* fin po-sidebar-content */}
                    </div>

                    {/* ══ CONTENU PRINCIPAL ══ */}
                    <div style={{flex:1,minWidth:0}}>
                      {/* En-tête + sélecteur de vue */}
                      <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:"18px",gap:"10px",flexWrap:"wrap"}}>
                        <div style={{flex:1}}>
                          <h2 style={{fontFamily:"'DM Sans',sans-serif",fontSize:"22px",fontWeight:"800",color:C.gold,lineHeight:"1.3",marginBottom:"4px"}}>
                            {libFilter === "all" ? "Tous les prompts" : (libCatMap[libFilter]?.icon||"") + " " + (libCatMap[libFilter]?.label||"")}
                          </h2>
                          <p style={{fontSize:"13px",color:C.muted}}>
                            {(() => {
                              let items = library.filter(p => {
                                if (libFilter !== "all" && p.category !== libFilter) return false;
                                if (libFilterModel !== "all" && p.model !== libFilterModel) return false;
                                if (libFilterRating > 0 && (p.rating||0) < libFilterRating) return false;
                                return true;
                              });
                              return `${items.length} prompt${items.length>1?"s":""}`;
                            })()}
                          </p>
                        </div>
                        <div style={{display:"flex",gap:"4px",alignItems:"center"}}>
                          {[{id:"list",icon:"☰",t:"Liste détaillée"},{id:"grid",icon:"▦",t:"Grille"},{id:"compact",icon:"═",t:"Liste compacte"}].map(v => (
                            <button key={v.id} title={v.t} onClick={() => setLibViewMode(v.id)}
                              style={{background:libViewMode===v.id?`${C.amber}20`:"transparent",border:`1px solid ${libViewMode===v.id?C.amber+"50":C.amber+"20"}`,borderRadius:"6px",padding:"5px 9px",cursor:"pointer",color:libViewMode===v.id?C.gold:C.muted,fontSize:"14px",lineHeight:1}}>{v.icon}</button>
                          ))}
                        </div>
                        <div style={{display:"flex",gap:"8px",flexWrap:"wrap"}}>
                          <button onClick={() => { setLibEditing(null); setLibShowEdit(true); }} style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})}>+ Nouveau prompt</button>
                          <button onClick={libExport} style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})}>Exporter</button>
                          <button onClick={libStartImport} style={btnS(false,false,{fontSize:"13px",padding:"9px 18px"})}>Importer</button>
                        </div>
                      </div>

                      {/* Liste filtrée et triée */}
                      {(() => {
                        let items = library.filter(p => {
                          if (libFilter !== "all" && p.category !== libFilter) return false;
                          if (libFilterModel !== "all" && p.model !== libFilterModel) return false;
                          if (libFilterRating > 0 && (p.rating||0) < libFilterRating) return false;
                          return true;
                        });
                        items.sort((a,b) => {
                          if (libSort === "rating") return (b.rating||0) - (a.rating||0);
                          if (libSort === "category") return (a.category||"").localeCompare(b.category||"");
                          if (libSort === "model") return (a.model||"").localeCompare(b.model||"");
                          return (a.title||"").localeCompare(b.title||"");
                        });
                        if (!items.length) return <p style={{fontSize:"13px",color:C.muted,textAlign:"center",padding:"40px 0"}}>Aucun prompt ne correspond aux filtres.</p>;

                        const toggleExpand = (id) => setLibExpanded(prev => ({...prev, [id]: !prev[id]}));

                        /* ── MODE GRILLE ── */
                        if (libViewMode === "grid") return (
                          <div className="po-lib-grid" style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:"10px"}}>
                            {items.map(p => {
                              const cat = libCatMap[p.category] || {label:"?",icon:"📌",color:C.muted};
                              const recModel = ALL_MODELS.find(m => m.id === p.model);
                              const isExp = !!libExpanded[p.id];
                              return (
                                <div key={p.id} style={{background:C.navyD,border:`1px solid ${C.amber}12`,borderRadius:"12px",padding:"14px",position:"relative",transition:"all 0.2s"}}>
                                  <div style={{position:"absolute",top:"8px",right:"8px",display:"flex",gap:"4px"}} onClick={e => e.stopPropagation()}>
                                    <button title="Modifier" onClick={() => { setLibEditing({...p}); setLibShowEdit(true); }} style={{background:"transparent",border:"none",cursor:"pointer",color:C.muted,fontSize:"11px",padding:"2px"}}>✏️</button>
                                    <button title="Supprimer" onClick={() => askConfirm(`Supprimer le prompt "${p.title}" ?`, () => libDelete(p.id))} style={{background:"transparent",border:"none",cursor:"pointer",color:`${C.error}80`,fontSize:"11px",padding:"2px"}}>🗑</button>
                                  </div>
                                  <div style={{display:"flex",alignItems:"center",gap:"8px",marginBottom:"6px",paddingRight:"40px"}}>
                                    <span style={{fontSize:"18px"}}>{cat.icon}</span>
                                    <span style={{fontSize:"13px",fontWeight:"700",color:C.cream,lineHeight:"1.3"}}>{p.title}</span>
                                  </div>
                                  <div style={{marginBottom:"6px"}}>
                                    {[1,2,3,4,5].map(n => (
                                      <span key={n} onClick={() => libRate(p.id, (p.rating||0)===n ? 0 : n)} style={{cursor:"pointer",fontSize:"12px",color:n<=(p.rating||0)?"#F39C12":`${C.muted}30`}}>★</span>
                                    ))}
                                  </div>
                                  <p style={{fontSize:"11px",color:C.muted,lineHeight:"1.5",marginBottom:"8px"}}>{p.description}</p>
                                  {isExp && (
                                    <div style={{marginBottom:"8px"}}>
                                      <pre style={{fontSize:"11px",color:`${C.cream}90`,background:`${C.navy}80`,borderRadius:"6px",padding:"8px",whiteSpace:"pre-wrap",wordBreak:"break-word",maxHeight:"120px",overflowY:"auto",lineHeight:"1.5",margin:0}}>{p.prompt.slice(0,300)}{p.prompt.length>300?"…":""}</pre>
                                      {recModel && <div style={{fontSize:"10px",color:`${C.muted}80`,marginTop:"6px"}}><span style={{color:recModel.pcolor}}>{recModel.plogo}</span> {recModel.name}</div>}
                                    </div>
                                  )}
                                  <div style={{display:"flex",gap:"6px",alignItems:"center"}}>
                                    <button onClick={() => libUse(p)} style={btnS(true,false,{fontSize:"11px",padding:"6px 12px"})}>Utiliser</button>
                                    <button onClick={() => toggleExpand(p.id)} style={{background:"transparent",border:`1px solid ${C.amber}20`,borderRadius:"6px",padding:"5px 8px",cursor:"pointer",color:C.muted,fontSize:"11px"}}>{isExp?"▲ Réduire":"▼ Détails"}</button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );

                        /* ── MODE COMPACT ── */
                        if (libViewMode === "compact") return items.map(p => {
                          const cat = libCatMap[p.category] || {label:"?",icon:"📌",color:C.muted};
                          const recModel = ALL_MODELS.find(m => m.id === p.model);
                          const isExp = !!libExpanded[p.id];
                          return (
                            <div key={p.id} style={{background:C.navyD,border:`1px solid ${C.amber}10`,borderRadius:"8px",padding:isExp?"14px":"8px 14px",marginBottom:"4px",transition:"all 0.2s"}}>
                              <div style={{display:"flex",alignItems:"center",gap:"10px",cursor:"pointer"}} onClick={() => toggleExpand(p.id)}>
                                <span style={{fontSize:"14px"}}>{cat.icon}</span>
                                <span style={{flex:1,fontSize:"13px",fontWeight:"600",color:C.cream}}>{p.title}</span>
                                <div onClick={e => e.stopPropagation()} style={{display:"flex",gap:"2px"}}>
                                  {[1,2,3,4,5].map(n => (
                                    <span key={n} onClick={() => libRate(p.id, (p.rating||0)===n ? 0 : n)} style={{cursor:"pointer",fontSize:"11px",color:n<=(p.rating||0)?"#F39C12":`${C.muted}25`}}>★</span>
                                  ))}
                                </div>
                                {recModel && <span style={{fontSize:"10px",color:`${C.muted}60`}}>{recModel.plogo}</span>}
                                <span style={{fontSize:"10px",color:C.muted}}>{isExp?"▲":"▼"}</span>
                              </div>
                              {isExp && (
                                <div style={{marginTop:"10px",paddingTop:"10px",borderTop:`1px solid ${C.amber}10`}}>
                                  <p style={{fontSize:"12px",color:C.muted,lineHeight:"1.6",marginBottom:"8px"}}>{p.description}</p>
                                  <pre style={{fontSize:"11px",color:`${C.cream}90`,background:`${C.navy}80`,borderRadius:"6px",padding:"8px",whiteSpace:"pre-wrap",wordBreak:"break-word",maxHeight:"150px",overflowY:"auto",lineHeight:"1.5",margin:"0 0 10px"}}>{p.prompt.slice(0,400)}{p.prompt.length>400?"…":""}</pre>
                                  {recModel && <div style={{fontSize:"11px",color:`${C.muted}80`,marginBottom:"8px"}}><span style={{color:recModel.pcolor}}>{recModel.plogo}</span> {recModel.name} ({recModel.platform})</div>}
                                  <div style={{display:"flex",gap:"6px"}} onClick={e => e.stopPropagation()}>
                                    <button onClick={() => libUse(p)} style={btnS(true,false,{fontSize:"11px",padding:"6px 12px"})}>Utiliser</button>
                                    <button title="Modifier" onClick={() => { setLibEditing({...p}); setLibShowEdit(true); }} style={{background:"transparent",border:`1px solid ${C.amber}20`,borderRadius:"6px",padding:"5px 8px",cursor:"pointer",color:C.muted,fontSize:"11px"}}>✏️</button>
                                    <button title="Supprimer" onClick={() => askConfirm(`Supprimer le prompt "${p.title}" ?`, () => libDelete(p.id))} style={{background:"transparent",border:`1px solid ${C.error}25`,borderRadius:"6px",padding:"5px 8px",cursor:"pointer",color:`${C.error}80`,fontSize:"11px"}}>🗑</button>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        });

                        /* ── MODE LISTE DÉTAILLÉE (défaut) ── */
                        return items.map(p => {
                          const cat = libCatMap[p.category] || {label:"?",icon:"📌",color:C.muted};
                          const recModel = ALL_MODELS.find(m => m.id === p.model);
                          const isExp = !!libExpanded[p.id];
                          return (
                            <div key={p.id} style={{background:C.navyD,border:`1px solid ${C.amber}12`,borderRadius:"12px",padding:"16px",marginBottom:"10px",position:"relative",transition:"all 0.2s"}}>
                              <div style={{position:"absolute",top:"10px",right:"10px",display:"flex",gap:"5px"}}>
                                <button title="Modifier" onClick={() => { setLibEditing({...p}); setLibShowEdit(true); }} style={{background:"transparent",border:`1px solid ${C.amber}20`,borderRadius:"6px",padding:"4px 7px",cursor:"pointer",color:C.muted,fontSize:"12px",lineHeight:1}}>✏️</button>
                                <button title="Supprimer" onClick={() => askConfirm(`Supprimer le prompt "${p.title}" ?`, () => libDelete(p.id))} style={{background:"transparent",border:`1px solid ${C.error}25`,borderRadius:"6px",padding:"4px 7px",cursor:"pointer",color:`${C.error}90`,fontSize:"12px",lineHeight:1}}>🗑</button>
                              </div>
                              <div style={{display:"flex",alignItems:"center",gap:"9px",marginBottom:"6px",paddingRight:"60px"}}>
                                <span style={{fontSize:"16px"}}>{cat.icon}</span>
                                <span style={{fontSize:"14px",fontWeight:"700",color:C.cream}}>{p.title}</span>
                                {!p.builtIn && <span style={{background:`${C.amber}12`,color:`${C.amber}90`,borderRadius:"4px",padding:"1px 6px",fontSize:"9px",fontWeight:"700"}}>Perso</span>}
                              </div>
                              <div style={{marginBottom:"6px"}}>
                                {[1,2,3,4,5].map(n => (
                                  <span key={n} onClick={() => libRate(p.id, (p.rating||0)===n ? 0 : n)} style={{cursor:"pointer",fontSize:"14px",color:n<=(p.rating||0)?"#F39C12":`${C.muted}30`,marginRight:"1px"}}>★</span>
                                ))}
                              </div>
                              <p style={{fontSize:"12px",color:C.muted,lineHeight:"1.6",marginBottom:"6px"}}>{p.description}</p>
                              {recModel && <div style={{fontSize:"11px",color:`${C.muted}80`,marginBottom:"8px"}}><span style={{color:recModel.pcolor}}>{recModel.plogo}</span> {recModel.name}</div>}
                              {isExp && (
                                <div style={{marginBottom:"10px",paddingTop:"8px",borderTop:`1px solid ${C.amber}10`}}>
                                  <pre style={{fontSize:"12px",color:`${C.cream}90`,background:`${C.navy}80`,borderRadius:"8px",padding:"12px",whiteSpace:"pre-wrap",wordBreak:"break-word",maxHeight:"200px",overflowY:"auto",lineHeight:"1.6",margin:0}}>{p.prompt}</pre>
                                </div>
                              )}
                              <div style={{display:"flex",gap:"8px",alignItems:"center"}}>
                                <button onClick={() => libUse(p)} style={btnS(true,false,{fontSize:"13px",padding:"8px 18px"})}>Utiliser ce prompt</button>
                                <button onClick={() => toggleExpand(p.id)} style={{background:"transparent",border:`1px solid ${C.amber}20`,borderRadius:"6px",padding:"7px 12px",cursor:"pointer",color:C.muted,fontSize:"12px"}}>{isExp?"▲ Réduire":"▼ Voir le prompt"}</button>
                              </div>
                            </div>
                          );
                        });
                      })()}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* ── Debug panel ── */}
          {showDebug && (
            <div className="po-debug" style={{position:"fixed",bottom:0,left:0,right:0,maxHeight:"220px",overflowY:"auto",background:"#000E",zIndex:200,padding:"10px 16px",fontSize:"11px",fontFamily:"monospace",color:"#0F0",borderTop:`2px solid ${C.error}`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:"8px",position:"sticky",top:0,background:"#000E",paddingBottom:"4px"}}>
                <span style={{fontWeight:"bold",color:"#FF0"}}>DEBUG LOG ({debugLog.length})</span>
                <button onClick={() => setDebugLog([])} style={{background:"transparent",border:"1px solid #555",color:"#999",fontSize:"10px",padding:"2px 10px",cursor:"pointer",borderRadius:"3px"}}>Clear</button>
              </div>
              {debugLog.length === 0 && <div style={{color:"#555"}}>En attente d'appels API…</div>}
              {debugLog.map((l,i) => <div key={i} style={{opacity:i>=debugLog.length-3?1:0.5,lineHeight:"1.6"}}>{l}</div>)}
            </div>
          )}
        </div>
      );
    }

    ReactDOM.createRoot(document.getElementById('root')).render(<App />);
